// import comment from "vue-excel-export";
import store from "../store";

export function totalTable(A = {}) {
  let projectData = store.state.projectData;
  if (!projectData || !projectData.总投资估算) {
    console.error("项目数据或总投资估算数据不存在");
    return;
  }

  let investNode = projectData.总投资估算;

  // 确保总表存在
  if (!investNode.总表) {
    investNode.总表 = {};
  }

  // 确保必要的嵌套对象存在
  const ensureNestedObject = (obj, path) => {
    const keys = path.split(".");
    let current = obj;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (!current[key]) {
        current[key] = {};
      }
      // 检查当前属性是否为对象，如果不是则替换为对象
      if (typeof current[key] !== "object" || current[key] === null) {
        current[key] = {};
      }
      current = current[key];
    }
    return current;
  };

  // 确保数据结构存在 - 对照jjpj.js中的完整结构
  ensureNestedObject(investNode, "总表.建设投资.工程费用");
  ensureNestedObject(investNode, "总表.建设投资.工程建设其他费用");
  ensureNestedObject(investNode, "总表.建设投资.预备费.基本预备费");
  ensureNestedObject(investNode, "总表.建设投资.预备费.涨价预备费");
  ensureNestedObject(investNode, "总表.流动资金");
  ensureNestedObject(investNode, "总表.建设期利息");
  ensureNestedObject(investNode, "总表.总投资");

  // 获取源数据，如果不存在则默认为0
  const 建筑费用合计 = investNode.建筑费用?.合计 || 0;
  const 设备工程购置费合计 = investNode.设备工程?.购置费合计 || 0;
  const 设备工程运输费合计 = investNode.设备工程?.运输费合计 || 0;
  const 设备工程安装费合计 = investNode.设备工程?.安装费合计 || 0;
  const 工程建设其他费用合计 = investNode.工程建设其他费用?.合计 || 0;

  const 流动资金合计 = investNode.总表.流动资金?.其他费用 || 0;
  let 建设期利息合计 = 0;
  if (JSON.stringify(A) == "{}") {
    建设期利息合计 =
      projectData.资金筹措及分年投资计划.资金筹措.债务资金.interest || 0;
  } else {
    建设期利息合计 = A.int;
  }

  // 设置总表中的值
  investNode.总表.建设投资.工程费用.建筑费用 = 建筑费用合计;
  investNode.总表.建设投资.工程费用.设备费用 =
    设备工程购置费合计 + 设备工程运输费合计;
  investNode.总表.建设投资.工程费用.安装费用 = 设备工程安装费合计;
  investNode.总表.建设投资.工程费用.其他费用 =
    investNode.总表.建设投资.工程费用.其他费用 || 0;
  investNode.总表.建设投资.工程建设其他费用.其他费用 = 工程建设其他费用合计;

  // 计算工程费用合计
  investNode.总表.建设投资.工程费用.合计 =
    investNode.总表.建设投资.工程费用.建筑费用 +
    investNode.总表.建设投资.工程费用.设备费用 +
    investNode.总表.建设投资.工程费用.安装费用 +
    investNode.总表.建设投资.工程费用.其他费用;

  // 工程建设其他费用各项初始化
  investNode.总表.建设投资.工程建设其他费用.建筑费用 =
    investNode.总表.建设投资.工程建设其他费用.建筑费用 || 0;
  investNode.总表.建设投资.工程建设其他费用.设备费用 =
    investNode.总表.建设投资.工程建设其他费用.设备费用 || 0;
  investNode.总表.建设投资.工程建设其他费用.安装费用 =
    investNode.总表.建设投资.工程建设其他费用.安装费用 || 0;
  investNode.总表.建设投资.工程建设其他费用.其他费用 = 工程建设其他费用合计;
  investNode.总表.建设投资.工程建设其他费用.合计 = 工程建设其他费用合计;

  // 基本预备费各项初始化
  const 基本预备费率 = investNode.总表.基本预备费率 || 0;
  const 工程费用合计 = investNode.总表.建设投资.工程费用.合计 || 0;
  const 工程建设其他费用合计Value =
    investNode.总表.建设投资.工程建设其他费用.合计 || 0;
  investNode.总表.建设投资.预备费.基本预备费.建筑费用 =
    investNode.总表.建设投资.预备费.基本预备费.建筑费用 || 0;
  investNode.总表.建设投资.预备费.基本预备费.设备费用 =
    investNode.总表.建设投资.预备费.基本预备费.设备费用 || 0;
  investNode.总表.建设投资.预备费.基本预备费.安装费用 =
    investNode.总表.建设投资.预备费.基本预备费.安装费用 || 0;
  investNode.总表.建设投资.预备费.基本预备费.其他费用 =
    (基本预备费率 * (工程费用合计 + 工程建设其他费用合计Value)) / 100;
  investNode.总表.建设投资.预备费.基本预备费.合计 =
    investNode.总表.建设投资.预备费.基本预备费.其他费用;

  // 涨价预备费各项初始化
  const 涨价预备费率 = investNode.总表.涨价预备费率 || 0;
  investNode.总表.建设投资.预备费.涨价预备费.建筑费用 =
    investNode.总表.建设投资.预备费.涨价预备费.建筑费用 || 0;
  investNode.总表.建设投资.预备费.涨价预备费.设备费用 =
    investNode.总表.建设投资.预备费.涨价预备费.设备费用 || 0;
  investNode.总表.建设投资.预备费.涨价预备费.安装费用 =
    investNode.总表.建设投资.预备费.涨价预备费.安装费用 || 0;
  investNode.总表.建设投资.预备费.涨价预备费.其他费用 =
    (涨价预备费率 * (工程费用合计 + 工程建设其他费用合计Value)) / 100;
  investNode.总表.建设投资.预备费.涨价预备费.合计 =
    investNode.总表.建设投资.预备费.涨价预备费.其他费用;

  // 预备费各项初始化
  investNode.总表.建设投资.预备费.建筑费用 =
    investNode.总表.建设投资.预备费.建筑费用 || 0;
  investNode.总表.建设投资.预备费.设备费用 =
    investNode.总表.建设投资.预备费.设备费用 || 0;
  investNode.总表.建设投资.预备费.安装费用 =
    investNode.总表.建设投资.预备费.安装费用 || 0;
  investNode.总表.建设投资.预备费.其他费用 =
    investNode.总表.建设投资.预备费.基本预备费.其他费用 +
    investNode.总表.建设投资.预备费.涨价预备费.其他费用;
  investNode.总表.建设投资.预备费.合计 =
    investNode.总表.建设投资.预备费.其他费用;

  // 建设投资各项费用
  investNode.总表.建设投资.建筑费用 =
    investNode.总表.建设投资.工程费用.建筑费用;
  investNode.总表.建设投资.设备费用 =
    investNode.总表.建设投资.工程费用.设备费用;
  investNode.总表.建设投资.安装费用 =
    investNode.总表.建设投资.工程费用.安装费用;
  investNode.总表.建设投资.其他费用 =
    investNode.总表.建设投资.工程费用.其他费用 +
    investNode.总表.建设投资.工程建设其他费用.其他费用 +
    investNode.总表.建设投资.预备费.其他费用;
  investNode.总表.建设投资.合计 =
    investNode.总表.建设投资.工程费用.合计 +
    investNode.总表.建设投资.工程建设其他费用.合计 +
    investNode.总表.建设投资.预备费.合计;

  // 流动资金各项初始化
  investNode.总表.流动资金.建筑费用 = 0;
  investNode.总表.流动资金.设备费用 = 0;
  investNode.总表.流动资金.安装费用 = 0;
  // investNode.总表.流动资金.其他费用 = 流动资金合计;
  investNode.总表.流动资金.合计 = 流动资金合计;
  // 建设期利息各项初始化
  investNode.总表.建设期利息.建筑费用 =
    investNode.总表.建设期利息.建筑费用 || 0;
  investNode.总表.建设期利息.设备费用 =
    investNode.总表.建设期利息.设备费用 || 0;
  investNode.总表.建设期利息.安装费用 =
    investNode.总表.建设期利息.安装费用 || 0;
  investNode.总表.建设期利息.合计 = 建设期利息合计;
  investNode.总表.建设期利息.其他费用 = 建设期利息合计;

  // 总投资计算
  investNode.总表.总投资.建筑费用 =
    investNode.总表.建设投资.建筑费用 +
    investNode.总表.流动资金.建筑费用 +
    investNode.总表.建设期利息.建筑费用;
  investNode.总表.总投资.设备费用 =
    investNode.总表.建设投资.设备费用 +
    investNode.总表.流动资金.设备费用 +
    investNode.总表.建设期利息.设备费用;
  investNode.总表.总投资.安装费用 =
    investNode.总表.建设投资.安装费用 +
    investNode.总表.流动资金.安装费用 +
    investNode.总表.建设期利息.安装费用;
  investNode.总表.总投资.其他费用 =
    investNode.总表.建设投资.其他费用 +
    investNode.总表.流动资金.其他费用 +
    investNode.总表.建设期利息.其他费用;
  investNode.总表.总投资.合计 =
    investNode.总表.建设投资.合计 +
    investNode.总表.流动资金.合计 +
    investNode.总表.建设期利息.合计;

  // 计算比例，防止除以0
  const 总投资合计 = investNode.总表.总投资.合计 || 1; // 使用1避免除以0
  if (总投资合计 !== 0) {
    // 工程费用比例
    investNode.总表.建设投资.工程费用.比例 =
      (investNode.总表.建设投资.工程费用.合计 || 0) / 总投资合计;
    // 注意：这里不设置 investNode.总表.建设投资.工程费用.建筑费用.比例 等，因为建筑费用是数字

    // 工程建设其他费用比例
    investNode.总表.建设投资.工程建设其他费用.比例 =
      (investNode.总表.建设投资.工程建设其他费用.合计 || 0) / 总投资合计;

    // 预备费比例
    investNode.总表.建设投资.预备费.比例 =
      (investNode.总表.建设投资.预备费.合计 || 0) / 总投资合计;

    // 基本预备费比例
    investNode.总表.建设投资.预备费.基本预备费.比例 =
      (investNode.总表.建设投资.预备费.基本预备费.合计 || 0) / 总投资合计;

    // 涨价预备费比例
    investNode.总表.建设投资.预备费.涨价预备费.比例 =
      (investNode.总表.建设投资.预备费.涨价预备费.合计 || 0) / 总投资合计;

    // 流动资金比例
    investNode.总表.流动资金.比例 =
      (investNode.总表.流动资金.合计 || 0) / 总投资合计;

    // 建设期利息比例
    investNode.总表.建设期利息.比例 =
      (investNode.总表.建设期利息.合计 || 0) / 总投资合计;

    // 建设投资比例
    investNode.总表.建设投资.比例 =
      (investNode.总表.建设投资.合计 || 0) / 总投资合计;
  } else {
    // 如果总投资为0，将比例设为0
    investNode.总表.建设投资.工程费用.比例 = 0;
    investNode.总表.建设投资.工程建设其他费用.比例 = 0;
    investNode.总表.建设投资.预备费.比例 = 0;
    investNode.总表.流动资金.比例 = 0;
    investNode.总表.建设期利息.比例 = 0;
    investNode.总表.建设投资.基本预备费.比例 = 0;
    investNode.总表.建设投资.涨价预备费.比例 = 0;
    investNode.总表.建设投资.比例 = 0;
  }

  investNode.总表.总投资.比例 = 1.0;

  projectData.总投资估算 = investNode;

  store.commit("SET_PROJECT_DATA", projectData);

  // return projectData

  callplan(1);

  if (JSON.stringify(A) !== "{}") {
    return investNode.总表.总投资.合计;
  } else {
    projectData.总投资估算 = investNode;
    // console.log("来没来");

    return projectData;
  }
}

export function callplan(a) {
  let projectData = store.state.projectData;

  if (a === 0) {
    calculateAnnualInvestment();
  } else {
    let ztz = projectData.总投资估算.总表.总投资.合计;
    let jhzt = JSON.parse(
      JSON.stringify(
        projectData.资金筹措及分年投资计划?.分年投资计划?.总投资?.amount || 0,
      ),
    );
    if (jhzt === 0) {
      calculateAnnualInvestment();
    } else {
      let bili = Math.abs(jhzt - ztz) / jhzt;
      if (bili > 0.1) {
        calculateAnnualInvestment();
      } else {
        calculateAnnualInvestment("ok");
      }
    }
  }
}

//成本方面
//1.原辅材料采购__成本第一步
export function jingying() {
  let projectData = store.state.projectData;

  // 检查数据结构是否完整
  if (
    !projectData ||
    !projectData["基础数据"] ||
    !projectData["成本费用"] ||
    !projectData["成本费用"]["原辅材料"]
  ) {
    console.warn("数据结构不完整，无法执行燃料动力计算");
    return;
  }

  var jichu = projectData.基础数据;
  var yuanfu = projectData.成本费用.原辅材料;

  // 验证必要数据是否存在
  if (!jichu || !yuanfu) {
    console.warn("基础数据或原辅材料数据不存在");
    return;
  }

  // 确保各个数据对象存在
  if (!yuanfu.materials) {
    yuanfu.materials = { materialslist: [], year: [], tax: [] };
  }
  if (!yuanfu.auxiliary) {
    yuanfu.auxiliary = { taxRate: 0.17, unitPrice: 0, year: [], tax: [] };
  }
  if (!yuanfu.other) {
    yuanfu.other = { taxRate: 0.17, unitPrice: 0, year: [], tax: [] };
  }
  if (!yuanfu.total) {
    yuanfu.total = { year: [], tax: [] };
  }

  let 原料 = yuanfu.materials;
  let 辅料 = yuanfu.auxiliary;
  let 其他 = yuanfu.other;
  let 合计 = yuanfu.total;

  let loadDataKeys = Object.keys(jichu.loadData);
  let 原料ARR = [];
  let 税收ARR = [];
  let 耗量ARR = [];
  let yuanliaototal = [];
  let yuanliaoshiut = [];
  let luanlnub = 0;
  let 原料总价 = 0;
  let 税总价 = 0;
  let 耗量总价 = 0;
  原料.total = 0;

  // 验证 materialslist 是否存在且为数组
  if (原料.materialslist && Array.isArray(原料.materialslist)) {
    原料.materialslist.forEach((item) => {
      原料ARR = [];
      税收ARR = [];
      耗量ARR = [];
      原料总价 = 0;
      税总价 = 0;
      耗量总价 = 0;

      // 遍历 loadData 中的所有年份数据
      for (let i = 0; i < loadDataKeys.length; i++) {
        const yearKey = loadDataKeys[i];
        const loadValue = jichu.loadData[yearKey] || 0;

        let yearliang = (loadValue * (item.quantity || 0)) / 100;
        let year = (yearliang * (item.unitPrice || 0)) / 10000;

        // 确保数组足够长
        if (yuanliaototal.length <= i) {
          yuanliaototal.push(0);
        }
        if (yuanliaoshiut.length <= i) {
          yuanliaoshiut.push(0);
        }

        yuanliaototal[i] += year;
        let yaershui = year - year / (1 + (item.taxRate || 0.17));
        原料总价 += year;
        税总价 += yaershui;
        耗量总价 += yearliang;
        yuanliaoshiut[i] += yaershui;
        原料ARR.push(year);
        税收ARR.push(yaershui);
        耗量ARR.push(yearliang);
      }

      luanlnub++;
      // 避免重复设置 ID
      item.sequence = `1.${luanlnub}`;
      if (!item.id) {
        item.id = Date.now() + luanlnub;
      }
      item.consumption = 耗量ARR;
      item.year = 原料ARR; // 修正：使用 years 属性
      item.tax = 税收ARR;
      item.total = 原料总价;
      item.taxTotal = 税总价;
      item.consumptionTotal = 耗量总价;
      原料.total += 原料总价;
    });
  }

  原料.tax = yuanliaoshiut;
  原料.year = yuanliaototal; // 将计算结果存储到 year 属性
  // 原料.total = 原料总价;

  // 计算辅助材料
  辅料.total = 0;
  辅料.taxTotal = 0;

  for (let i = 0; i < loadDataKeys.length; i++) {
    const yearKey = loadDataKeys[i];
    const loadValue = jichu.loadData[yearKey] || 0;

    let yearliang = (loadValue * (辅料.Amount || 0)) / 100;
    let yaershui = yearliang - yearliang / (1 + (辅料.taxRate || 0.17));

    // 确保数组足够长
    if (辅料.year.length <= i) 辅料.year.push(0);
    if (辅料.tax.length <= i) 辅料.tax.push(0);

    辅料.total += yearliang;
    辅料.taxTotal += yaershui;

    辅料.year[i] = yearliang;
    辅料.tax[i] = yaershui;
  }

  // 计算其他材料
  其他.total = 0;
  其他.taxTotal = 0;

  for (let i = 0; i < loadDataKeys.length; i++) {
    const yearKey = loadDataKeys[i];
    const loadValue = jichu.loadData[yearKey] || 0;

    let yearliang = (loadValue * (其他.Amount || 0)) / 100;
    let yaershui = yearliang - yearliang / (1 + (其他.taxRate || 0.17));

    // 确保数组足够长
    if (其他.year.length <= i) 其他.year.push(0);
    if (其他.tax.length <= i) 其他.tax.push(0);
    其他.total += yearliang;
    其他.taxTotal += yaershui;

    其他.year[i] = yearliang;
    其他.tax[i] = yaershui;
  }

  // 计算总计
  合计.total = 0;
  合计.taxTotal = 0;
  for (let i = 0; i < loadDataKeys.length; i++) {
    // 确保数组足够长
    if (合计.year.length <= i) 合计.year.push(0);
    if (合计.tax.length <= i) 合计.tax.push(0);

    let yearliang =
      (原料.year[i] || 0) + (辅料.year[i] || 0) + (其他.year[i] || 0);
    let yaershui = (原料.tax[i] || 0) + (辅料.tax[i] || 0) + (其他.tax[i] || 0);
    合计.year[i] = yearliang;
    合计.tax[i] = yaershui;
  }
  // 一次性计算总计，避免循环内累加
  for (let i = 0; i < 合计.year.length; i++) {
    合计.total += 合计.year[i] || 0;
    合计.taxTotal += 合计.tax[i] || 0;
  }

  // 更新数据到 store
  yuanfu.materials = 原料;
  yuanfu.auxiliary = 辅料;
  yuanfu.other = 其他;
  yuanfu.total = 合计;

  projectData.成本费用.原辅材料 = yuanfu;

  store.commit("SET_PROJECT_DATA", projectData);
  totalCost();
}

//2.燃料动力__成本第二步
export function ranliao() {
  let projectData = store.state.projectData;

  // 检查数据结构是否完整
  if (
    !projectData ||
    !projectData["基础数据"] ||
    !projectData["成本费用"] ||
    !projectData["成本费用"]["燃料动力"]
  ) {
    console.warn("数据结构不完整，无法执行燃料动力计算");
    return;
  }

  var jichu = projectData.基础数据;
  var rldl = projectData.成本费用.燃料动力;

  // 验证必要数据是否存在
  if (!jichu || !rldl) {
    console.warn("基础数据或燃料动力数据不存在");
    return;
  }

  // 确保各个数据对象存在
  if (!rldl.fuelpower) {
    rldl.fuelpower = {
      fuelpower: [],
      total: { total: 0, taxTotal: 0, year: [], tax: [] },
    };
  }
  if (!rldl.total) {
    rldl.total = { total: 0, taxTotal: 0, year: [], tax: [] };
  }

  let 燃料动力 = rldl.fuelpower;

  // 验证 loadData 是否存在
  if (!jichu.loadData) {
    console.warn("loadData 不存在");
    return;
  }

  let loadDataKeys = Object.keys(jichu.loadData);
  let 燃料ARR = [];
  let 税收ARR = [];
  let 耗量ARR = [];

  let rltotal = [];
  let rltaxtotal = [];
  let rlz = 0;
  let rtz = 0;

  // 验证 fuelpower 是否存在且为数组
  if (rldl.fuelpower && Array.isArray(rldl.fuelpower)) {
    rldl.fuelpower.forEach((item) => {
      燃料ARR = [];
      税收ARR = [];
      耗量ARR = [];
      let 燃料总价 = 0;
      let 税总价 = 0;
      let 耗量总价 = 0;

      // 遍历 loadData 中的所有年份数据
      for (let i = 0; i < loadDataKeys.length; i++) {
        const yearKey = loadDataKeys[i];
        const loadValue = jichu.loadData[yearKey] || 0;

        let yearliang = (loadValue * (item.quantity || 0)) / 100;
        let year = (yearliang * (item.unitPrice || 0)) / 10000;

        // 确保数组足够长
        if (rltotal.length <= i) {
          rltotal.push(0);
        }
        if (rltaxtotal.length <= i) {
          rltaxtotal.push(0);
        }

        rltotal[i] += year;
        let yaershui = year - year / (1 + (item.taxRate || 0.17));
        rltaxtotal[i] += yaershui;
        燃料总价 += year;
        税总价 += yaershui;
        耗量总价 += yearliang;

        燃料ARR.push(year);
        税收ARR.push(yaershui);
        耗量ARR.push(yearliang);

        rlz += year;
        rtz += yaershui;
      }
      item.consumption = 耗量ARR;
      item.year = 燃料ARR;
      item.tax = 税收ARR;
      item.total = 燃料总价;
      item.taxTotal = 税总价;
      item.consumptionTotal = 耗量总价;
    });
  }

  // 修正：正确设置 total 属性
  // 正确设置 total 属性
  // 先清空之前的累计值，重新计算
  rlz = 0;
  rtz = 0;
  for (let i = 0; i < rltotal.length; i++) {
    rlz += rltotal[i] || 0;
    rtz += rltaxtotal[i] || 0;
  }

  rldl.total = {
    year: rltotal,
    tax: rltaxtotal,
    total: rlz,
    taxTotal: rtz,
  };

  // 确保燃料动力数据正确设置
  rldl.fuelpower = 燃料动力;

  projectData.成本费用.燃料动力 = rldl;
  store.commit("SET_PROJECT_DATA", projectData);
  totalCost();
}

// 在 utils/comp.js 文件中的 gzfl 函数
// 在 utils/comp.js 文件中的 gzfl 函数
// 在 utils/comp.js 文件中的 gzfl 函数
export function gzfl() {
  let projectData = store.state.projectData;

  // 检查数据结构是否完整
  if (
    !projectData ||
    !projectData["基础数据"] ||
    !projectData["成本费用"] ||
    !projectData["成本费用"]["职工薪酬"]
  ) {
    console.warn("数据结构不完整，无法执行职工薪酬计算");
    return;
  }

  var jichu = projectData.基础数据;
  var welfare = projectData.成本费用.职工薪酬;

  // 验证必要数据是否存在
  if (!jichu || !welfare) {
    console.warn("基础数据或职工薪酬数据不存在");
    return;
  }

  // 确保各个数据对象存在
  if (!welfare.welfareList) {
    welfare.welfareList = [];
  }
  if (!welfare.total) {
    welfare.total = {
      total: 0,
      salaryTotal: 0,
      avgSalaryTotal: 0,
      welfareTotal: 0,
      year: [],
      salaryYear: [],
      avgSalaryYear: [],
      welfareYear: [],
    };
  }

  // 验证 loadData 是否存在
  if (!jichu.loadData) {
    console.warn("loadData 不存在");
    return;
  }

  let loadDataKeys = Object.keys(jichu.loadData);
  let yearCount = loadDataKeys.length;

  // 初始化总计数组
  let totalYear = new Array(yearCount).fill(0);
  let salaryYearTotal = new Array(yearCount).fill(0);
  let avgSalaryYearTotal = new Array(yearCount).fill(0);
  let welfareYearTotal = new Array(yearCount).fill(0);
  let total = 0;
  let salaryTotal = 0;
  let avgSalaryTotal = 0;
  let welfareTotal = 0;

  // 计算每个工种的数据
  welfare.welfareList.forEach((item) => {
    let salaryYear = [];
    let avgSalaryYear = []; // 人均年工资数组
    let welfareYear = [];
    let year = [];
    let itemSalaryTotal = 0;
    let itemAvgSalaryTotal = 0;
    let itemWelfareTotal = 0;
    let itemTotal = 0;

    // 遍历 loadData 中的所有年份数据
    for (let i = 0; i < loadDataKeys.length; i++) {
      const yearKey = loadDataKeys[i];
      const loadValue = jichu.loadData[yearKey] || 0;

      // 计算第i年的人均年工资（考虑增长率）
      let annualAvgSalary = item.Base * Math.pow(1 + item.growth / 100, i);

      // 根据运营负荷调整人均年工资 - 现在改为有负荷年份全额计算
      let adjustedAnnualAvgSalary = loadValue > 0 ? annualAvgSalary : 0;

      let totalAnnualSalary = loadValue > 0 ? annualAvgSalary * item.people : 0;

      // 计算当年福利费
      let annualWelfare = totalAnnualSalary * item.rate;

      // 计算当年总费用（工资+福利）
      let annualTotal = totalAnnualSalary + annualWelfare;

      // 累计到年度数组
      salaryYear.push(totalAnnualSalary);
      avgSalaryYear.push(adjustedAnnualAvgSalary); // 人均年工资
      welfareYear.push(annualWelfare);
      year.push(annualTotal);

      // 累计到总计
      itemSalaryTotal += totalAnnualSalary;
      itemAvgSalaryTotal += adjustedAnnualAvgSalary;
      itemWelfareTotal += annualWelfare;
      itemTotal += annualTotal;
    }

    // 更新单项数据
    item.salaryYear = salaryYear;
    item.gz = avgSalaryYear; // 人均年工资数组
    item.welfareYear = welfareYear;
    item.year = year;
    item.salaryTotal = itemSalaryTotal;
    item.avgSalaryTotal = itemAvgSalaryTotal;
    item.welfareTotal = itemWelfareTotal;
    item.total = itemTotal;

    // 累加到总计
    for (let i = 0; i < year.length; i++) {
      if (i < totalYear.length) {
        totalYear[i] += year[i];
        salaryYearTotal[i] += salaryYear[i];
        avgSalaryYearTotal[i] += avgSalaryYear[i];
        welfareYearTotal[i] += welfareYear[i];
      }
    }

    salaryTotal += itemSalaryTotal;
    avgSalaryTotal += itemAvgSalaryTotal;
    welfareTotal += itemWelfareTotal;
    total += itemTotal;
  });

  // 更新总计数据
  // 先清空之前的累计值，重新计算
  let finalTotal = 0;
  let finalSalaryTotal = 0;
  let finalAvgSalaryTotal = 0;
  let finalWelfareTotal = 0;

  for (let i = 0; i < totalYear.length; i++) {
    finalTotal += totalYear[i] || 0;
    finalSalaryTotal += salaryYearTotal[i] || 0;
    finalAvgSalaryTotal += avgSalaryYearTotal[i] || 0;
    finalWelfareTotal += welfareYearTotal[i] || 0;
  }

  welfare.total = {
    total: finalTotal,
    salaryTotal: finalSalaryTotal,
    avgSalaryTotal: finalAvgSalaryTotal,
    welfareTotal: finalWelfareTotal,
    year: totalYear,
    salaryYear: salaryYearTotal,
    avgSalaryYear: avgSalaryYearTotal,
    welfareYear: welfareYearTotal,
  };

  // 更新store
  projectData.成本费用.职工薪酬 = welfare;
  store.commit("SET_PROJECT_DATA", projectData);
  totalCost();
}
// 在 utils/comp.js 中添加折旧计算函数

export function deprecia() {
  let projectData = store.state.projectData;

  // 检查数据结构是否完整
  if (!projectData || !projectData["基础数据"] || !projectData["成本费用"]) {
    console.warn("数据结构不完整，无法执行折旧计算");
    return;
  }

  var jichu = projectData["基础数据"];

  // 检查计算周期和建设期是否有效
  if (!jichu.calculationPeriod || !jichu.constructionPeriod) {
    console.warn("基础数据不完整，缺少计算周期或建设期信息");
    return;
  }

  let zj = projectData["成本费用"]["折旧"] || {};

  // —— categories 兜底
  zj.categories = zj.categories || {};

  zj.categories["房屋及建构筑物"] = zj.categories["房屋及建构筑物"] || {
    originalValue: 0,
    depreciationYears: 20,
    salvageRate: 5,
    depreciationTotal: 0,
    NAVatEOP: 0,
    originalValues: [],
    depreciationValues: [],
    currentValues: [],
  };

  zj.categories["设备"] = zj.categories["设备"] || {
    originalValue: 0,
    depreciationYears: 10,
    salvageRate: 0,
    depreciationTotal: 0,
    NAVatEOP: 0,
    originalValues: [],
    depreciationValues: [],
    currentValues: [],
  };

  // —— total 兜底
  zj.total = zj.total || {
    depreciationTotal: 0,
    NAVatEOP: 0,
    originalValues: [],
    depreciationValues: [],
    currentValues: [],
  };

  let fj = zj.categories["房屋及建构筑物"];
  let sb = zj.categories["设备"];
  let total = zj.total;

  // 获取原值数据
  fj.originalValue = projectData["总投资估算"]?.["建筑费用"]?.["合计"] || 0;
  sb.originalValue = projectData["总投资估算"]?.["设备工程"]?.["合计"] || 0;
  fj.originalValues = [];
  fj.depreciationValues = [];
  fj.currentValues = [];
  sb.originalValues = [];
  sb.depreciationValues = [];
  sb.currentValues = [];
  total.originalValues = [];
  total.depreciationValues = [];
  total.currentValues = [];

  // 初始化数组
  for (let i = 0; i < jichu.calculationPeriod; i++) {
    if (i < jichu.constructionPeriod) {
      fj.originalValues[i] = 0;
      fj.depreciationValues[i] = 0;
      fj.currentValues[i] = 0;
      sb.originalValues[i] = 0;
      sb.depreciationValues[i] = 0;
      sb.currentValues[i] = 0;
      total.originalValues[i] = 0;
      total.depreciationValues[i] = 0;
      total.currentValues[i] = 0;
    } else {
      fj.originalValues[i] = fj.originalValue;
      sb.originalValues[i] = sb.originalValue;

      // 计算折旧
      if (i < jichu.constructionPeriod + fj.depreciationYears) {
        fj.depreciationValues[i] =
          (fj.originalValue * (1 - fj.salvageRate / 100)) /
          fj.depreciationYears;
      } else {
        fj.depreciationValues[i] = 0;
      }

      if (i < jichu.constructionPeriod + sb.depreciationYears) {
        sb.depreciationValues[i] =
          (sb.originalValue * (1 - sb.salvageRate / 100)) /
          sb.depreciationYears;
      } else {
        sb.depreciationValues[i] = 0;
      }

      // 计算净值
      if (i === jichu.constructionPeriod) {
        fj.currentValues[i] = fj.originalValue - fj.depreciationValues[i];
        sb.currentValues[i] = sb.originalValue - sb.depreciationValues[i];
      } else {
        fj.currentValues[i] = Math.max(
          fj.currentValues[i - 1] - fj.depreciationValues[i],
          fj.originalValue * (fj.salvageRate / 100),
        );
        sb.currentValues[i] = Math.max(
          sb.currentValues[i - 1] - sb.depreciationValues[i],
          sb.originalValue * (sb.salvageRate / 100),
        );
      }

      // 计算合计值
      total.originalValues[i] = fj.originalValues[i] + sb.originalValues[i];
      total.depreciationValues[i] =
        fj.depreciationValues[i] + sb.depreciationValues[i];
      total.currentValues[i] = fj.currentValues[i] + sb.currentValues[i];
    }
  }

  // 统计折旧合计和期末净值
  total.depreciationTotal = 0;
  fj.depreciationTotal = 0;
  sb.depreciationTotal = 0;

  for (let i = 0; i < jichu.calculationPeriod; i++) {
    total.depreciationTotal += total.depreciationValues[i];
    fj.depreciationTotal += fj.depreciationValues[i];
    sb.depreciationTotal += sb.depreciationValues[i];
  }

  // 设置期末净值
  total.NAVatEOP = total.currentValues[jichu.calculationPeriod - 1];
  sb.NAVatEOP = sb.currentValues[jichu.calculationPeriod - 1];
  fj.NAVatEOP = fj.currentValues[jichu.calculationPeriod - 1];

  zj.total = total;
  zj.categories["房屋及建构筑物"] = fj;
  zj.categories["设备"] = sb;

  // 只在循环结束后提交一次
  projectData["成本费用"]["折旧"] = zj;
  store.commit("SET_PROJECT_DATA", projectData);
  totalCost();
}
// 在 comp.js 文件中添加摊销计算函数
export function amortization() {
  let projectData = store.state.projectData;

  // 检查数据结构是否完整
  if (!projectData || !projectData["基础数据"] || !projectData["成本费用"]) {
    console.warn("数据结构不完整，无法执行摊销计算");
    return;
  }

  var jichu = projectData["基础数据"];

  // 检查计算周期和建设期是否有效
  if (!jichu.calculationPeriod || !jichu.constructionPeriod) {
    console.warn("基础数据不完整，缺少计算周期或建设期信息");
    return;
  }

  let am = projectData["成本费用"]["摊销"] || {};

  // 初始化摊销数据结构
  am.items = am.items || {};

  // 确保无形资产数据结构完整
  if (!am.items["无形资产"]) {
    am.items["无形资产"] = {
      originalValue: 0, // 原值
      amortizationYears: 10, // 摊销年限
      amortizationTotal: 0, // 摊销合计
      originalValues: [], // 原值分年数组
      amortizationValues: [], // 摊销分年数组
    };
  }

  // 确保其他资产数据结构完整
  if (!am.items["其他资产"]) {
    am.items["其他资产"] = {
      originalValue: 0, // 原值
      amortizationYears: 5, // 摊销年限
      amortizationTotal: 0, // 摊销合计
      originalValues: [], // 原值分年数组
      amortizationValues: [], // 摊销分年数组
    };
  }

  // 初始化总计数据
  if (!am.total) {
    am.total = {
      amortizationTotal: 0, // 摊销总合计
      originalValues: [], // 总原值分年数组
      amortizationValues: [], // 总摊销分年数组
    };
  }

  let wxzc = am.items["无形资产"];
  let qtzc = am.items["其他资产"];
  let total = am.total;

  // 获取原值数据 - 从总投资估算中获取
  const otherConstructionCosts =
    projectData["总投资估算"]?.["工程建设其他费用"] || {};
  const otherConstructionData = otherConstructionCosts.data || {};

  // 计算无形资产原值
  const intangibleAssets = otherConstructionData["无形资产"] || [];
  wxzc.originalValue = intangibleAssets.reduce(
    (sum, item) => sum + (item.amount || 0),
    0,
  );

  // 计算其他资产原值
  const otherAssets = otherConstructionData["其他资产"] || [];
  qtzc.originalValue = otherAssets.reduce(
    (sum, item) => sum + (item.amount || 0),
    0,
  );

  // 初始化数组，确保数组有足够的长度
  wxzc.originalValues = Array(jichu.calculationPeriod).fill(0);
  wxzc.amortizationValues = Array(jichu.calculationPeriod).fill(0);
  qtzc.originalValues = Array(jichu.calculationPeriod).fill(0);
  qtzc.amortizationValues = Array(jichu.calculationPeriod).fill(0);
  total.originalValues = Array(jichu.calculationPeriod).fill(0);
  total.amortizationValues = Array(jichu.calculationPeriod).fill(0);

  // 计算各年度数据
  for (let i = 0; i < jichu.calculationPeriod; i++) {
    if (i < jichu.constructionPeriod) {
      // 建设期原值为0，摊销也为0
      wxzc.originalValues[i] = 0;
      wxzc.amortizationValues[i] = 0;
      qtzc.originalValues[i] = 0;
      qtzc.amortizationValues[i] = 0;
      total.originalValues[i] = 0;
      total.amortizationValues[i] = 0;
    } else {
      // 运营期开始，原值为初始值
      wxzc.originalValues[i] = wxzc.originalValue;
      qtzc.originalValues[i] = qtzc.originalValue;

      // 计算摊销
      // 无形资产摊销
      if (i < jichu.constructionPeriod + wxzc.amortizationYears) {
        wxzc.amortizationValues[i] =
          wxzc.originalValue / wxzc.amortizationYears;
      } else {
        wxzc.amortizationValues[i] = 0;
      }

      // 其他资产摊销
      if (i < jichu.constructionPeriod + qtzc.amortizationYears) {
        qtzc.amortizationValues[i] =
          qtzc.originalValue / qtzc.amortizationYears;
      } else {
        qtzc.amortizationValues[i] = 0;
      }

      // 计算合计值
      total.originalValues[i] = wxzc.originalValues[i] + qtzc.originalValues[i];
      total.amortizationValues[i] =
        wxzc.amortizationValues[i] + qtzc.amortizationValues[i];
    }
  }

  // 统计摊销合计
  total.amortizationTotal = 0;
  wxzc.amortizationTotal = 0;
  qtzc.amortizationTotal = 0;

  for (let i = 0; i < jichu.calculationPeriod; i++) {
    total.amortizationTotal += total.amortizationValues[i];
    wxzc.amortizationTotal += wxzc.amortizationValues[i];
    qtzc.amortizationTotal += qtzc.amortizationValues[i];
  }

  // 更新数据结构
  am.items["无形资产"] = wxzc;
  am.items["其他资产"] = qtzc;
  am.total = total;

  // 只在循环结束后提交一次
  projectData["成本费用"]["摊销"] = am;
  store.commit("SET_PROJECT_DATA", projectData);
}
// 在 utils/comp.js 文件中添加总成本费用计算函数
export function calculateTotalCost() {
  // 从 store 获取数据
  const projectData = store.state.projectData || {};
  const basicData = projectData["基础数据"] || {};
  const costData = projectData["成本费用"] || {};

  // 获取输入参数
  const repairRate = costData.repaircost || 0;
  const otherCost = costData.othercost || 0;

  // 获取基础数据
  const calculationPeriod = basicData?.calculationPeriod || 12;
  const constructionPeriod = basicData?.constructionPeriod || 1;
  const operationPeriod = basicData?.operationPeriod || 14;

  // 获取各成本费用数据
  const rawMaterialTotal = costData?.["原辅材料"]?.["total"]?.total || 0;
  const rawMaterialYear =
    costData?.["原辅材料"]?.["total"]?.year || Array(calculationPeriod).fill(0);

  const fuelPowerTotal = costData?.["燃料动力"]?.["total"]?.total || 0;
  const fuelPowerYear =
    costData?.["燃料动力"]?.["total"]?.["year"] ||
    Array(calculationPeriod).fill(0);

  const wagesBenefitsTotal = costData?.["职工薪酬"]?.["total"]?.total || 0;
  const wagesBenefitsYear =
    costData?.["职工薪酬"]?.["total"]?.year || Array(calculationPeriod).fill(0);

  const depreciationTotal =
    costData?.["折旧"]?.["total"]?.depreciationTotal || 0;
  const depreciationYear =
    costData?.["折旧"]?.["total"]?.depreciationValues ||
    Array(calculationPeriod).fill(0);

  const amortizationTotal =
    costData?.["摊销"]?.["total"]?.amortizationTotal || 0;
  const amortizationYear =
    costData?.["摊销"]?.["total"]?.amortizationValues ||
    Array(calculationPeriod).fill(0);

  // 获取负荷数据（用于计算运营期其他费用）
  const loadData = basicData?.loadData || {};
  const loadKeys = Object.keys(loadData).sort(
    (a, b) => parseInt(a) - parseInt(b),
  );

  // 计算修理费（从经营期第一年开始）
  const repairYear = [];
  let repairTotal = 0;

  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    // 建设期分年投资
    if (i < constructionPeriod) {
      // 建设期修理费为0
      repairYear[i] = 0;
    } else {
      // 经营期修理费 = 年总折旧 * 年修理费率
      repairYear[i] = (depreciationYear[i] * repairRate) / 100;
    }
    repairTotal += repairYear[i];
  }

  // console.log("修理费：", repairYear);

  // 计算其他费用（从计算期第1年开始，根据负荷计算）
  const otherYear = [];
  let otherTotal = 0;

  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    // 其他费用 = 其他费用 * 负荷（从计算期第1年开始）
    const yearKey = loadKeys[i];
    const loadValue = loadData[yearKey] || 0;
    otherYear[i] = otherCost * (loadValue / 100);
    otherTotal += otherYear[i];
  }

  // 按折旧最高值计提：找到折旧最高值，让所有年份都按最高值计提
  let maxDepreciationValue = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    if (depreciationYear[i] > maxDepreciationValue) {
      maxDepreciationValue = depreciationYear[i];
    }
  }

  // 创建按最高值计提的折旧数组（用于成本计算）
  const maxDepreciationYear =
    Array(calculationPeriod).fill(maxDepreciationValue);

  // 重新计算修理费（基于最高值计提的折旧）
  const maxRepairYear = [];
  let maxRepairTotal = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    // 建设期分年投资
    if (i < constructionPeriod) {
      // 建设期修理费为0
      maxRepairYear[i] = 0;
    } else {
      // 经营期修理费 = 年总折旧(最高值) * 年修理费率
      maxRepairYear[i] = (maxDepreciationYear[i] * repairRate) / 100;
    }
    maxRepairTotal += maxRepairYear[i];
  }

  // 计算经营成本、固定成本、可变成本和利息
  const operatingCostsYear = [];
  const fixedCostYear = [];
  const variableCostYear = [];
  const interestYear = Array(calculationPeriod).fill(0);

  // 获取经营期利息数据（从资金筹措及分年投资计划.资金筹措.债务资金.operating）
  const debtFundingData =
    projectData?.["资金筹措及分年投资计划"]?.["资金筹措"]?.["债务资金"] || {};
  const operatingInterestList = debtFundingData.operating || [];

  const w =
    projectData?.["流动资金估算"]?.["计算结果"]?.[
      "workingCapitalLoanInterest"
    ] || {};
  const liudonglixi = w.total || 0;
  const liudonglixiYear = w.year || Array(calculationPeriod).fill(0);

  // 填充各年利息数据（只包含经营期利息）
  for (
    let i = 0;
    i < operatingInterestList.length && i < calculationPeriod;
    i++
  ) {
    interestYear[i] =
      (operatingInterestList[i] || 0) + (liudonglixiYear[i] || 0);
  }

  // 计算每年总成本（折旧用正常值，修理费用最高值）
  const totalYear = [];
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    totalYear[i] =
      (rawMaterialYear[i] || 0) +
      (fuelPowerYear[i] || 0) +
      (wagesBenefitsYear[i] || 0) +
      (maxRepairYear[i] || 0) + // 修理费按最高折旧值计提
      (otherYear[i] || 0) +
      (depreciationYear[i] || 0) + // 折旧按正常值计算
      (amortizationYear[i] || 0) +
      (interestYear[i] || 0); // 加上利息
  }

  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    // 经营成本 = 原辅材料 + 燃料动力 + 工资福利 + 修理费(最高值) + 其他费用
    operatingCostsYear[i] =
      (rawMaterialYear[i] || 0) +
      (fuelPowerYear[i] || 0) +
      (wagesBenefitsYear[i] || 0) +
      (maxRepairYear[i] || 0) + // 修理费按最高折旧值计提
      (otherYear[i] || 0);

    // 固定成本 = 工资福利 + 修理费(最高值) + 其他费用 + 折旧(正常值) + 摊销 + 利息
    fixedCostYear[i] =
      (wagesBenefitsYear[i] || 0) +
      (maxRepairYear[i] || 0) + // 修理费按最高折旧值计提
      (otherYear[i] || 0) +
      (depreciationYear[i] || 0) + // 折旧按正常值计算
      (amortizationYear[i] || 0) +
      (interestYear[i] || 0); // 加上利息

    // 可变成本 = 原辅材料 + 燃料动力
    variableCostYear[i] = (rawMaterialYear[i] || 0) + (fuelPowerYear[i] || 0);
  }

  // 计算各成本合计
  const operatingCostsTotal = operatingCostsYear.reduce(
    (sum, value) => sum + value,
    0,
  );
  const fixedCostTotal = fixedCostYear.reduce((sum, value) => sum + value, 0);
  const variableCostTotal = variableCostYear.reduce(
    (sum, value) => sum + value,
    0,
  );
  const interestTotal = interestYear.reduce((sum, value) => sum + value, 0);

  // 计算总成本合计
  const total = totalYear.reduce((sum, value) => sum + value, 0);

  // 计算最高值计提的折旧合计（用于显示最高值计提的概念，但实际显示仍用正常值）
  const maxDepreciationTotal = maxDepreciationYear.reduce(
    (sum, value) => sum + value,
    0,
  );

  // 返回总成本费用对象
  return {
    repaircost: repairRate,
    othercost: otherCost,
    other: {
      total: otherTotal,
      year: otherYear,
    },
    repair: {
      total: maxRepairTotal, // 使用最高值计提的修理费
      year: maxRepairYear, // 使用最高值计提的修理费
      originalTotal: repairTotal, // 保留原始值供显示
      originalYear: repairYear, // 保留原始值供显示
    },
    rawmaterial: {
      total: rawMaterialTotal,
      year: rawMaterialYear,
    },
    fuelPpower: {
      total: fuelPowerTotal,
      year: fuelPowerYear,
    },
    wagesBenefits: {
      total: wagesBenefitsTotal,
      year: wagesBenefitsYear,
    },
    depreciation: {
      total: depreciationTotal, // 折旧按正常值显示（房屋+设备的正常合计）
      year: depreciationYear, // 折旧按正常值显示
    },
    Amortization: {
      total: amortizationTotal,
      year: amortizationYear,
    },
    interest: {
      total: interestTotal,
      year: interestYear,
    },
    Operatingcosts: {
      total: operatingCostsTotal,
      year: operatingCostsYear,
    },
    fixedcost: {
      total: fixedCostTotal,
      year: fixedCostYear,
    },
    variablecost: {
      total: variableCostTotal,
      year: variableCostYear,
    },
    Totalcost: {
      total: total,
      year: totalYear,
    },
  };
}

// 更新成本费用（不带参数版本）
export function totalCost() {
  let projectData = store.state.projectData;

  if (!projectData || !projectData["基础数据"]) {
    console.warn("数据结构不完整，无法执行成本费用计算");
    return;
  }

  // 直接调用完整计算逻辑
  const totalCostData = calculateTotalCost();

  // 更新成本费用对象
  if (!projectData["成本费用"]) {
    projectData["成本费用"] = {};
  }

  // 更新职工薪酬数据（工资福利）
  if (!projectData["成本费用"]["职工薪酬"]) {
    projectData["成本费用"]["职工薪酬"] = {};
  }
  if (!projectData["成本费用"]["职工薪酬"]["total"]) {
    projectData["成本费用"]["职工薪酬"]["total"] = {};
  }
  projectData["成本费用"]["职工薪酬"]["total"].total =
    totalCostData.wagesBenefits.total;
  projectData["成本费用"]["职工薪酬"]["total"].year =
    totalCostData.wagesBenefits.year;
  // 保持与组件中使用的字段名一致
  projectData["成本费用"]["职工薪酬"]["total"].gzfltotal =
    totalCostData.wagesBenefits.total;
  projectData["成本费用"]["职工薪酬"]["total"].gzfl =
    totalCostData.wagesBenefits.year;

  // 更新摊销数据
  if (!projectData["成本费用"]["摊销"]) {
    projectData["成本费用"]["摊销"] = {};
  }
  if (!projectData["成本费用"]["摊销"]["total"]) {
    projectData["成本费用"]["摊销"]["total"] = {};
  }
  projectData["成本费用"]["摊销"]["total"].amortizationTotal =
    totalCostData.Amortization.total;
  projectData["成本费用"]["摊销"]["total"].amortizationValues =
    totalCostData.Amortization.year;
  // 保持与组件中使用的字段名一致
  projectData["成本费用"]["摊销"]["total"].depreciationTotal =
    totalCostData.Amortization.total;
  projectData["成本费用"]["摊销"]["total"].depreciationValues =
    totalCostData.Amortization.year;

  // 更新修理费、其他费用等数据
  projectData["成本费用"]["修理费"] = {
    total: totalCostData.repair.total,
    year: totalCostData.repair.year,
  };
  projectData["成本费用"]["其他费用"] = {
    total: totalCostData.other.total,
    year: totalCostData.other.year,
  };
  projectData["成本费用"]["利息"] = {
    total: totalCostData.interest.total,
    year: totalCostData.interest.year,
  };
  projectData["成本费用"]["经营成本"] = {
    total: totalCostData.Operatingcosts.total,
    year: totalCostData.Operatingcosts.year,
  };
  projectData["成本费用"]["固定成本"] = {
    total: totalCostData.fixedcost.total,
    year: totalCostData.fixedcost.year,
  };
  projectData["成本费用"]["可变成本"] = {
    total: totalCostData.variablecost.total,
    year: totalCostData.variablecost.year,
  };
  projectData["成本费用"]["总成本费用"] = {
    total: totalCostData.Totalcost.total,
    year: totalCostData.Totalcost.year,
  };

  // 移除旧的总成本费用对象
  delete projectData["总成本费用"];

  // console.log('成本返回：');

  store.commit("SET_PROJECT_DATA", projectData);
}

// 新增营业收入税金及利润计算函数
export function calculateOperatingRevenue(taxParams = {}) {
  let projectData = store.state.projectData;

  // 检查数据结构是否完整
  if (!projectData || !projectData["基础数据"]) {
    console.warn("数据结构不完整，无法执行营业收入计算");
    return;
  }

  let jichu = projectData.基础数据;

  // 检查基础数据是否完整
  if (!jichu) {
    console.warn("基础数据不存在，无法计算营业收入");
    return;
  }

  let operatingRevenue = projectData["营业收入税金及利润"];

  // 获取税率参数，默认值与前端保持一致
  const UMCTaxRate = taxParams.UMCTax || 7; // 城建税率
  const EducationTaxRate = taxParams.Educationtax || 3; // 教育费附加率
  const ConsumptionTaxRate = taxParams.consumptiontax || 0; // 消费税率

  // 确保营业收入及营业税金数据结构
  if (!operatingRevenue["营业收入及营业税金"]) {
    operatingRevenue["营业收入及营业税金"] = {
      consumptiontax: ConsumptionTaxRate, //销项税率
      UMCTax: UMCTaxRate, //城建税率
      Educationtax: EducationTaxRate, //教育费附加率
      revenuetotal: 0, //总收入,放在总收入这一行的合计
      revenueByYear: [], //分年收入,放在总收入这一行的分年
      alltax: 0, //总税金,放在	年纳税合计这一行的合计
      additionaltax: 0, //附加税,放在附加税这一行的合计
      additionaltaxByYear: [], //分年附加税,为城建税+教育费附加+消费税,放在附加税这一行的分年
      alltaxByYear: [], //各税种分年税金合计,放在总收入这一行的分年
      outputtotal: 0, //总销项税金,为所有销售的销项税之和,放在销项税合计这一行的合计
      inptotal: 0, //总进项税,为所有采购的进项税之和,放在进项税合计这一行的合计
      valudedtotal: 0, //总增值税,为总销项税金-总进项税,放在增值税合计这一行的合计
      UMCTaxTotal: 0, //总城建税.为总增值税*城建税率,放在城建税合计这一行的合计
      EducationtaxTotal: 0, //总教育费附加.为总增值税*教育费附加率,放在教育费附加合计这一行的合计
      consumptiontaxTotal: 0, //总消费税.为总收入*消费税率,放在消费税合计这一行的合计
      outputtaxByYear: [], //分年销项税金,为各销售的销项税之和,放在销项税合计这一行的分年
      inputtaxByYear: [], //分年进项税,为各采购的进项税之和,放在进项税合计这一行的分年
      valueddedtax: [], //分年增值税,为分年销项税金-分年进项税,放在增值税合计这一行的分年
      UMCTaxByYear: [], //分年城建税,为分年增值税*城建税率,放在城建税合计这一行的分年
      EducationtaxByYear: [], //分年教育费附加,为分年增值税*教育费附加率,放在教育费附加合计这一行的分年
      consumptiontaxByYear: [], //分年消费税,为分年收入*消费税率,放在消费税合计这一行的分年

      //营业收入
      revenue: {},
      //其他收入
      otherinput: {},
    };
  }

  // 确保营业收入数据结构
  if (!operatingRevenue["营业收入及营业税金"].revenue) {
    operatingRevenue["营业收入及营业税金"].revenue = {
      revenueByYear: [], //分年营业收入合计数组,放在表中营业收入合计这一行的分年
      revenuetotal: 0, //营业收入合计,放在表中营业收入合计这一行的合计

      revenuelist: [],
    };
  }

  // 确保其他收入数据结构
  if (!operatingRevenue["营业收入及营业税金"].otherinput) {
    operatingRevenue["营业收入及营业税金"].otherinput = {
      input: 0, //年收入（前端输入，乘以经营负荷）
      tax: 0.17, //其他收入税率（前端输入）
      total: 0, //总其他收入,放在其他收入这一行的合计
      taxTotal: 0, //总其他收入税金,放在其他收入税额这一行的合计
      taxByYear: [], //其他收入分年税金,为(1-1/税率)*其他分年收入,放在其他收入税额这一行的分年
      inputByYear: [], //其他收入分年收入,为input*经营负荷,放在其他收入这一行的分年
    };
  }

  let 外层 = operatingRevenue["营业收入及营业税金"];
  let 营业收入 = 外层.revenue; // 营业收入数据
  let 其他收入 = 外层.otherinput; // 其他收入数据

  // 获取经营负荷数据
  let loadDataKeys = Object.keys(jichu.loadData);
  let calculationPeriod = jichu.calculationPeriod || 20;

  营业收入.revenueByYear = Array(calculationPeriod).fill(0);
  营业收入.revenuetotal = 0;
  外层.revenueByYear = Array(calculationPeriod).fill(0);
  外层.outputtotal = 0;
  外层.outputtaxByYear = Array(calculationPeriod).fill(0);
  外层.inputtaxByYear = Array(calculationPeriod).fill(0);
  外层.valudedtotal = 0;

  // 先清空累计值，避免重复累加
  营业收入.revenuetotal = 0;
  外层.revenuetotal = 0;
  外层.outputtotal = 0;

  营业收入.revenuelist.forEach((item) => {
    // 重置每个产品的累计值
    item.totalRevenue = 0;
    item.totalquantity = 0;
    item.totalTax = 0;

    // 计算各年投资活动现金流量
    for (let i = 0; i < calculationPeriod; i++) {
      item.revenueByYear[i] =
        (item.unitprice *
          item.quantity *
          (jichu.loadData[loadDataKeys[i]] || 0)) /
        100 /
        10000;
      item.quantityByYear[i] =
        (item.quantity * (jichu.loadData[loadDataKeys[i]] || 0)) / 100;
      item.taxByYear[i] =
        item.revenueByYear[i] * (1 - 1 / (1 + (item.tax || 0.17)));

      // 计算每个产品的总计
      item.totalRevenue += item.revenueByYear[i];
      item.totalquantity += item.quantityByYear[i];
      item.totalTax += item.taxByYear[i];

      // 累计到总收入
      外层.revenueByYear[i] += item.revenueByYear[i];
      外层.outputtaxByYear[i] += item.taxByYear[i];
      营业收入.revenueByYear[i] += item.revenueByYear[i];
    }

    // 计算所有产品的总收入和销项税金
    外层.revenuetotal += item.totalRevenue;
    外层.outputtotal += item.totalTax;
    营业收入.revenuetotal += item.totalRevenue;
  });

  其他收入.taxByYear = Array(calculationPeriod).fill(0);
  其他收入.taxTotal = 0;
  其他收入.inputByYear = Array(calculationPeriod).fill(0);
  其他收入.total = 0;
  外层.additionaltaxByYear = Array(calculationPeriod).fill(0);
  外层.additionaltax = 0;

  // 其他收入计算
  其他收入.total = 0;
  其他收入.taxTotal = 0;

  // 计算各年其他收入
  for (let i = 0; i < calculationPeriod; i++) {
    其他收入.inputByYear[i] =
      (其他收入.input * (jichu.loadData[loadDataKeys[i]] || 0)) / 100;
    其他收入.taxByYear[i] =
      其他收入.inputByYear[i] * (1 - 1 / (1 + (其他收入.tax || 0.17)));

    // 累计其他收入到总收入
    外层.revenueByYear[i] += 其他收入.inputByYear[i];
    外层.outputtaxByYear[i] += 其他收入.taxByYear[i];
  }

  // 计算其他收入总计（避免循环内累加）
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    其他收入.total += 其他收入.inputByYear[i];
    其他收入.taxTotal += 其他收入.taxByYear[i];
  }

  // 计算其他收入对总收入的影响
  外层.outputtotal += 其他收入.taxTotal;
  外层.revenuetotal += 其他收入.total;
  // 计算进项
  for (let i = 0; i < calculationPeriod; i++) {
    外层.inputtaxByYear[i] =
      (projectData["成本费用"]?.["原辅材料"]?.total?.tax[i] || 0) +
      (projectData["成本费用"]?.["燃料动力"]?.total?.tax[i] || 0); // 进项税
  }

  外层.inptotal =
    (projectData["成本费用"]?.["原辅材料"]?.total.taxTotal || 0) +
    (projectData["成本费用"]?.["燃料动力"]?.total.taxTotal || 0); // 总进项税

  外层.valudedtotal = 外层.outputtotal - 外层.inptotal;

  外层.valueddedtax = 外层.outputtaxByYear.map((v, i) =>
    v - 外层.inputtaxByYear[i] < 0 ? 0 : v - 外层.inputtaxByYear[i],
  );

  // 计算总增值税为分年增值税的总和
  外层.valudedtotal = 外层.valueddedtax.reduce((total, v) => total + v, 0);

  // 初始化附加税相关数组和累计值
  外层.UMCTaxByYear = Array(calculationPeriod).fill(0);
  外层.EducationtaxByYear = Array(calculationPeriod).fill(0);
  外层.UMCTaxTotal = 0;
  外层.EducationtaxTotal = 0;
  外层.consumptiontaxTotal = 0;
  外层.consumptiontaxByYear = Array(calculationPeriod).fill(0);
  外层.additionaltax = 0;

  // 先计算各税种的分年数据
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    外层.UMCTaxByYear[i] = (外层.valueddedtax[i] * 外层.UMCTax) / 100;
    外层.EducationtaxByYear[i] =
      (外层.valueddedtax[i] * 外层.Educationtax) / 100;
    外层.consumptiontaxByYear[i] =
      (外层.revenueByYear[i] * 外层.consumptiontax) / 100;
    外层.additionaltaxByYear[i] =
      外层.EducationtaxByYear[i] +
      外层.UMCTaxByYear[i] +
      外层.consumptiontaxByYear[i];
  }

  // 计算总附加税（避免循环内累加）
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    外层.UMCTaxTotal += 外层.UMCTaxByYear[i];
    外层.EducationtaxTotal += 外层.EducationtaxByYear[i];
    外层.consumptiontaxTotal += 外层.consumptiontaxByYear[i];
    外层.additionaltax += 外层.additionaltaxByYear[i];
  }
  外层.revenue = 营业收入;
  外层.otherinput = 其他收入;
  projectData["营业收入税金及利润"]["营业收入及营业税金"] = 外层;
  store.commit("SET_PROJECT_DATA", projectData);
  return projectData;
}

//流动资金估算
export function workingCapital() {
  let projectData = store.state.projectData;
  if (!projectData) {
    console.error("项目数据不存在");
    return {};
  }

  const 流动资金数据 = projectData["流动资金估算"] || {};
  const 基础数据 = projectData["基础数据"] || {};
  const 营业收入数据 =
    projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.["revenue"] ||
    {};
  const 成本费用数据 = projectData["成本费用"]?.["经营成本"] || {};

  // 计算期参数
  const calculationPeriod = 基础数据?.calculationPeriod || 15;
  const constructionPeriod = 基础数据?.constructionPeriod || 1;

  // 获取经营负荷数据
  const loadData = 基础数据?.loadData || {};

  // 从其他组件获取的基础数据
  const 分年营业收入 = 营业收入数据.revenueByYear || []; // 分年营业收入
  const 营业收入合计 = 营业收入数据.revenuetotal || 0; // 营业收入合计
  const 分年经营成本 = 成本费用数据.year || []; // 分年经营成本
  const 经营成本合计 = 成本费用数据.total || 0; // 经营成本合计

  // 找到经营负荷达到100%的第一年
  let firstFullLoadYear = null;
  for (let year = 1; year <= calculationPeriod; year++) {
    if (loadData[year] === 100) {
      firstFullLoadYear = year;
      break;
    }
  }

  // 周转次数参数
  const 应收帐款周转次数 = 流动资金数据.accountsReceivableTurnover || 8;
  const 应付帐款周转次数 = 流动资金数据.accountsPayableTurnover || 12;
  const 存货周转次数 = 流动资金数据.inventoryTurnover || 6;
  const 现金周转次数 = 流动资金数据.cashTurnover || 24;
  const 流动资金贷款比例 = 流动资金数据.loanRatio / 100;
  const 流动资金借款利率 = 流动资金数据.loanInterestRate || 4.35; // 流动资金借款利率，默认4.35%

  // 计算结果对象
  const 计算结果 = {
    // 基础数据
    revenueByYear: [...分年营业收入], // 分年营业收入
    revenueTotal: 营业收入合计, // 营业收入合计
    operatingCostByYear: [...分年经营成本], // 分年经营成本
    operatingCostTotal: 经营成本合计, // 经营成本合计

    // 计算结果
    receivables: { year: [], total: 0 }, // 应收帐款
    inventory: { year: [], total: 0 }, // 建设期：
    cash: { year: [], total: 0 }, // 现金
    payables: { year: [], total: 0 }, // 应付帐款
    currentAssets: { year: [], total: 0 }, // 流动资产
    currentLiabilities: { year: [], total: 0 }, // 流动负债
    workingCapitalRequirement: { year: [], total: 0 }, // 流动资金需求
    workingCapitalLoan: { year: [], total: 0 }, // 流动资金贷款
    workingCapitalLoanInterest: { year: [], total: 0 }, // 流动资金借款利息
    workingCapitalEquity: { year: [], total: 0 }, // 流动资金自有资金
    increaseThisYear: { year: [], total: 0 }, // 流动资金本年增加额
    equityIncreaseThisYear: { year: [], total: 0 }, // 自有流动资金本年增加额
  };

  let 上年流动资金需求 = 0;

  // 计算每年的流动资金
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    const year = i + 1;

    // 检查是否有营业收入或经营成本数据
    const 当年营业收入 = 分年营业收入[i] || 0;
    const 当年经营成本 = 分年经营成本[i] || 0;
    const 有收入或成本数据 = 当年营业收入 > 0 || 当年经营成本 > 0;

    // 建设期和运营期，只要有数据就计算流动资金
    if (
      有收入或成本数据 &&
      i < 分年营业收入.length &&
      i < 分年经营成本.length
    ) {
      // 应收帐款 = 营业收入 / 应收帐款周转次数
      const 应收帐款金额 = 当年营业收入 / 应收帐款周转次数;
      计算结果.receivables.year[i] = 应收帐款金额;

      // 建设期： = 经营成本 / 存货周转次数
      const 存货金额 = 当年经营成本 / 存货周转次数;
      计算结果.inventory.year[i] = 存货金额;

      // 现金 = (经营成本 * 0.1) / 现金周转次数 (假设现金为经营成本的10%)
      const 现金基准 = 当年经营成本 * 0.1;
      const 现金金额 = 现金基准 / 现金周转次数;
      计算结果.cash.year[i] = 现金金额;

      // 应付帐款 = 经营成本 / 应付帐款周转次数
      const 应付帐款金额 = 当年经营成本 / 应付帐款周转次数;
      计算结果.payables.year[i] = 应付帐款金额;

      // 流动资产 = 应收帐款 + 存货 + 现金
      计算结果.currentAssets.year[i] =
        计算结果.receivables.year[i] +
        计算结果.inventory.year[i] +
        计算结果.cash.year[i];

      // 流动负债 = 应付帐款
      计算结果.currentLiabilities.year[i] = 计算结果.payables.year[i];

      // 流动资金需求 = 流动资产 - 流动负债
      计算结果.workingCapitalRequirement.year[i] =
        计算结果.currentAssets.year[i] - 计算结果.currentLiabilities.year[i];

      计算结果.workingCapitalLoan.year[i] =
        计算结果.workingCapitalRequirement.year[i] * 流动资金贷款比例;

      // 流动资金自有资金 = 流动资金需求 - 流动资金贷款
      计算结果.workingCapitalEquity.year[i] =
        计算结果.workingCapitalRequirement.year[i] -
        计算结果.workingCapitalLoan.year[i];

      计算结果.workingCapitalLoanInterest.year[i] =
        计算结果.workingCapitalLoan.year[i] * (流动资金借款利率 / 100);

      // 流动资金本年增加额 = 本年需求 - 上年需求
      // 只有在经营负荷达到100%的第一年及之前才计算增加额
      const currentYear = i + 1;

      // 如果找到了100%负荷年份
      if (firstFullLoadYear) {
        if (currentYear <= firstFullLoadYear) {
          // 在达到100%负荷之前，正常计算增加额
          if (上年流动资金需求 === 0) {
            计算结果.increaseThisYear.year[i] =
              计算结果.workingCapitalRequirement.year[i];
          } else {
            计算结果.increaseThisYear.year[i] =
              计算结果.workingCapitalRequirement.year[i] - 上年流动资金需求;
          }

          上年流动资金需求 = 计算结果.workingCapitalRequirement.year[i];
        } else {
          // 达到100%负荷后的年份，流动资金本年增加额为0
          计算结果.increaseThisYear.year[i] = 0;
          // 不再更新上年流动资金需求，保持在满负荷水平
        }
      } else {
        // 如果没有找到100%负荷年份，按原有逻辑计算（所有年份都计算增加额）
        if (上年流动资金需求 === 0) {
          计算结果.increaseThisYear.year[i] =
            计算结果.workingCapitalRequirement.year[i];
        } else {
          计算结果.increaseThisYear.year[i] =
            计算结果.workingCapitalRequirement.year[i] - 上年流动资金需求;
        }

        上年流动资金需求 = 计算结果.workingCapitalRequirement.year[i];
      }

      // 自有流动资金本年增加额 = 本年自有流动资金 - 上年自有流动资金
      // 只有在经营负荷达到100%的第一年及之前才计算增加额
      if (firstFullLoadYear) {
        if (currentYear <= firstFullLoadYear) {
          // 在达到100%负荷之前，正常计算增加额
          if (i === 0) {
            // 第一年的自有流动资金增加额等于第一年的自有流动资金
            计算结果.equityIncreaseThisYear.year[i] =
              计算结果.workingCapitalEquity.year[i];
          } else {
            // 其他年份的自有流动资金增加额 = 本年自有流动资金 - 上年自有流动资金
            计算结果.equityIncreaseThisYear.year[i] =
              计算结果.workingCapitalEquity.year[i] -
              计算结果.workingCapitalEquity.year[i - 1];
          }
        } else {
          // 达到100%负荷后的年份，自有流动资金本年增加额为0
          计算结果.equityIncreaseThisYear.year[i] = 0;
        }
      } else {
        // 如果没有找到100%负荷年份，按原有逻辑计算（所有年份都计算增加额）
        if (i === 0) {
          // 第一年的自有流动资金增加额等于第一年的自有流动资金
          计算结果.equityIncreaseThisYear.year[i] =
            计算结果.workingCapitalEquity.year[i];
        } else {
          // 其他年份的自有流动资金增加额 = 本年自有流动资金 - 上年自有流动资金
          计算结果.equityIncreaseThisYear.year[i] =
            计算结果.workingCapitalEquity.year[i] -
            计算结果.workingCapitalEquity.year[i - 1];
        }
      }
    } else {
      // 建设期或数据不足设置为0
      计算结果.receivables.year[i] = 0;
      计算结果.inventory.year[i] = 0;
      计算结果.cash.year[i] = 0;
      计算结果.payables.year[i] = 0;
      计算结果.currentAssets.year[i] = 0;
      计算结果.currentLiabilities.year[i] = 0;
      计算结果.workingCapitalRequirement.year[i] = 0;
      计算结果.workingCapitalLoan.year[i] = 0;
      计算结果.workingCapitalLoanInterest.year[i] = 0;
      计算结果.workingCapitalEquity.year[i] = 0;
      计算结果.increaseThisYear.year[i] = 0;
    }
  }

  // 计算总计
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    计算结果.receivables.total += 计算结果.receivables.year[i] || 0;
    计算结果.inventory.total += 计算结果.inventory.year[i] || 0;
    计算结果.cash.total += 计算结果.cash.year[i] || 0;
    计算结果.payables.total += 计算结果.payables.year[i] || 0;
    计算结果.currentAssets.total += 计算结果.currentAssets.year[i] || 0;
    计算结果.currentLiabilities.total +=
      计算结果.currentLiabilities.year[i] || 0;
    计算结果.workingCapitalRequirement.total +=
      计算结果.workingCapitalRequirement.year[i] || 0;
    计算结果.workingCapitalLoan.total +=
      计算结果.workingCapitalLoan.year[i] || 0;
    计算结果.workingCapitalLoanInterest.total +=
      计算结果.workingCapitalLoanInterest.year[i] || 0;
    计算结果.workingCapitalEquity.total +=
      计算结果.workingCapitalEquity.year[i] || 0;
    计算结果.increaseThisYear.total += 计算结果.increaseThisYear.year[i] || 0;
    计算结果.equityIncreaseThisYear.total +=
      计算结果.equityIncreaseThisYear.year[i] || 0;
  }

  // 保存计算结果到store
  projectData["流动资金估算"] = projectData["流动资金估算"] || {};
  projectData["流动资金估算"]["计算结果"] = 计算结果;

  // 将自有流动资金本年增加额写入总投资估算.总表.流动资金.其他费用
  if (!projectData["总投资估算"]) {
    projectData["总投资估算"] = {};
  }

  if (!projectData["总投资估算"]["总表"]) {
    projectData["总投资估算"]["总表"] = {};
  }

  if (!projectData["总投资估算"]["总表"]["流动资金"]) {
    projectData["总投资估算"]["总表"]["流动资金"] = {};
  }

  projectData["总投资估算"]["总表"]["流动资金"]["其他费用"] =
    计算结果.equityIncreaseThisYear.total;

  totalTable();

  store.commit("SET_PROJECT_DATA", projectData);

  return 计算结果;
}

// 资金筹措及分年投资计划-----资金筹措
export async function Financing() {
  let projectData = store.state.projectData;
  if (!projectData) {
    console.error("项目数据不存在");
    return {};
  }

  // 确保数据结构存在
  if (!projectData.资金筹措及分年投资计划) {
    projectData.资金筹措及分年投资计划 = {};
  }

  let zjcc = projectData.资金筹措及分年投资计划?.资金筹措;
  let jsq = projectData.基础数据?.constructionPeriod || 0;
  let zqx = projectData.基础数据?.calculationPeriod || 0;

  // 如果 zjcc 不存在，创建完整的数据结构
  if (!zjcc) {
    zjcc = {
      amount: 0, //资金筹措总额，等于资金筹措总额+债务资金总额，恒等于总投资估算.总表.总投资.合计
      proportion: 1, //与资金筹措总额的比例
      项目资本金: {
        amount: 0, //项目资本金总额，等于资金筹措总额-债务资金.amount
        proportion: null, //项目资本金总额与资金筹措总额的比例
      },
      债务资金: {
        amount: 0, //债务资金总额,等于银行借款.amount+债券.amount+融资租赁.amount+其他借款.amount
        proportion: null, //债务资金总额与资金筹措总额的比例
        interest: 0, //建设期利息
        loan: [],
        interestlist: [], //建设期利息分年列表
        operating: [],
        principal: [],
        银行借款: {
          amount: 0, //银行借款总额
          proportion: null, //银行借款总额与资金筹措总额的比例
          term: 0, //银行借款期限
          rate: 0, //银行借款利率
          startyear: 1, //银行借款开始年
          quarter: 3, //银行借款开始季度
          interest: 0, //建设期利息
          loan: [],
          interestlist: [], //建设期利息分年列表
          operating: [],
          principal: [],
          Repayment: "逐年付息期末还本", //还款方式
        },
        债券: {
          amount: 0, //债券总额
          proportion: null, //债券总额与资金筹措总额的比例
          term: 0, //债券期限
          rate: 0, //债券利率
          startyear: 1, //债券开始年
          quarter: 3, //债券开始季度
          interest: 0, //建设期利息
          loan: [],
          interestlist: [], //建设期利息分年列表
          operating: [],
          principal: [],
          Repayment: "逐年付息期末还本", //还款方式
        },
        融资租赁: {
          amount: 0, //融资总额
          proportion: 1, //融资总额与资金筹措总额的比例
          term: 0, //融资期限
          rate: 0, //融资利率
          startyear: 1, //融资开始年
          quarter: 3, //融资开始季度
          interest: 0, //建设期利息
          loan: [],
          interestlist: [], //建设期利息分年列表
          operating: [],
          principal: [],
          Repayment: "逐年付息期末还本", //还款方式
        },
        其他借款: {
          amount: 0, //其他借款总额
          proportion: 1, //其他借款总额与资金筹措总额的比例
          term: 0, //其他借款期限
          rate: 0, //其他借款利率
          startyear: 1, //其他借款开始年
          quarter: 3, //其他借款开始季度
          interest: 0, //建设期利息
          loan: [],
          interestlist: [], //建设期利息分年列表
          operating: [],
          principal: [],
          Repayment: "逐年付息期末还本", //还款方式
        },
      },
    };
  }

  // 确保所有需要的数组都存在且被正确初始化
  zjcc.proportion = 1;

  // 初始化所有需要的数组，确保它们都有正确的长度
  const initializeArray = (arr, length) => {
    if (!Array.isArray(arr)) {
      arr = [];
    }
    // 确保数组有足够的长度
    while (arr.length < length) {
      arr.push(0);
    }
    // 如果数组太长，截断它
    if (arr.length > length) {
      arr = arr.slice(0, length);
    }
    return arr;
  };

  // 初始化所有数组
  const initAllArrays = (length) => {
    // 债务资金
    zjcc.债务资金.interestlist = initializeArray(
      zjcc.债务资金.interestlist,
      length,
    );
    zjcc.债务资金.loan = initializeArray(zjcc.债务资金.loan, length);
    zjcc.债务资金.principal = initializeArray(zjcc.债务资金.principal, zqx);

    // 银行借款
    zjcc.债务资金.银行借款.interestlist = initializeArray(
      zjcc.债务资金.银行借款.interestlist,
      length,
    );
    zjcc.债务资金.银行借款.loan = initializeArray(
      zjcc.债务资金.银行借款.loan,
      length,
    );
    zjcc.债务资金.银行借款.principal = initializeArray(
      zjcc.债务资金.银行借款.principal,
      zqx,
    );

    // 债券
    zjcc.债务资金.债券.interestlist = initializeArray(
      zjcc.债务资金.债券.interestlist,
      length,
    );
    zjcc.债务资金.债券.loan = initializeArray(zjcc.债务资金.债券.loan, length);
    zjcc.债务资金.债券.principal = initializeArray(
      zjcc.债务资金.债券.principal,
      zqx,
    );

    // 融资租赁
    zjcc.债务资金.融资租赁.interestlist = initializeArray(
      zjcc.债务资金.融资租赁.interestlist,
      length,
    );
    zjcc.债务资金.融资租赁.loan = initializeArray(
      zjcc.债务资金.融资租赁.loan,
      length,
    );
    zjcc.债务资金.融资租赁.principal = initializeArray(
      zjcc.债务资金.融资租赁.principal,
      zqx,
    );

    // 其他借款
    zjcc.债务资金.其他借款.interestlist = initializeArray(
      zjcc.债务资金.其他借款.interestlist,
      length,
    );
    zjcc.债务资金.其他借款.loan = initializeArray(
      zjcc.债务资金.其他借款.loan,
      length,
    );
    zjcc.债务资金.其他借款.principal = initializeArray(
      zjcc.债务资金.其他借款.principal,
      zqx,
    );
  };

  // 初始化所有数组
  initAllArrays(jsq);
  zjcc.债务资金.operating = initializeArray(zjcc.债务资金.operating, zqx);
  zjcc.债务资金.银行借款.operating = initializeArray(
    zjcc.债务资金.银行借款.operating,
    zqx,
  );
  zjcc.债务资金.其他借款.operating = initializeArray(
    zjcc.债务资金.其他借款.operating,
    zqx,
  );
  zjcc.债务资金.债券.operating = initializeArray(
    zjcc.债务资金.债券.operating,
    zqx,
  );
  zjcc.债务资金.融资租赁.operating = initializeArray(
    zjcc.债务资金.融资租赁.operating,
    zqx,
  );

  for (let i = 0; i < jsq; i++) {
    // 计算银行借款利息
    const bankLoanRepayment =
      zjcc.债务资金.银行借款.Repayment || "逐年付息期末还本";
    if (
      zjcc.债务资金.银行借款.startyear <= i + 1 &&
      i + 1 <= zjcc.债务资金.银行借款.startyear + zjcc.债务资金.银行借款.term
    ) {
      zjcc.债务资金.银行借款.loan[i] = 0;
      if (zjcc.债务资金.银行借款.startyear == i + 1) {
        zjcc.债务资金.银行借款.loan[i] = zjcc.债务资金.银行借款.amount;
      }

      // 只有当还款方式不是"期末本息"时，才计算建设期利息
      if (bankLoanRepayment !== "期末本息") {
        if (zjcc.债务资金.银行借款.startyear == i + 1) {
          // 开始年份按季度计算
          zjcc.债务资金.银行借款.interestlist[i] =
            (((zjcc.债务资金.银行借款.amount * zjcc.债务资金.银行借款.rate) /
              100) *
              (4 - zjcc.债务资金.银行借款.quarter + 1)) /
            4;
        } else {
          // 后续年份按全年计算
          zjcc.债务资金.银行借款.interestlist[i] =
            (zjcc.债务资金.银行借款.amount * zjcc.债务资金.银行借款.rate) / 100;
        }
      } else {
        // 期末本息还款方式，建设期利息为0
        zjcc.债务资金.银行借款.interestlist[i] = 0;
      }
    } else {
      // 不在借款期限内，设置为0
      zjcc.债务资金.银行借款.loan[i] = 0;
      zjcc.债务资金.银行借款.interestlist[i] = 0;
    }

    // 计算债券利息
    const bondRepayment = zjcc.债务资金.债券.Repayment || "逐年付息期末还本";
    if (
      zjcc.债务资金.债券.startyear <= i + 1 &&
      i + 1 <= zjcc.债务资金.债券.startyear + zjcc.债务资金.债券.term
    ) {
      zjcc.债务资金.债券.loan[i] = 0;
      if (zjcc.债务资金.债券.startyear == i + 1) {
        zjcc.债务资金.债券.loan[i] = zjcc.债务资金.债券.amount;
      }

      // 只有当还款方式不是"期末本息"时，才计算建设期利息
      if (bondRepayment !== "期末本息") {
        if (zjcc.债务资金.债券.startyear == i + 1) {
          zjcc.债务资金.债券.interestlist[i] =
            (((zjcc.债务资金.债券.amount * zjcc.债务资金.债券.rate) / 100) *
              (4 - zjcc.债务资金.债券.quarter + 1)) /
            4;
        } else {
          zjcc.债务资金.债券.interestlist[i] =
            (zjcc.债务资金.债券.amount * zjcc.债务资金.债券.rate) / 100;
        }
      } else {
        // 期末本息还款方式，建设期利息为0
        zjcc.债务资金.债券.interestlist[i] = 0;
      }
    } else {
      zjcc.债务资金.债券.loan[i] = 0;
      zjcc.债务资金.债券.interestlist[i] = 0;
    }

    // 融资租赁利息计算
    const leaseRepayment =
      zjcc.债务资金.融资租赁.Repayment || "逐年付息期末还本";
    if (
      zjcc.债务资金.融资租赁.startyear <= i + 1 &&
      i + 1 <= zjcc.债务资金.融资租赁.startyear + zjcc.债务资金.融资租赁.term
    ) {
      zjcc.债务资金.融资租赁.loan[i] = 0;
      if (zjcc.债务资金.融资租赁.startyear == i + 1) {
        zjcc.债务资金.融资租赁.loan[i] = zjcc.债务资金.融资租赁.amount;
      }

      // 只有当还款方式不是"期末本息"时，才计算建设期利息
      if (leaseRepayment !== "期末本息") {
        if (zjcc.债务资金.融资租赁.startyear == i + 1) {
          zjcc.债务资金.融资租赁.interestlist[i] =
            (((zjcc.债务资金.融资租赁.amount * zjcc.债务资金.融资租赁.rate) /
              100) *
              (4 - zjcc.债务资金.融资租赁.quarter + 1)) /
            4;
        } else {
          zjcc.债务资金.融资租赁.interestlist[i] =
            (zjcc.债务资金.融资租赁.amount * zjcc.债务资金.融资租赁.rate) / 100;
        }
      } else {
        // 期末本息还款方式，建设期利息为0
        zjcc.债务资金.融资租赁.interestlist[i] = 0;
      }
    } else {
      zjcc.债务资金.融资租赁.loan[i] = 0;
      zjcc.债务资金.融资租赁.interestlist[i] = 0;
    }

    // 其他借款利息计算
    const otherLoanRepayment =
      zjcc.债务资金.其他借款.Repayment || "逐年付息期末还本";
    if (
      zjcc.债务资金.其他借款.startyear <= i + 1 &&
      i + 1 <= zjcc.债务资金.其他借款.startyear + zjcc.债务资金.其他借款.term
    ) {
      zjcc.债务资金.其他借款.loan[i] = 0;
      if (zjcc.债务资金.其他借款.startyear == i + 1) {
        zjcc.债务资金.其他借款.loan[i] = zjcc.债务资金.其他借款.amount;
      }

      // 只有当还款方式不是"期末本息"时，才计算建设期利息
      if (otherLoanRepayment !== "期末本息") {
        if (zjcc.债务资金.其他借款.startyear == i + 1) {
          zjcc.债务资金.其他借款.interestlist[i] =
            (((zjcc.债务资金.其他借款.amount * zjcc.债务资金.其他借款.rate) /
              100) *
              (4 - zjcc.债务资金.其他借款.quarter + 1)) /
            4;
        } else {
          zjcc.债务资金.其他借款.interestlist[i] =
            (zjcc.债务资金.其他借款.amount * zjcc.债务资金.其他借款.rate) / 100;
        }
      } else {
        // 期末本息还款方式，建设期利息为0
        zjcc.债务资金.其他借款.interestlist[i] = 0;
      }
    } else {
      zjcc.债务资金.其他借款.loan[i] = 0;
      zjcc.债务资金.其他借款.interestlist[i] = 0;
    }

    // 计算总贷款和总利息
    zjcc.债务资金.loan[i] =
      zjcc.债务资金.银行借款.loan[i] +
      zjcc.债务资金.债券.loan[i] +
      zjcc.债务资金.融资租赁.loan[i] +
      zjcc.债务资金.其他借款.loan[i];

    zjcc.债务资金.interestlist[i] =
      zjcc.债务资金.银行借款.interestlist[i] +
      zjcc.债务资金.债券.interestlist[i] +
      zjcc.债务资金.融资租赁.interestlist[i] +
      zjcc.债务资金.其他借款.interestlist[i];
  }
  zjcc.债务资金.operating = initializeArray(zjcc.债务资金.operating, zqx);
  zjcc.债务资金.银行借款.operating = initializeArray(
    zjcc.债务资金.银行借款.operating,
    zqx,
  );
  zjcc.债务资金.其他借款.operating = initializeArray(
    zjcc.债务资金.其他借款.operating,
    zqx,
  );
  zjcc.债务资金.债券.operating = initializeArray(
    zjcc.债务资金.债券.operating,
    zqx,
  );
  zjcc.债务资金.融资租赁.operating = initializeArray(
    zjcc.债务资金.融资租赁.operating,
    zqx,
  );

  // 重置经营期利息和本金数组
  for (let i = 0; i < zqx; i++) {
    zjcc.债务资金.银行借款.operating[i] = 0;
    zjcc.债务资金.其他借款.operating[i] = 0;
    zjcc.债务资金.债券.operating[i] = 0;
    zjcc.债务资金.融资租赁.operating[i] = 0;
    zjcc.债务资金.银行借款.principal[i] = 0;
    zjcc.债务资金.其他借款.principal[i] = 0;
    zjcc.债务资金.债券.principal[i] = 0;
    zjcc.债务资金.融资租赁.principal[i] = 0;
    zjcc.债务资金.operating[i] = 0;
    zjcc.债务资金.principal[i] = 0;
  }

  // 计算经营期利息和本金的函数
  const calculateOperatingInterestAndPrincipal = (
    debtType,
    repaymentMethod,
  ) => {
    const debt = zjcc.债务资金[debtType];
    const amount = debt.amount;
    const rate = debt.rate / 100;
    const term = debt.term;
    const startYear = debt.startyear;
    const endYear = startYear + term - 1;

    if (amount <= 0 || rate <= 0 || term <= 0) return;

    switch (repaymentMethod) {
      case "逐年付息期末还本":
        // 按现有方式计算
        for (let i = jsq; i < endYear; i++) {
          if (i < zqx) {
            debt.operating[i] = amount * rate;
          }
        }
        // 最后一年还本
        if (endYear - 1 < zqx) {
          debt.principal[endYear - 1] = amount;
        }
        break;

      case "等额本息":
        // 计算月利率和总还款月数
        const monthlyRate = rate / 12;
        const totalMonths = term * 12;

        // 计算每月还款额
        const monthlyPayment =
          (amount * monthlyRate * Math.pow(1 + monthlyRate, totalMonths)) /
          (Math.pow(1 + monthlyRate, totalMonths) - 1);

        // 计算每年的利息和本金
        let remainingPrincipal = amount;
        for (let year = startYear; year <= endYear; year++) {
          let annualInterest = 0;
          let annualPrincipal = 0;

          // 计算该年的12个月还款
          for (let month = 1; month <= 12; month++) {
            const monthInterest = remainingPrincipal * monthlyRate;
            const monthPrincipal = monthlyPayment - monthInterest;

            annualInterest += monthInterest;
            annualPrincipal += monthPrincipal;

            remainingPrincipal -= monthPrincipal;

            // 防止负数
            if (remainingPrincipal < 0) {
              remainingPrincipal = 0;
            }
          }

          // 将年利息和本金存入对应年份
          const yearIndex = year - 1;
          if (yearIndex >= jsq && yearIndex < zqx) {
            debt.operating[yearIndex] = annualInterest;
            debt.principal[yearIndex] = annualPrincipal;
          }
        }
        break;

      case "期末本息":
        // 最后一年还款
        if (endYear - 1 < zqx) {
          // 计算总利息
          const totalInterest = amount * rate * term;
          debt.operating[endYear - 1] = totalInterest;
          debt.principal[endYear - 1] = amount;
        }
        break;

      default:
        // 默认按逐年付息期末还本处理
        for (let i = jsq; i < endYear; i++) {
          if (i < zqx) {
            debt.operating[i] = amount * rate;
          }
        }
        if (endYear - 1 < zqx) {
          debt.principal[endYear - 1] = amount;
        }
    }
  };

  // 对每种债务类型应用还款方式
  const debtTypes = ["银行借款", "债券", "融资租赁", "其他借款"];
  debtTypes.forEach((debtType) => {
    const repaymentMethod =
      zjcc.债务资金[debtType].Repayment || "逐年付息期末还本";
    calculateOperatingInterestAndPrincipal(debtType, repaymentMethod);
  });

  // 汇总所有债务类型的经营期利息和本金
  for (let i = 0; i < zqx; i++) {
    zjcc.债务资金.operating[i] =
      zjcc.债务资金.银行借款.operating[i] +
      zjcc.债务资金.债券.operating[i] +
      zjcc.债务资金.融资租赁.operating[i] +
      zjcc.债务资金.其他借款.operating[i];

    zjcc.债务资金.principal[i] =
      zjcc.债务资金.银行借款.principal[i] +
      zjcc.债务资金.债券.principal[i] +
      zjcc.债务资金.融资租赁.principal[i] +
      zjcc.债务资金.其他借款.principal[i];
  }
  projectData.成本费用.利息.year = zjcc.债务资金.operating;
  projectData.成本费用.利息.total = zjcc.债务资金.operating.reduce(
    (a, b) => a + b,
    0,
  );

  // 计算各项总利息
  zjcc.债务资金.银行借款.interest = zjcc.债务资金.银行借款.interestlist.reduce(
    (a, b) => a + b,
    0,
  );
  zjcc.债务资金.债券.interest = zjcc.债务资金.债券.interestlist.reduce(
    (a, b) => a + b,
    0,
  );
  zjcc.债务资金.融资租赁.interest = zjcc.债务资金.融资租赁.interestlist.reduce(
    (a, b) => a + b,
    0,
  );
  zjcc.债务资金.其他借款.interest = zjcc.债务资金.其他借款.interestlist.reduce(
    (a, b) => a + b,
    0,
  );

  // 计算总债务利息
  zjcc.债务资金.interest =
    zjcc.债务资金.银行借款.interest +
    zjcc.债务资金.债券.interest +
    zjcc.债务资金.融资租赁.interest +
    zjcc.债务资金.其他借款.interest;

  // 计算债务资金总额
  zjcc.债务资金.amount =
    zjcc.债务资金.银行借款.amount +
    zjcc.债务资金.债券.amount +
    zjcc.债务资金.融资租赁.amount +
    zjcc.债务资金.其他借款.amount;

  // 计算总投资
  zjcc.amount = totalTable({ int: zjcc.债务资金.interest });
  console.log("总投资：", zjcc.amount, zjcc.债务资金.interest);

  // 确保项目资本金是一个对象
  if (!zjcc.项目资本金 || typeof zjcc.项目资本金 !== "object") {
    zjcc.项目资本金 = { amount: 0, proportion: null };
  }

  // 计算项目资本金
  zjcc.项目资本金.amount = zjcc.amount - zjcc.债务资金.amount;

  // 检查项目资本金是否为负数
  if (zjcc.项目资本金.amount < 0) {
    console.error("项目资本金不能为负数，请调整债务资金！");
    // 返回验证失败信息
    return {
      success: false,
      error: "项目资本金不能为负数，请调整债务资金！",
      errorCode: "NEGATIVE_CAPITAL",
    };
  }

  // 检查建设期利息总额是否超过项目资本金
  if (zjcc.债务资金.interest > zjcc.项目资本金.amount) {
    console.error("建设期利息总额超过项目资本金，不允许！");
    // 返回验证失败信息
    return {
      success: false,
      error: "建设期利息总额超过项目资本金，不允许！",
      errorCode: "INTEREST_EXCEEDS_CAPITAL",
    };
  }

  // 计算各项比例
  if (zjcc.amount > 0) {
    zjcc.proportion = 1;
    zjcc.债务资金.银行借款.proportion =
      zjcc.债务资金.银行借款.amount / zjcc.amount;
    zjcc.债务资金.债券.proportion = zjcc.债务资金.债券.amount / zjcc.amount;
    zjcc.债务资金.融资租赁.proportion =
      zjcc.债务资金.融资租赁.amount / zjcc.amount;
    zjcc.债务资金.其他借款.proportion =
      zjcc.债务资金.其他借款.amount / zjcc.amount;
    zjcc.债务资金.proportion = zjcc.债务资金.amount / zjcc.amount;
    zjcc.项目资本金.proportion = zjcc.项目资本金.amount / zjcc.amount;
  } else {
    zjcc.proportion = null;
    zjcc.项目资本金.proportion = null;
  }

  // 更新项目数据
  projectData.资金筹措及分年投资计划.资金筹措 = zjcc;
  store.commit("SET_PROJECT_DATA", projectData);
  let ss =
    projectData.资金筹措及分年投资计划.还本付息.repaymentSource || "netProfit";

  calculateRepaymentPlan(ss);

  calculateAnnualInvestment("ok"); //分年投资计划
  return zjcc;
}
export function 苏() {
  totalTable(); //总投资估算

  deprecia(); //折旧费用
  amortization(); //摊销费用
  calculateOperatingRevenue(); //营业收入计算
  workingCapital(); //流动资金估算
  Financing(); //资金筹措及分年投资计划-----资金筹措
  totalTable(); //总投资估算
  totalCost(); //总成本费用计算
  profitCalculation(); //利润计算
  // allInvestmentCashFlowCalculation(); //分年投资现金流量计算
  capitalCashFlowCalculation(); //资本金现金流量计算
  //财务计划现金流量计算
  financialPlanCashFlowCalculation(); //财务计划现金流量计算
  calculateRepaymentPlan(); //还款计划计算
  breakevenAnalysisCalculation(); //盈亏平衡分析计算
}

export function zongmove() {
  totalTable(); //总投资估算
  jingying(); //经营费用
  ranliao(); //燃料费用
  gzfl(); //工资福利费用
  deprecia(); //折旧费用
  amortization(); //摊销费用
  calculateOperatingRevenue(); //营业收入计算
  workingCapital(); //流动资金估算
  Financing(); //资金筹措及分年投资计划-----资金筹措
  // calculateAnnualInvestment(); //分年投资计划
  totalTable(); //总投资估算
  totalCost(); //总成本费用计算
  profitCalculation(); //利润计算
  allInvestmentCashFlowCalculation(); //分年投资现金流量计算
  capitalCashFlowCalculation(); //资本金现金流量计算
  //财务计划现金流量计算
  financialPlanCashFlowCalculation(); //财务计划现金流量计算
  calculateRepaymentPlan(); //还款计划计算
  breakevenAnalysisCalculation(); //盈亏平衡分析计算
}

// 利润计算函数
export function profitCalculation() {
  let projectData = store.state.projectData;

  // 检查数据结构是否完整
  if (!projectData || !projectData["基础数据"]) {
    console.warn("数据结构不完整，无法执行利润计算");
    return;
  }

  let jichu = projectData.基础数据;
  let profitData = projectData["营业收入税金及利润"] || {};

  // 确保利润数据结构存在
  if (!profitData["利润"]) {
    profitData["利润"] = {
      incomeTaxRate: 25, // 所得税率，默认25%，最高33%
      法定盈余公积金Rate: 10, // 法定盈余公积金比率，默认10%
      任意盈余公积金Rate: 0, // 任意盈余公积金比率，默认0%
      subsidyIncome: 0, // 补贴收入，默认0万元
      total: 0, // 利润总额合计
      netProfit: 0, // 净利润合计
      netProfitYear: [], // 分年净利润
      incomeTaxTotal: 0, // 所得税合计
      preferredStockRate: 0, // 优先股股利比率，默认0%

      year: [], // 分年利润总额
      netProfitYear: [], // 分年净利润
      incomeTaxYear: [], // 分年所得税
      法定盈余公积金Total: 0, // 法定盈余公积金合计
      任意盈余公积金Total: 0, // 任意盈余公积金合计
      法定盈余公积金Year: [], // 分年法定盈余公积金
      任意盈余公积金Year: [], // 分年任意盈余公积金
      // 新增利润表项目
      revenueTotal: 0, // 营业收入合计
      revenueByYear: [], // 分年营业收入
      businessTaxTotal: 0, // 营业税金及附加合计
      businessTaxByYear: [], // 分年营业税金及附加
      vatTotal: 0, // 增值税合计
      vatByYear: [], // 分年增值税
      totalCostTotal: 0, // 总成本费用合计
      totalCostByYear: [], // 分年总成本费用
      subsidyIncomeTotal: 0, // 补贴收入合计
      subsidyIncomeByYear: [], // 分年补贴收入
      profitBeforeTaxTotal: 0, // 利润总额合计
      profitBeforeTaxByYear: [], // 分年利润总额
      lossCompensationTotal: 0, // 弥补以前年度亏损合计
      lossCompensationByYear: [], // 分年弥补以前年度亏损
      taxableIncomeTotal: 0, // 应纳税所得额合计
      taxableIncomeByYear: [], // 分年应纳税所得额
      undistributedProfitTotal: 0, // 未分配利润合计
      undistributedProfitByYear: [], // 分年未分配利润
      ebitTotal: 0, // 息税前利润合计
      ebitByYear: [], // 分年息税前利润
      ebitdaTotal: 0, // 息税折旧摊销前利润合计
      ebitdaByYear: [], // 分年息税折旧摊销前利润
      ytaxableIncomeTotal: 0, //所税计算依据合计
      ytaxableIncomeByYear: [], //所得税计算依据分年
      beginningUndistributedProfitTotal: 0, // 期初未分配利润合计
      beginningUndistributedProfitByYear: [], //期初未分配利润分年
      availableForDistributionTotal: 0, //可供分配利润合计
      availableForDistributionByYear: [], //可供分配的利润合计
      availableForInvestorsTotal: 0, //可供投资者分配的利润合计
      availableForInvestorsByYear: [], //可供投资者分配的利润分年
      preferredStockDividendTotal: 0, // 应付优先股股利合计
      preferredStockDividendByYear: [], // 分年应付优先股股利
      commonDividendTotal: 0, // 分年普通股利合计
      commonDividendByYear: [], //分年普通股利
    };
  }

  let lirun = profitData["利润"];
  lirun.revenueByYear =
    projectData.营业收入税金及利润.营业收入及营业税金.revenueByYear;
  lirun.revenueTotal =
    projectData.营业收入税金及利润.营业收入及营业税金.revenuetotal;

  lirun.businessTaxByYear =
    projectData.营业收入税金及利润.营业收入及营业税金.additionaltaxByYear;
  lirun.businessTaxTotal =
    projectData.营业收入税金及利润.营业收入及营业税金.additionaltax;
  lirun.vatByYear =
    projectData.营业收入税金及利润.营业收入及营业税金.valueddedtax;
  lirun.vatTotal =
    projectData.营业收入税金及利润.营业收入及营业税金.valudedtotal;
  lirun.totalCostTotal = projectData.成本费用.总成本费用.total;
  lirun.totalCostByYear = projectData.成本费用.总成本费用.year;
  let zhejiu = projectData.成本费用.折旧.total.depreciationValues;
  let tanxiao = projectData.成本费用.摊销.total.depreciationValues;

  // 获取利润计算所需的参数

  lirun.incomeTaxRate = profitData["利润"].incomeTaxRate || 25; // 所得税率
  lirun.法定盈余公积金Rate = profitData["利润"].法定盈余公积金Rate || 10; // 法定盈余公积金比率
  lirun.任意盈余公积金Rate = profitData["利润"].任意盈余公积金Rate || 0; // 任意盈余公积金比率
  lirun.subsidyIncome = profitData["利润"].subsidyIncome || 0; // 补贴收入

  // 限制税率在合理范围内
  lirun.incomeTaxRate = Math.min(profitData["利润"].incomeTaxRate, 33); // 最高33%
  lirun.法定盈余公积金Rate = Math.max(
    0,
    Math.min(profitData["利润"].法定盈余公积金Rate, 30),
  ); // 0-100%
  lirun.任意盈余公积金Rate = Math.max(
    0,
    Math.min(profitData["利润"].任意盈余公积金Rate, 100),
  ); // 0-100%
  lirun.subsidyIncome = Math.max(0, profitData["利润"].subsidyIncome); // 补贴收入不能为负
  lirun.preferredStockDividendRate = Math.max(
    0,
    Math.min(profitData["利润"].preferredStockDividendRate || 0, 100),
  ); // 0-100%，默认0%

  // 获取计算期
  const calculationPeriod = jichu.calculationPeriod || 15; //计算期
  const operationPeriod = jichu.operationPeriod || 14; //运营期
  const constructionPeriod = jichu.constructionPeriod || 1; //建设期
  const jyfh = jichu.loadData || {}; //经营负荷
  // 将jyfh中的value转成数组，每个元素为Number类型
  const jyfhValues = Object.values(jyfh).map(Number); //经营负荷值
  const lixi = projectData.成本费用.利息.year || [];

  // 确保所有需要的数组存在且长度足够
  lirun.revenueByYear = lirun.revenueByYear || [];
  lirun.businessTaxByYear = lirun.businessTaxByYear || [];
  lirun.vatByYear = lirun.vatByYear || [];
  lirun.totalCostByYear = lirun.totalCostByYear || [];

  // 初始化结果数组
  lirun.subsidyIncomeByYear = [];
  lirun.subsidyIncomeTotal = 0;
  lirun.profitBeforeTaxByYear = [];
  lirun.profitBeforeTaxTotal = 0;
  lirun.lossCompensationByYear = [];
  lirun.lossCompensationTotal = 0;

  lirun.taxableIncomeByYear = [];
  lirun.taxableIncomeTotal = 0;

  lirun.incomeTaxYear = []; // 分年所得税
  lirun.incomeTaxByYear = []; // 分年所得税（用于利润表导出）
  lirun.incomeTaxTotal = 0; // 所得税合计
  lirun.netProfit = 0; // 净利润合计
  lirun.netProfitYear = []; // 分年净利润
  lirun.netProfitByYear = []; // 分年净利润（用于利润表导出）
  lirun.netProfitTotal = 0; // 净利润合计（用于利润表导出）
  lirun.beginningUndistributedProfitByYear = []; // 期初分年未分配利润
  lirun.beginningUndistributedProfitTotal = 0; // 期初未分配利润合计
  lirun.undistributedProfitTotal = 0; // 未分配利润合计
  lirun.undistributedProfitByYear = []; // 分年未分配利润
  lirun.availableForDistributionTotal = 0; //可供分配利润合计
  lirun.availableForDistributionByYear = []; //可供分配的利润合计
  lirun.法定盈余公积金Total = 0; // 法定盈余公积金合计
  lirun.任意盈余公积金Total = 0; // 任意盈余公积金合计
  lirun.法定盈余公积金Year = []; // 分年法定盈余公积金
  lirun.法定盈余公积金ByYear = []; // 分年法定盈余公积金（用于利润表导出）
  lirun.legalSurplusFundTotal = 0; // 法定盈余公积金合计（用于利润表导出）
  lirun.任意盈余公积金Year = []; // 分年任意盈余公积金
  lirun.任意盈余公积金ByYear = []; // 分年任意盈余公积金（用于利润表导出）
  lirun.arbitrarySurplusFundTotal = 0; // 任意盈余公积金合计（用于利润表导出）
  lirun.availableForInvestorsTotal = 0; //可供投资者分配的利润合计
  lirun.availableForInvestorsByYear = []; //可供投资者分配的利润分年
  lirun.preferredStockDividendTotal = 0; // 应付优先股股利合计
  lirun.preferredStockDividendByYear = []; //分年应付优先股股利
  lirun.commonDividendTotal = 0; // 分年普通股利合计
  lirun.commonDividendByYear = []; //分年普通股利
  lirun.undistributedProfitTotal = 0; // 未分配利润合计
  lirun.undistributedProfitByYear = []; // 分年未分配利润
  lirun.ebitTotal = 0; // EBIT
  lirun.ebitByYear = []; // 分年EBIT
  lirun.ebitdaTotal = 0; // EBITDA
  lirun.ebitdaByYear = []; // 分年EBITDA

  // 计算每年的利润
  let accumulatedLoss = 0; // 累计未弥补亏损
  // 获取流动资金贷款利息数据
  const workingCapitalLoanInterest = projectData.流动资金估算?.计算结果
    ?.workingCapitalLoanInterest || { year: [] };
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    // 补贴收入
    lirun.subsidyIncomeByYear[i] =
      ((jyfhValues[i] || 0) * lirun.subsidyIncome) / 100;
    lirun.subsidyIncomeTotal += lirun.subsidyIncomeByYear[i];
    // 利润总额
    lirun.profitBeforeTaxByYear[i] =
      (lirun.revenueByYear[i] || 0) -
      (lirun.businessTaxByYear[i] || 0) -
      (lirun.vatByYear[i] || 0) -
      (lirun.totalCostByYear[i] || 0) +
      lirun.subsidyIncomeByYear[i] -
      (workingCapitalLoanInterest.year[i] || 0);
    lirun.profitBeforeTaxTotal += lirun.profitBeforeTaxByYear[i];
    // 弥补以前年度亏损
    if (accumulatedLoss > 0) {
      // 如果有累计未弥补亏损，用当年利润总额弥补
      if (lirun.profitBeforeTaxByYear[i] > 0) {
        // 可弥补的亏损额 = min(当年利润总额, 累计未弥补亏损)
        const compensation = Math.min(
          lirun.profitBeforeTaxByYear[i],
          accumulatedLoss,
        );
        lirun.lossCompensationByYear[i] = compensation;
        lirun.lossCompensationTotal += compensation;
        // 减少累计未弥补亏损
        accumulatedLoss -= compensation;
      }
    } else if (lirun.profitBeforeTaxByYear[i] < 0) {
      // 如果当年亏损，增加累计未弥补亏损
      accumulatedLoss += Math.abs(lirun.profitBeforeTaxByYear[i]);
      lirun.lossCompensationByYear[i] = 0;
    } else {
      // 当年有利润且没有未弥补亏损
      lirun.lossCompensationByYear[i] = 0;
    }
    // 所税计算依据
    lirun.taxableIncomeByYear[i] =
      lirun.profitBeforeTaxByYear[i] - lirun.lossCompensationByYear[i] > 0
        ? lirun.profitBeforeTaxByYear[i] - lirun.lossCompensationByYear[i]
        : 0;
    lirun.taxableIncomeTotal += lirun.taxableIncomeByYear[i];
    // 所得税

    lirun.incomeTaxYear[i] =
      (lirun.taxableIncomeByYear[i] || 0) * (lirun.incomeTaxRate / 100);
    lirun.incomeTaxByYear[i] = lirun.incomeTaxYear[i]; // 同步到导出字段
    lirun.incomeTaxTotal += lirun.incomeTaxYear[i];
    // 净利润
    lirun.netProfitYear[i] =
      lirun.profitBeforeTaxByYear[i] - lirun.incomeTaxYear[i];
    lirun.netProfit += lirun.netProfitYear[i];
    // 期初未分配利润
    lirun.beginningUndistributedProfitByYear[i] =
      i === 0 ? 0 : lirun.undistributedProfitByYear[i - 1];
    lirun.beginningUndistributedProfitTotal +=
      lirun.beginningUndistributedProfitByYear[i];
    // 未分配利润
    lirun.availableForDistributionByYear[i] =
      lirun.netProfitYear[i] + lirun.beginningUndistributedProfitByYear[i];
    lirun.availableForDistributionTotal +=
      lirun.availableForDistributionByYear[i];
    // 法定盈余公积金
    lirun.法定盈余公积金Year[i] =
      lirun.netProfitYear[i] * (lirun.法定盈余公积金Rate / 100);
    lirun.法定盈余公积金Total += lirun.法定盈余公积金Year[i];
    lirun.任意盈余公积金Year[i] =
      lirun.netProfitYear[i] * (lirun.任意盈余公积金Rate / 100);
    lirun.任意盈余公积金Total += lirun.任意盈余公积金Year[i];
    // 14.可供投资者分配的利润
    lirun.availableForInvestorsByYear[i] =
      lirun.availableForDistributionByYear[i] - lirun.法定盈余公积金Year[i];
    lirun.availableForInvestorsTotal += lirun.availableForInvestorsByYear[i];
    //15. 应付优先股股利
    lirun.preferredStockDividendByYear[i] =
      lirun.availableForInvestorsByYear[i] < 0
        ? 0
        : lirun.availableForInvestorsByYear[i] *
          (lirun.preferredStockRate / 100);
    lirun.preferredStockDividendTotal += lirun.preferredStockDividendByYear[i];
    //16.任意盈余公积金
    lirun.任意盈余公积金Year[i] =
      lirun.netProfitYear[i] * ((lirun.任意盈余公积金Rate || 0) / 100);
    lirun.任意盈余公积金Total += lirun.任意盈余公积金Year[i];
    // 17.普通股利
    lirun.commonDividendByYear[i] =
      lirun.availableForInvestorsByYear[i] -
      lirun.preferredStockDividendByYear[i] -
      lirun.任意盈余公积金Year[i];
    lirun.commonDividendTotal += lirun.commonDividendByYear[i];
    // 未分配利润
    lirun.undistributedProfitByYear[i] =
      lirun.availableForDistributionByYear[i] -
      lirun.preferredStockDividendByYear[i] -
      lirun.任意盈余公积金Year[i];
    lirun.undistributedProfitTotal += lirun.undistributedProfitByYear[i];
    // 20. EBIT
    lirun.ebitByYear[i] =
      lirun.netProfitYear[i] + lirun.incomeTaxYear[i] + lixi[i];
    lirun.ebitTotal += lirun.ebitByYear[i];
    // 21. EBITDA
    lirun.ebitdaByYear[i] =
      lirun.ebitByYear[i] + (zhejiu[i] || 0) + (tanxiao[i] || 0);

    lirun.ebitdaTotal += lirun.ebitdaByYear[i];
  }

  // 计算利润率指标（使用正常年数据）
  const normalYear = jichu.normalYear || 1;
  const normalYearIndex = Math.max(0, normalYear - 1);

  // 获取正常年数据
  const normalYearRevenue = lirun.revenueByYear[normalYearIndex] || 0;
  const normalYearProfitBeforeTax =
    lirun.profitBeforeTaxByYear[normalYearIndex] || 0;
  const normalYearNetProfit = lirun.netProfitYear[normalYearIndex] || 0;

  // 获取总投资和资本金
  const totalInvestment = projectData.总投资估算?.总表?.总投资?.合计 || 0;
  const capitalAmount =
    projectData.资金筹措及分年投资计划?.资金筹措?.项目资本金?.amount || 0;

  // 计算利润率指标
  const profitMargins = {
    // 销售利润率
    salesProfitRate:
      normalYearRevenue > 0
        ? (normalYearProfitBeforeTax / normalYearRevenue) * 100
        : 0,
    salesNetProfitRate:
      normalYearRevenue > 0
        ? (normalYearNetProfit / normalYearRevenue) * 100
        : 0,

    // 投资利润率
    investmentProfitRate:
      totalInvestment > 0
        ? (normalYearProfitBeforeTax / totalInvestment) * 100
        : 0,
    investmentNetProfitRate:
      totalInvestment > 0 ? (normalYearNetProfit / totalInvestment) * 100 : 0,

    // 资本金利润率
    capitalProfitRate:
      capitalAmount > 0 ? (normalYearProfitBeforeTax / capitalAmount) * 100 : 0,
    capitalNetProfitRate:
      capitalAmount > 0 ? (normalYearNetProfit / capitalAmount) * 100 : 0,
  };

  // 将利润率指标添加到利润数据中
  lirun.profitMargins = profitMargins;

  projectData["营业收入税金及利润"]["利润"] = lirun;
  store.commit("SET_PROJECT_DATA", projectData);
  return { lirun, operationPeriod, constructionPeriod };
}
// 全部投资现金流量计算函数
export function allInvestmentCashFlowCalculation(a = {}) {
  let projectData = store.state.projectData;

  // 检查数据结构是否完整
  if (!projectData || !projectData["基础数据"]) {
    console.warn("数据结构不完整，无法执行全部投资现金流量计算");
    return;
  }

  let jichu = projectData.基础数据;
  const calculationPeriod = jichu.calculationPeriod || 12; // 计算期
  const constructionPeriod = jichu.constructionPeriod || 1; // 建设期
  let cashFlowData = projectData["盈利能力分析"] || {};

  // 确保现金流量数据结构存在
  if (!cashFlowData["全部投资现金流量"]) {
    cashFlowData["全部投资现金流量"] = {
      // 现金流入
      operatingRevenueByYear: [], // 营业收入
      operatingRevenueTotal: 0,
      subsidyIncomeByYear: [], // 补贴收入
      subsidyIncomeTotal: 0,
      recoveryFixedAssetsByYear: [], // 回收固定资产余值
      recoveryFixedAssetsTotal: 0,
      recoveryWorkingCapitalByYear: [], // 回收流动资金
      recoveryWorkingCapitalTotal: 0,
      totalCashInflowsByYear: [], // 现金流入合计
      totalCashInflowsTotal: 0,

      // 现金流出
      totalInvestmentByYear: [], // 总投资
      totalInvestmentTotal: 0,
      operatingCostsByYear: [], // 经营成本
      operatingCostsTotal: 0,
      businessTaxByYear: [], // 营业税金及附加
      businessTaxTotal: 0,
      vatByYear: [], // 增值税
      vatTotal: 0,
      incomeTaxByYear: [], // 所得税
      incomeTaxTotal: 0,
      totalCashOutflowsByYear: [], // 现金流出合计
      totalCashOutflowsTotal: 0,

      // 净现金流量
      netCashFlowByYear: [], // 净现金流量
      netCashFlowTotal: 0,

      // 折现净现金流量
      discountedNetCashFlowByYear: [], // 折现净现金流量
      discountedNetCashFlowTotal: 0, // NPV
      cumulativeDiscountedNetCashFlowByYear: [], // 累计折现净现金流量

      // 指标
      irr: 0, // 内部收益率
      paybackPeriod: 0, // 静态投资回收期
      discountedPaybackPeriod: 0, // 动态投资回收期
    };
  }

  let cashFlow = cashFlowData["全部投资现金流量"];
  const discountRate = jichu.discountRate || 10; // 基准收益率
  const jyfh = jichu.loadData || {}; // 经营负荷
  const jyfhValues = Object.values(jyfh).map(Number); // 经营负荷值

  // 获取所需数据
  const totalInvestment =
    projectData["总投资估算"]?.["总计"]?.["总投资"]?.["合计"] || 0;
  const operatingRevenue =
    projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
      "revenueByYear"
    ] || [];
  const subsidyIncome =
    projectData["营业收入税金及利润"]?.["利润"]?.["subsidyIncomeByYear"] || [];
  const operatingCosts = projectData["成本费用"]?.["经营成本"]?.["year"] || []; //经营成本
  const businessTax =
    projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
      "additionaltaxByYear"
    ] || []; // 营业税金及附加
  const vat =
    projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
      "valueddedtax"
    ] || []; // 增值税
  const incomeTax =
    projectData["营业收入税金及利润"]?.["利润"]?.["incomeTaxYear"] || [];

  // 分配总投资到各年（假设建设期内均匀投入）
  cashFlow.totalInvestmentByYear = [];
  cashFlow.totalInvestmentTotal = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    cashFlow.totalInvestmentByYear[i] =
      projectData["资金筹措及分年投资计划"]?.["分年投资计划"]?.["总投资"]?.year[
        i
      ] || 0;
  }
  cashFlow.totalInvestmentTotal =
    projectData["资金筹措及分年投资计划"]?.["分年投资计划"]?.["总投资"]
      ?.amount || 0;
  // console.log("总投资", cashFlow.totalInvestmentByYear);

  // 计算现金流入
  cashFlow.operatingRevenueByYear = [...operatingRevenue];
  cashFlow.operatingRevenueTotal = operatingRevenue.reduce(
    (sum, val) => sum + (val || 0),
    0,
  );

  cashFlow.subsidyIncomeByYear = [...subsidyIncome];
  cashFlow.subsidyIncomeTotal = subsidyIncome.reduce(
    (sum, val) => sum + (val || 0),
    0,
  );

  // 回收固定资产余值（假设最后一年回收）
  cashFlow.recoveryFixedAssetsByYear = Array(calculationPeriod).fill(0);
  cashFlow.recoveryFixedAssetsByYear[calculationPeriod - 1] =
    projectData["成本费用"]?.["折旧"]?.["total"]?.NAVatEOP || 0; // 假设固定资产残值等于折旧后的账面价值
  cashFlow.recoveryFixedAssetsTotal =
    cashFlow.recoveryFixedAssetsByYear[calculationPeriod - 1];

  // 回收流动资金（假设最后一年回收）
  const workingCapital =
    projectData["流动资金估算"]?.["计算结果"]?.["equityIncreaseThisYear"]
      ?.total || 0;
  cashFlow.recoveryWorkingCapitalByYear = Array(calculationPeriod).fill(0);
  cashFlow.recoveryWorkingCapitalByYear[calculationPeriod - 1] = workingCapital;
  cashFlow.recoveryWorkingCapitalTotal = workingCapital;

  // 现金流入合计
  cashFlow.totalCashInflowsByYear = [];
  cashFlow.totalCashInflowsTotal = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    cashFlow.totalCashInflowsByYear[i] =
      (cashFlow.operatingRevenueByYear[i] || 0) * (1 + (a.产品 || 0)) +
      (cashFlow.subsidyIncomeByYear[i] || 0) +
      (cashFlow.recoveryFixedAssetsByYear[i] || 0) +
      (cashFlow.recoveryWorkingCapitalByYear[i] || 0);
    cashFlow.totalCashInflowsTotal += cashFlow.totalCashInflowsByYear[i];
  }

  // 计算现金流出
  cashFlow.operatingCostsByYear = [...operatingCosts];
  cashFlow.operatingCostsTotal = operatingCosts.reduce(
    (sum, val) => sum + (val || 0),
    0,
  );

  cashFlow.businessTaxByYear = [...businessTax];
  cashFlow.businessTaxTotal = businessTax.reduce(
    (sum, val) => sum + (val || 0),
    0,
  );

  cashFlow.vatByYear = [...vat];
  cashFlow.vatTotal = vat.reduce((sum, val) => sum + (val || 0), 0);

  cashFlow.incomeTaxByYear = [...incomeTax];
  cashFlow.incomeTaxTotal = incomeTax.reduce((sum, val) => sum + (val || 0), 0);

  // 现金流出合计
  cashFlow.totalCashOutflowsByYear = [];
  cashFlow.totalCashOutflowsTotal = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    // 修复：当变化率为0时，原料率不影响结果，确保所有指标变化为0时结果一致

    let 原料系数 = 1 - (a.原料率 || 0) + (1 + (a.原料 || 0)) * (a.原料率 || 0);

    cashFlow.totalCashOutflowsByYear[i] =
      (cashFlow.totalInvestmentByYear[i] || 0) * (1 + (a.建投 || 0)) +
      (cashFlow.operatingCostsByYear[i] || 0) * (原料系数 || 0) +
      (cashFlow.businessTaxByYear[i] || 0) +
      (cashFlow.vatByYear[i] || 0) +
      (cashFlow.incomeTaxByYear[i] || 0);
    cashFlow.totalCashOutflowsTotal += cashFlow.totalCashOutflowsByYear[i];
  }

  // 计算净现金流量
  cashFlow.netCashFlowByYear = [];
  cashFlow.netCashFlowTotal = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    cashFlow.netCashFlowByYear[i] =
      cashFlow.totalCashInflowsByYear[i] - cashFlow.totalCashOutflowsByYear[i];
    cashFlow.netCashFlowTotal += cashFlow.netCashFlowByYear[i];
  }

  // 计算折现净现金流量
  cashFlow.discountedNetCashFlowByYear = [];
  cashFlow.discountedNetCashFlowTotal = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    const discountFactor = Math.pow(1 + discountRate / 100, i + 1); // 第i年对应t=0，折现率为(1+r)^1
    cashFlow.discountedNetCashFlowByYear[i] =
      cashFlow.netCashFlowByYear[i] / discountFactor;
    cashFlow.discountedNetCashFlowTotal +=
      cashFlow.discountedNetCashFlowByYear[i];
  }

  // 计算累计折现净现金流量
  cashFlow.cumulativeDiscountedNetCashFlowByYear = [];
  let cumulative = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    cumulative += cashFlow.discountedNetCashFlowByYear[i];
    cashFlow.cumulativeDiscountedNetCashFlowByYear[i] = cumulative;
  }

  // 计算静态投资回收期
  cashFlow.paybackPeriod = 0;
  let cumulativeNetCashFlow = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    cumulativeNetCashFlow += cashFlow.netCashFlowByYear[i];
    if (cumulativeNetCashFlow >= 0 && cashFlow.paybackPeriod === 0) {
      if (i === 0) {
        cashFlow.paybackPeriod = i + 1; // 第一年就回收
      } else {
        const previousCumulative =
          cumulativeNetCashFlow - cashFlow.netCashFlowByYear[i];
        cashFlow.paybackPeriod =
          i + Math.abs(previousCumulative) / cashFlow.netCashFlowByYear[i];
      }
    }
  }

  // 计算动态投资回收期
  cashFlow.discountedPaybackPeriod = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    if (
      cashFlow.cumulativeDiscountedNetCashFlowByYear[i] >= 0 &&
      cashFlow.discountedPaybackPeriod === 0
    ) {
      if (i === 0) {
        cashFlow.discountedPaybackPeriod = i + 1; // 第一年就回收
      } else {
        const previousCumulative =
          cashFlow.cumulativeDiscountedNetCashFlowByYear[i - 1];
        cashFlow.discountedPaybackPeriod =
          i +
          Math.abs(previousCumulative) /
            cashFlow.discountedNetCashFlowByYear[i];
      }
    }
  }

  // 计算内部收益率IRR（使用试算法）
  // 计算税后指标
  cashFlow.irr = calculateIRR(cashFlow.netCashFlowByYear);

  // 计算税前指标
  // 复制净现金流量数组，用于计算税前指标
  const netCashFlowBeforeTax = [...cashFlow.netCashFlowByYear];
  // 计算税前净现金流量（加上所得税）
  for (let i = 0; i < calculationPeriod; i++) {
    netCashFlowBeforeTax[i] += cashFlow.incomeTaxByYear[i] || 0;
  }
  // 计算税前内部收益率
  cashFlow.irrBeforeTax = calculateIRR(netCashFlowBeforeTax);

  // 计算税前净现值
  cashFlow.discountedNetCashFlowTotalBeforeTax = 0;
  for (let i = 0; i < calculationPeriod; i++) {
    const discountFactor = Math.pow(1 + discountRate / 100, i + 1);
    cashFlow.discountedNetCashFlowTotalBeforeTax +=
      netCashFlowBeforeTax[i] / discountFactor;
  }

  // 计算税前静态投资回收期
  cashFlow.paybackPeriodBeforeTax = 0;
  let cumulativeNetCashFlowBeforeTax = 0;
  for (let i = 0; i < calculationPeriod; i++) {
    cumulativeNetCashFlowBeforeTax += netCashFlowBeforeTax[i];
    if (
      cumulativeNetCashFlowBeforeTax >= 0 &&
      cashFlow.paybackPeriodBeforeTax === 0
    ) {
      if (i > 0) {
        const previousCumulative =
          cumulativeNetCashFlowBeforeTax - netCashFlowBeforeTax[i];
        cashFlow.paybackPeriodBeforeTax =
          i + Math.abs(previousCumulative) / netCashFlowBeforeTax[i];
      }
    }
  }

  // 计算税前动态投资回收期
  cashFlow.discountedPaybackPeriodBeforeTax = 0;
  let cumulativeDiscountedBeforeTax = 0;
  for (let i = 0; i < calculationPeriod; i++) {
    const discountFactor = Math.pow(1 + discountRate / 100, i + 1);
    cumulativeDiscountedBeforeTax += netCashFlowBeforeTax[i] / discountFactor;
    if (
      cumulativeDiscountedBeforeTax >= 0 &&
      cashFlow.discountedPaybackPeriodBeforeTax === 0
    ) {
      if (i > 0) {
        const previousCumulative =
          cumulativeDiscountedBeforeTax -
          netCashFlowBeforeTax[i] / discountFactor;
        cashFlow.discountedPaybackPeriodBeforeTax =
          i +
          Math.abs(previousCumulative) /
            (netCashFlowBeforeTax[i] / discountFactor);
      }
    }
  }
  if (JSON.stringify(a) == "{}") {
    // 保存到Vuex
    projectData["盈利能力分析"] = cashFlowData;
    store.commit("SET_PROJECT_DATA", projectData);

    return {
      cashFlow,
      calculationPeriod, // 计算期
      constructionPeriod, // 建设期
      discountRate,
    };
  } else {
    return cashFlow.irr;
  }
}

// 财务计划现金流量表
// 盈亏平衡分析计算
export function breakevenAnalysisCalculation() {
  let projectData = store.state.projectData;
  const defaultCalculationPeriod = 15;

  // 检查数据结构是否完整
  if (!projectData || !projectData["基础数据"]) {
    console.warn("数据结构不完整，无法执行盈亏平衡分析");

    // 返回默认值
    const defaultBreakevenData = {
      annualRevenueByYear: Array(defaultCalculationPeriod).fill(0),
      salesTaxByYear: Array(defaultCalculationPeriod).fill(0),
      vatByYear: Array(defaultCalculationPeriod).fill(0),
      variableCostByYear: Array(defaultCalculationPeriod).fill(0),
      fixedCostByYear: Array(defaultCalculationPeriod).fill(0),
      bepUtilizationRateByYear: Array(defaultCalculationPeriod).fill(0),
      calculationPeriod: defaultCalculationPeriod,
    };
    return defaultBreakevenData;
  }

  let jichu = projectData.基础数据;
  const calculationPeriod = jichu.calculationPeriod || defaultCalculationPeriod;
  const constructionPeriod = jichu.constructionPeriod || 1;

  // 初始化结果数据
  const breakevenData = {
    annualRevenueByYear: Array(calculationPeriod).fill(0),
    salesTaxByYear: Array(calculationPeriod).fill(0),
    vatByYear: Array(calculationPeriod).fill(0),
    variableCostByYear: Array(calculationPeriod).fill(0),
    fixedCostByYear: Array(calculationPeriod).fill(0),
    bepUtilizationRateByYear: Array(calculationPeriod).fill(0),
    calculationPeriod: calculationPeriod,
  };

  // 从项目数据中获取所需数据
  const costData = projectData["成本费用"] || {};

  // 填充建设期数据（建设期内无生产，数据均为0）
  for (let i = 0; i < constructionPeriod; i++) {
    breakevenData.annualRevenueByYear[i] = 0;
    breakevenData.salesTaxByYear[i] = 0;
    breakevenData.vatByYear[i] = 0;
    breakevenData.variableCostByYear[i] = 0;
    breakevenData.fixedCostByYear[i] = 0;
    breakevenData.bepUtilizationRateByYear[i] = 0;
  }

  // 填充经营期数据
  for (let i = constructionPeriod; i < calculationPeriod; i++) {
    // 从各年数据中获取
    breakevenData.annualRevenueByYear[i] =
      projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
        "revenueByYear"
      ]?.[i] || 0;
    breakevenData.salesTaxByYear[i] =
      projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
        "additionaltaxByYear"
      ]?.[i] || 0;
    breakevenData.vatByYear[i] =
      projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
        "valueddedtax"
      ]?.[i] || 0;

    // 固定成本
    breakevenData.fixedCostByYear[i] =
      projectData["成本费用"]?.["固定成本"]?.["year"]?.[i] || 0;

    // 可变成本
    breakevenData.variableCostByYear[i] =
      projectData["成本费用"]?.["可变成本"]?.["year"]?.[i] || 0;

    // 计算盈亏平衡点产能利用率
    const contributionMargin =
      breakevenData.annualRevenueByYear[i] -
      breakevenData.variableCostByYear[i];
    if (contributionMargin > 0) {
      breakevenData.bepUtilizationRateByYear[i] =
        (breakevenData.fixedCostByYear[i] / contributionMargin) * 100;
    } else {
      breakevenData.bepUtilizationRateByYear[i] = 0;
    }
  }

  // 保存结果到VUEX
  // 创建projectData的深拷贝，避免直接修改store中的数据
  const updatedProjectData = projectData;

  if (!updatedProjectData.不确定性分析) {
    updatedProjectData.不确定性分析 = {};
  }
  updatedProjectData.不确定性分析.盈亏平衡分析 = breakevenData;

  // 提交更新后的数据到Vuex
  store.commit("SET_PROJECT_DATA", updatedProjectData);

  return breakevenData;
}

function calculateIRR(cashFlows, precision = 0.0001) {
  // 检查现金流量数组是否有效
  if (!cashFlows || cashFlows.length === 0) {
    return 0;
  }

  // 初始化IRR计算参数
  let lowRate = -0.99;
  let highRate = 10;
  let npvLow, npvHigh;

  // 计算初始NPV值
  npvLow = calculateNPV(cashFlows, lowRate);
  npvHigh = calculateNPV(cashFlows, highRate);

  // 扩展搜索范围，如果初始范围无法找到IRR
  let expansionCount = 0;
  const maxExpansions = 10;

  while (npvLow * npvHigh > 0 && expansionCount < maxExpansions) {
    // 扩展搜索范围
    lowRate *= 2;
    highRate *= 2;
    npvLow = calculateNPV(cashFlows, lowRate);
    npvHigh = calculateNPV(cashFlows, highRate);
    expansionCount++;
  }

  // 如果仍然无法找到IRR，返回0
  if (npvLow * npvHigh > 0) {
    return 0;
  }

  // 二分法迭代计算IRR
  while (Math.abs(highRate - lowRate) > precision) {
    const midRate = (lowRate + highRate) / 2;
    const npvMid = calculateNPV(cashFlows, midRate);

    if (npvMid === 0) {
      return midRate * 100;
    } else if (npvMid * npvLow < 0) {
      highRate = midRate;
      npvHigh = npvMid;
    } else {
      lowRate = midRate;
      npvLow = npvMid;
    }
  }

  // 返回最终IRR值（转换为百分比）
  return ((lowRate + highRate) / 2) * 100;
}

function calculateNPV(cashFlows, rate) {
  let npv = 0;
  for (let i = 0; i < cashFlows.length; i++) {
    npv += cashFlows[i] / Math.pow(1 + rate, i + 1);
  }
  return npv;
}

// 资本金现金流量表
export function capitalCashFlowCalculation() {
  let projectData = store.state.projectData;

  // 确保项目数据存在
  if (!projectData) {
    console.error("项目数据不存在");
    return {
      cashFlow: {},
      calculationPeriod: 12,
      constructionPeriod: 1,
      discountRate: 10,
    };
  }

  // 获取数据
  let jichu = projectData["基础数据"];
  let cashFlowData = projectData["盈利能力分析"] || {};

  const calculationPeriod = jichu?.calculationPeriod || 12; // 计算期
  const constructionPeriod = jichu?.constructionPeriod || 1; // 计算期
  const discountRate = jichu?.discountRate || 10; // 折现率

  // 确保现金流数据结构存在，仅在不存在时创建需要的项目

  if (!cashFlowData["资本金现金流量表"]) {
    cashFlowData["资本金现金流量表"] = {
      // 现金流入项目
      cashInflowByYear: Array(calculationPeriod).fill(0), // 现金流入小计
      cashInflowTotal: 0,
      operatingRevenueByYear: Array(calculationPeriod).fill(0), // 营业收入
      operatingRevenueTotal: 0,
      subsidyIncomeByYear: Array(calculationPeriod).fill(0), // 补贴收入
      subsidyIncomeTotal: 0,
      recoveryFixedAssetsByYear: Array(calculationPeriod).fill(0), // 回收固定资产余值
      recoveryFixedAssetsTotal: 0,

      recoveryWorkingCapitalByYear: Array(calculationPeriod).fill(0), // 回收流动资金
      recoveryWorkingCapitalTotal: 0,
      otherCashInflowByYear: Array(calculationPeriod).fill(0), // 其他现金流入
      otherCashInflowTotal: 0,

      // 现金流出项目
      cashOutflowByYear: Array(calculationPeriod).fill(0), // 现金流出小计
      cashOutflowTotal: 0,
      equityInvestmentByYear: Array(calculationPeriod).fill(0), // 项目资本金
      equityInvestmentTotal: 0,
      debtPrincipalRepaymentByYear: Array(calculationPeriod).fill(0), // 偿还债务本金
      debtPrincipalRepaymentTotal: 0,
      利息支出ByYear: Array(calculationPeriod).fill(0), // 利息支出
      利息支出Total: 0,
      operatingCostByYear: Array(calculationPeriod).fill(0), // 经营成本
      operatingCostTotal: 0,
      salesTaxByYear: Array(calculationPeriod).fill(0), // 营业税金及附加
      salesTaxTotal: 0,
      vatByYear: Array(calculationPeriod).fill(0), // 增值税
      vatTotal: 0,
      incomeTaxByYear: Array(calculationPeriod).fill(0), // 所得税
      incomeTaxTotal: 0,
      otherCashOutflowByYear: Array(calculationPeriod).fill(0), // 其他现金流出
      otherCashOutflowTotal: 0,

      // 净现金流量
      netCashFlowByYear: Array(calculationPeriod).fill(0), // 净现金流量(现金流入-现金流出)
      netCashFlowTotal: 0,
      cumulativeNetCashFlowByYear: Array(calculationPeriod).fill(0), // 累计净现金流量

      // 折现净现金流量
      discountedNetCashFlowByYear: Array(calculationPeriod).fill(0), // 折现净现金流量
      discountedNetCashFlowTotal: 0, // FNPV
      cumulativeDiscountedNetCashFlowByYear: Array(calculationPeriod).fill(0), // 累计折现净现金流量

      // 指标
      irr: 0, // 内部收益率(FIRR)
      paybackPeriod: 0, // 静态投资回收期
      discountedPaybackPeriod: 0, // 动态投资回收期
    };
  }

  let cashFlow = cashFlowData["资本金现金流量表"];

  // 确保所有必要的属性都已初始化
  const requiredProperties = {
    // 现金流入项目
    cashInflowByYear: Array(calculationPeriod).fill(0),
    cashInflowTotal: 0,
    operatingRevenueByYear: Array(calculationPeriod).fill(0),
    operatingRevenueTotal: 0,
    subsidyIncomeByYear: Array(calculationPeriod).fill(0),
    subsidyIncomeTotal: 0,
    recoveryFixedAssetsByYear: Array(calculationPeriod).fill(0),
    recoveryFixedAssetsTotal: 0,
    recoveryWorkingCapitalByYear: Array(calculationPeriod).fill(0),
    recoveryWorkingCapitalTotal: 0,
    otherCashInflowByYear: Array(calculationPeriod).fill(0),
    otherCashInflowTotal: 0,

    // 现金流出项目
    cashOutflowByYear: Array(calculationPeriod).fill(0),
    cashOutflowTotal: 0,
    equityInvestmentByYear: Array(calculationPeriod).fill(0),
    equityInvestmentTotal: 0,
    debtPrincipalRepaymentByYear: Array(calculationPeriod).fill(0),
    debtPrincipalRepaymentTotal: 0,
    利息支出ByYear: Array(calculationPeriod).fill(0),
    利息支出Total: 0,
    operatingCostByYear: Array(calculationPeriod).fill(0),
    operatingCostTotal: 0,
    salesTaxByYear: Array(calculationPeriod).fill(0),
    salesTaxTotal: 0,
    vatByYear: Array(calculationPeriod).fill(0),
    vatTotal: 0,
    incomeTaxByYear: Array(calculationPeriod).fill(0),
    incomeTaxTotal: 0,
    otherCashOutflowByYear: Array(calculationPeriod).fill(0),
    otherCashOutflowTotal: 0,

    // 净现金流量
    netCashFlowByYear: Array(calculationPeriod).fill(0),
    netCashFlowTotal: 0,
    cumulativeNetCashFlowByYear: Array(calculationPeriod).fill(0),
    // 税前净现金流量
    netCashFlowBeforeTaxByYear: Array(calculationPeriod).fill(0),
    cumulativeNetCashFlowBeforeTaxByYear: Array(calculationPeriod).fill(0),

    // 折现净现金流量
    discountedNetCashFlowByYear: Array(calculationPeriod).fill(0),
    discountedNetCashFlowTotal: 0,
    cumulativeDiscountedNetCashFlowByYear: Array(calculationPeriod).fill(0),
    // 税前折现净现金流量
    discountedNetCashFlowBeforeTaxByYear: Array(calculationPeriod).fill(0),
    discountedNetCashFlowBeforeTaxTotal: 0,
    cumulativeDiscountedNetCashFlowBeforeTaxByYear:
      Array(calculationPeriod).fill(0),

    // 指标
    irr: 0,
    irrBeforeTax: 0,
    paybackPeriod: 0,
    paybackPeriodBeforeTax: 0,
    discountedPaybackPeriod: 0,
    discountedPaybackPeriodBeforeTax: 0,
  };

  // 确保所有必要字段都已定义
  Object.keys(requiredProperties).forEach((key) => {
    if (!cashFlow.hasOwnProperty(key)) {
      cashFlow[key] = requiredProperties[key];
    } else if (key.endsWith("ByYear")) {
      // 确保数组长度正确
      cashFlow[key] = cashFlow[key]
        .slice(0, calculationPeriod)
        .concat(
          Array(Math.max(0, calculationPeriod - cashFlow[key].length)).fill(0),
        );
    }
  });

  // 获取数据，并确保所有数组都已初始化
  const operatingRevenue = Array.isArray(
    projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
      "revenueByYear"
    ],
  )
    ? projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
        "revenueByYear"
      ]
    : [];
  const subsidyIncome = Array.isArray(
    projectData["营业收入税金及利润"]?.["利润"]?.["subsidyIncomeByYear"],
  )
    ? projectData["营业收入税金及利润"]?.["利润"]?.["subsidyIncomeByYear"]
    : [];
  const operatingCosts = Array.isArray(
    projectData["成本费用"]?.["经营成本"]?.["year"],
  )
    ? projectData["成本费用"]?.["经营成本"]?.["year"]
    : [];
  const businessTax = Array.isArray(
    projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
      "additionaltaxByYear"
    ],
  )
    ? projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
        "additionaltaxByYear"
      ]
    : [];
  const vat = Array.isArray(
    projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.["valueddedtax"],
  )
    ? projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
        "valueddedtax"
      ]
    : [];
  const incomeTax = Array.isArray(
    projectData["营业收入税金及利润"]?.["利润"]?.["incomeTaxYear"],
  )
    ? projectData["营业收入税金及利润"]?.["利润"]?.["incomeTaxYear"]
    : [];
  const 利息支出 = Array.isArray(projectData["成本费用"]?.["利息"]?.year)
    ? projectData["成本费用"]?.["利息"]?.year
    : [];

  const equityInvestment = Array.isArray(
    projectData["资金筹措及分年投资计划"]?.["分年投资计划"]?.["资金筹措"]?.[
      "资本金"
    ]?.year,
  )
    ? projectData["资金筹措及分年投资计划"]?.["分年投资计划"]?.["资金筹措"]?.[
        "资本金"
      ]?.year
    : [];

  const debtPrincipalRepayment = Array.isArray(
    projectData["资金筹措及分年投资计划"]?.["资金筹措"]?.["债务资金"]
      ?.principal,
  )
    ? projectData["资金筹措及分年投资计划"]?.["资金筹措"]?.["债务资金"]
        ?.principal
    : [];

  // 回收固定资产余值(最后一年回收)
  const recoveryFixedAssets =
    projectData["成本费用"]?.["折旧"]?.["total"]?.NAVatEOP || 0;

  // 回收流动资金(最后一年回收)
  const recoveryWorkingCapital =
    projectData["流动资金估算"]?.["计算结果"]?.["equityIncreaseThisYear"]?.[
      "total"
    ] || 0;

  // 确保所有必要的数组都已初始化
  const arrayProperties = [
    "operatingRevenueByYear",
    "subsidyIncomeByYear",
    "recoveryFixedAssetsByYear",
    "recoveryWorkingCapitalByYear",
    "otherCashInflowByYear",
    "cashInflowByYear",
    "equityInvestmentByYear",
    "debtPrincipalRepaymentByYear",
    "利息支出ByYear",
    "operatingCostByYear",
    "salesTaxByYear",
    "vatByYear",
    "incomeTaxByYear",
    "otherCashOutflowByYear",
    "cashOutflowByYear",
    "netCashFlowByYear",
    "netCashFlowBeforeTaxByYear",
    "cumulativeNetCashFlowByYear",
    "cumulativeNetCashFlowBeforeTaxByYear",
  ];

  arrayProperties.forEach((prop) => {
    if (!Array.isArray(cashFlow[prop])) {
      cashFlow[prop] = Array(calculationPeriod).fill(0);
    } else if (cashFlow[prop].length < calculationPeriod) {
      // 确保数组长度足够
      cashFlow[prop] = [
        ...cashFlow[prop],
        ...Array(calculationPeriod - cashFlow[prop].length).fill(0),
      ];
    }
  });

  // 计算结果
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    // 现金流入项目
    cashFlow.operatingRevenueByYear[i] = operatingRevenue[i] || 0;
    cashFlow.subsidyIncomeByYear[i] = subsidyIncome[i] || 0;
    cashFlow.recoveryFixedAssetsByYear[i] =
      i === calculationPeriod - 1 ? recoveryFixedAssets : 0;
    cashFlow.recoveryWorkingCapitalByYear[i] =
      i === calculationPeriod - 1 ? recoveryWorkingCapital : 0;
    cashFlow.otherCashInflowByYear[i] = 0;

    // 现金流入小计
    cashFlow.cashInflowByYear[i] =
      cashFlow.operatingRevenueByYear[i] +
      cashFlow.subsidyIncomeByYear[i] +
      cashFlow.recoveryFixedAssetsByYear[i] +
      cashFlow.recoveryWorkingCapitalByYear[i] +
      cashFlow.otherCashInflowByYear[i];

    // 现金流出项目
    cashFlow.equityInvestmentByYear[i] = equityInvestment[i] || 0;
    cashFlow.debtPrincipalRepaymentByYear[i] = debtPrincipalRepayment[i] || 0;
    cashFlow.利息支出ByYear[i] = 利息支出[i] || 0;
    cashFlow.operatingCostByYear[i] = operatingCosts[i] || 0;
    cashFlow.salesTaxByYear[i] = businessTax[i] || 0;
    cashFlow.vatByYear[i] = vat[i] || 0;
    cashFlow.incomeTaxByYear[i] = incomeTax[i] || 0;
    cashFlow.otherCashOutflowByYear[i] = 0;

    // 现金流出小计
    cashFlow.cashOutflowByYear[i] =
      cashFlow.equityInvestmentByYear[i] +
      cashFlow.debtPrincipalRepaymentByYear[i] +
      cashFlow.利息支出ByYear[i] +
      cashFlow.operatingCostByYear[i] +
      cashFlow.salesTaxByYear[i] +
      cashFlow.vatByYear[i] +
      cashFlow.incomeTaxByYear[i] +
      cashFlow.otherCashOutflowByYear[i];

    // 净现金流量 = 现金流入 - 现金流出
    cashFlow.netCashFlowByYear[i] =
      cashFlow.cashInflowByYear[i] - cashFlow.cashOutflowByYear[i];

    // 税前净现金流量 = 现金流入 - 现金流出 + 所得税（即不扣除所得税的净现金流量）
    cashFlow.netCashFlowBeforeTaxByYear[i] =
      cashFlow.cashInflowByYear[i] -
      (cashFlow.cashOutflowByYear[i] - cashFlow.incomeTaxByYear[i]);
  }

  // 计算累计净现金流量
  let cumulativeNetCashFlow = 0;
  let cumulativeNetCashFlowBeforeTax = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    cumulativeNetCashFlow += cashFlow.netCashFlowByYear[i];
    cashFlow.cumulativeNetCashFlowByYear[i] = cumulativeNetCashFlow;

    // 计算税前累计净现金流量
    cumulativeNetCashFlowBeforeTax += cashFlow.netCashFlowBeforeTaxByYear[i];
    cashFlow.cumulativeNetCashFlowBeforeTaxByYear[i] =
      cumulativeNetCashFlowBeforeTax;
  }

  cashFlow.discountedNetCashFlowByYear = [];
  cashFlow.discountedNetCashFlowTotal = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    const discountFactor = Math.pow(1 + discountRate / 100, i + 1); // 第i年对应的折现因子为(1+r)^(i+1)
    cashFlow.discountedNetCashFlowByYear[i] =
      cashFlow.netCashFlowByYear[i] / discountFactor;
    cashFlow.discountedNetCashFlowTotal +=
      cashFlow.discountedNetCashFlowByYear[i];
  }

  cashFlow.cumulativeDiscountedNetCashFlowByYear = [];
  let cumulativeDiscounted = 0;
  // 计算各年投资活动现金流量
  for (let i = 0; i < calculationPeriod; i++) {
    cumulativeDiscounted += cashFlow.discountedNetCashFlowByYear[i];
    cashFlow.cumulativeDiscountedNetCashFlowByYear[i] = cumulativeDiscounted;
  }

  // 计算税前折现净现金流量
  cashFlow.discountedNetCashFlowBeforeTaxByYear = [];
  cashFlow.discountedNetCashFlowBeforeTaxTotal = 0;
  for (let i = 0; i < calculationPeriod; i++) {
    const discountFactor = Math.pow(1 + discountRate / 100, i + 1); // 第i年对应的折现因子为(1+r)^(i+1)
    cashFlow.discountedNetCashFlowBeforeTaxByYear[i] =
      cashFlow.netCashFlowBeforeTaxByYear[i] / discountFactor;
    cashFlow.discountedNetCashFlowBeforeTaxTotal +=
      cashFlow.discountedNetCashFlowBeforeTaxByYear[i];
  }

  // 计算税前累计折现净现金流量
  cashFlow.cumulativeDiscountedNetCashFlowBeforeTaxByYear = [];
  let cumulativeDiscountedBeforeTax = 0;
  for (let i = 0; i < calculationPeriod; i++) {
    cumulativeDiscountedBeforeTax +=
      cashFlow.discountedNetCashFlowBeforeTaxByYear[i];
    cashFlow.cumulativeDiscountedNetCashFlowBeforeTaxByYear[i] =
      cumulativeDiscountedBeforeTax;
  }

  // 计算静态投资回收期（税后）
  cashFlow.paybackPeriod = 0;
  cumulativeNetCashFlow = 0;
  for (let i = 0; i < calculationPeriod; i++) {
    cumulativeNetCashFlow += cashFlow.netCashFlowByYear[i];
    if (cumulativeNetCashFlow >= 0 && cashFlow.paybackPeriod === 0) {
      if (i === 0) {
        cashFlow.paybackPeriod = 0;
      } else {
        const previousCumulative =
          cumulativeNetCashFlow - cashFlow.netCashFlowByYear[i];
        cashFlow.paybackPeriod =
          i + Math.abs(previousCumulative) / cashFlow.netCashFlowByYear[i];
      }
    }
  }

  // 计算静态投资回收期（税前）
  cashFlow.paybackPeriodBeforeTax = 0;
  cumulativeNetCashFlowBeforeTax = 0;
  for (let i = 0; i < calculationPeriod; i++) {
    cumulativeNetCashFlowBeforeTax += cashFlow.netCashFlowBeforeTaxByYear[i];
    if (
      cumulativeNetCashFlowBeforeTax >= 0 &&
      cashFlow.paybackPeriodBeforeTax === 0
    ) {
      if (i === 0) {
        cashFlow.paybackPeriodBeforeTax = 0;
      } else {
        const previousCumulative =
          cumulativeNetCashFlowBeforeTax -
          cashFlow.netCashFlowBeforeTaxByYear[i];
        cashFlow.paybackPeriodBeforeTax =
          i +
          Math.abs(previousCumulative) / cashFlow.netCashFlowBeforeTaxByYear[i];
      }
    }
  }

  // 计算动态投资回收期（税后）
  cashFlow.discountedPaybackPeriod = 0;
  for (let i = 0; i < calculationPeriod; i++) {
    if (
      cashFlow.cumulativeDiscountedNetCashFlowByYear[i] >= 0 &&
      cashFlow.discountedPaybackPeriod === 0
    ) {
      if (i === 0) {
        cashFlow.discountedPaybackPeriod = 0;
      } else {
        const previousCumulative =
          cashFlow.cumulativeDiscountedNetCashFlowByYear[i - 1];
        cashFlow.discountedPaybackPeriod =
          i +
          Math.abs(previousCumulative) /
            cashFlow.discountedNetCashFlowByYear[i];
      }
    }
  }

  // 计算动态投资回收期（税前）
  cashFlow.discountedPaybackPeriodBeforeTax = 0;
  for (let i = 0; i < calculationPeriod; i++) {
    if (
      cashFlow.cumulativeDiscountedNetCashFlowBeforeTaxByYear[i] >= 0 &&
      cashFlow.discountedPaybackPeriodBeforeTax === 0
    ) {
      if (i === 0) {
        cashFlow.discountedPaybackPeriodBeforeTax = 0;
      } else {
        const previousCumulative =
          cashFlow.cumulativeDiscountedNetCashFlowBeforeTaxByYear[i - 1];
        cashFlow.discountedPaybackPeriodBeforeTax =
          i +
          Math.abs(previousCumulative) /
            cashFlow.discountedNetCashFlowBeforeTaxByYear[i];
      }
    }
  }

  // 计算内部收益率（税后）
  cashFlow.irr = calculateIRR(cashFlow.netCashFlowByYear);
  // 计算内部收益率（税前）
  cashFlow.irrBeforeTax = calculateIRR(cashFlow.netCashFlowBeforeTaxByYear);

  // 将计算结果保存到Vuex的projectData中
  store.commit("setProjectData", projectData);

  // 计算小计值
  cashFlow.operatingRevenueTotal = cashFlow.operatingRevenueByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.subsidyIncomeTotal = cashFlow.subsidyIncomeByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.recoveryFixedAssetsTotal = cashFlow.recoveryFixedAssetsByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.recoveryWorkingCapitalTotal =
    cashFlow.recoveryWorkingCapitalByYear.reduce((sum, val) => sum + val, 0);
  cashFlow.otherCashInflowTotal = cashFlow.otherCashInflowByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.cashInflowTotal = cashFlow.cashInflowByYear.reduce(
    (sum, val) => sum + val,
    0,
  );

  cashFlow.equityInvestmentTotal = cashFlow.equityInvestmentByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.debtPrincipalRepaymentTotal =
    cashFlow.debtPrincipalRepaymentByYear.reduce((sum, val) => sum + val, 0);
  cashFlow.利息支出Total = cashFlow.利息支出ByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.operatingCostTotal = cashFlow.operatingCostByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.salesTaxTotal = cashFlow.salesTaxByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.vatTotal = cashFlow.vatByYear.reduce((sum, val) => sum + val, 0);
  cashFlow.incomeTaxTotal = cashFlow.incomeTaxByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.otherCashOutflowTotal = cashFlow.otherCashOutflowByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.cashOutflowTotal = cashFlow.cashOutflowByYear.reduce(
    (sum, val) => sum + val,
    0,
  );
  cashFlow.netCashFlowTotal = cashFlow.netCashFlowByYear.reduce(
    (sum, val) => sum + val,
    0,
  );

  // 添加英文属性名映射，以支持组件中的英文属性名引用
  cashFlow.interestExpenseByYear = cashFlow.利息支出ByYear;
  cashFlow.interestExpenseTotal = cashFlow.利息支出Total;

  store.commit("SET_PROJECT_DATA", projectData);
  // console.log("结果：", cashFlow);

  return { cashFlow, calculationPeriod, constructionPeriod, discountRate };
}

export function financialPlanCashFlowCalculation() {
  // 财务计划现金流量表
  let projectData = store.state.projectData;
  const jichu = projectData["基础数据"] || {};
  let calculationPeriod = jichu?.calculationPeriod || 15; // 计算期间
  let constructionPeriod = jichu?.constructionPeriod || 1; // 建设期间
  let operationPeriod = jichu?.operationPeriod || 14; // 运营期间
  const createArray = () => Array(calculationPeriod).fill(0);
  let finaData = {
    // 经营活动现金流量
    operatingCashInflowByYear: createArray(), // 现金流入
    operatingCashInflowTotal: 0,
    operatingRevenueByYear: createArray(), // 营业收入
    operatingRevenueTotal: 0,
    subsidyIncomeByYear: createArray(), // 补贴收入
    subsidyIncomeTotal: 0,
    operatingOtherCashInflowByYear: createArray(), // 其他流入
    operatingOtherCashInflowTotal: 0,

    operatingCashOutflowByYear: createArray(), // 现金流出
    operatingCashOutflowTotal: 0,
    operatingCostByYear: createArray(), // 经营成本
    operatingCostTotal: 0,
    salesTaxByYear: createArray(), // 销售税金及附加
    salesTaxTotal: 0,
    vatByYear: createArray(), // 增值税
    vatTotal: 0,
    incomeTaxByYear: createArray(), // 所得税
    incomeTaxTotal: 0,
    operatingOtherCashOutflowByYear: createArray(), // 其他流出
    operatingOtherCashOutflowTotal: 0,

    operatingNetCashFlowByYear: createArray(), // 经营活动净现金流量
    operatingNetCashFlowTotal: 0,

    // 投资活动现金流量
    investmentCashInflowByYear: createArray(), // 现金流入
    investmentCashInflowTotal: 0,
    recoveryFixedAssetsByYear: createArray(), // 回收固定资产余值
    recoveryFixedAssetsTotal: 0,
    recoveryWorkingCapitalByYear: createArray(), // 回收流动资金
    recoveryWorkingCapitalTotal: 0,

    investmentCashOutflowByYear: createArray(), // 现金流出
    investmentCashOutflowTotal: 0,
    constructionInvestmentByYear: createArray(), // 建设投资
    constructionInvestmentTotal: 0,
    operationMaintenanceInvestmentByYear: createArray(), // 维持运营投资
    operationMaintenanceInvestmentTotal: 0,
    workingCapitalByYear: createArray(), // 流动资金
    workingCapitalTotal: 0,
    investmentOtherCashOutflowByYear: createArray(), // 其他流出
    investmentOtherCashOutflowTotal: 0,

    investmentNetCashFlowByYear: createArray(), // 投资活动净现金流量
    investmentNetCashFlowTotal: 0,

    // 筹资活动现金流量
    financingCashInflowByYear: createArray(), // 现金流入
    financingCashInflowTotal: 0,
    equityInvestmentByYear: createArray(), // 项目资本金投入
    equityInvestmentTotal: 0,
    constructionLoanByYear: createArray(), // 建设投资借款
    constructionLoanTotal: 0,
    workingCapitalLoanByYear: createArray(), // 流动资金借款
    workingCapitalLoanTotal: 0,
    bondByYear: createArray(), // 债券
    bondTotal: 0,
    shortTermLoanByYear: createArray(), // 短期借款
    shortTermLoanTotal: 0,
    financingOtherCashInflowByYear: createArray(), // 其他流入
    financingOtherCashInflowTotal: 0,

    financingCashOutflowByYear: createArray(), // 现金流出
    financingCashOutflowTotal: 0,
    利息支出ByYear: createArray(), // 各种利息支出
    利息支出Total: 0,
    debtPrincipalRepaymentByYear: createArray(), // 偿还债务本金
    debtPrincipalRepaymentTotal: 0,
    dividendsByYear: createArray(), // 应付利润(股利分配)
    dividendsTotal: 0,
    financingOtherCashOutflowByYear: createArray(), // 其他流出
    financingOtherCashOutflowTotal: 0,

    financingNetCashFlowByYear: createArray(), // 筹资活动净现金流量
    financingNetCashFlowTotal: 0,

    // 净现金流量
    netCashFlowByYear: createArray(), // 净现金流量
    netCashFlowTotal: 0,

    // 盈余资金
    surplusFundByYear: createArray(), // 盈余资金
    surplusFundTotal: 0,
    cumulativeSurplusFundByYear: createArray(), // 累计盈余资金
  };

  for (let i = 0; i < calculationPeriod; i++) {
    //现金流入子项
    finaData.operatingRevenueByYear[i] =
      projectData["营业收入税金及利润"]?.["营业收入及营业税金"].revenueByYear[
        i
      ] || 0; // 营业收入
    finaData.operatingRevenueTotal += finaData.operatingRevenueByYear[i]; // 营业收入合计

    finaData.subsidyIncomeByYear[i] =
      projectData["营业收入税金及利润"]?.["利润"].subsidyIncomeByYear[i] || 0; // 补贴收入
    finaData.subsidyIncomeTotal += finaData.subsidyIncomeByYear[i]; // 补贴收入合计

    finaData.operatingOtherCashInflowByYear[i] = 0; // 其他流入
    finaData.operatingOtherCashInflowTotal = 0; // 其他流入合计

    finaData.operatingCashInflowByYear[i] =
      (finaData.operatingRevenueByYear[i] || 0) +
      (finaData.operatingOtherCashInflowByYear[i] || 0) +
      (finaData.subsidyIncomeByYear[i] || 0);
    finaData.operatingCashInflowTotal += finaData.operatingCashInflowByYear[i]; // 现金流入合计------------

    finaData.operatingCostByYear[i] =
      projectData["成本费用"]?.["经营成本"]?.year[i] || 0; // 经营成本
    finaData.operatingCostTotal += finaData.operatingCostByYear[i]; // 经营成本合计

    finaData.salesTaxByYear[i] =
      projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
        "additionaltaxByYear"
      ][i] || 0; // 销售税金及附加

    finaData.salesTaxTotal += finaData.salesTaxByYear[i]; // 销售税金及附加合计

    finaData.vatByYear[i] =
      projectData["营业收入税金及利润"]?.["营业收入及营业税金"]?.[
        "valueddedtax"
      ][i] || 0; // 增值税
    finaData.vatTotal += finaData.vatByYear[i]; // 增值税合计

    finaData.incomeTaxByYear[i] =
      projectData["营业收入税金及利润"]?.["利润"]?.["incomeTaxYear"]?.[i] || 0; // 所得税
    finaData.incomeTaxTotal += finaData.incomeTaxByYear[i]; // 所得税合计

    finaData.operatingOtherCashOutflowByYear = 0; // 其他流出
    finaData.operatingOtherCashOutflowTotal = 0;

    finaData.operatingCashOutflowByYear[i] =
      (finaData.operatingCostByYear[i] || 0) +
      (finaData.salesTaxByYear[i] || 0) +
      (finaData.vatByYear[i] || 0) +
      (finaData.incomeTaxByYear[i] || 0); // 现金流出------------
    finaData.operatingCashOutflowTotal +=
      finaData.operatingCashOutflowByYear[i]; // 现金流出合计--------------

    finaData.operatingNetCashFlowByYear[i] =
      (finaData.operatingCashInflowByYear[i] || 0) -
      (finaData.operatingCashOutflowByYear[i] || 0); // 经营活动净现金流量---------------
    finaData.operatingNetCashFlowTotal +=
      finaData.operatingNetCashFlowByYear[i]; // 经营活动净现金流量合计-------------------------

    // 投资活动现金流量
    // finaData.recoveryFixedAssetsByYear[i] = 0; // 回收固定资产余值---------------
    if (i === calculationPeriod - 1) {
      finaData.recoveryFixedAssetsByYear[i] =
        projectData["成本费用"]?.["折旧"]?.["total"]?.NAVatEOP || 0;
      finaData.recoveryWorkingCapitalByYear[i] =
        projectData["流动资金估算"]?.["计算结果"]?.["equityIncreaseThisYear"]
          ?.total || 0;
    }
    finaData.recoveryFixedAssetsTotal +=
      finaData.recoveryFixedAssetsByYear[i] || 0; // 回收固定资产余值合计
    finaData.recoveryWorkingCapitalTotal +=
      finaData.recoveryWorkingCapitalByYear[i] || 0; // 回收流动资金合计

    finaData.investmentCashInflowByYear[i] =
      (finaData.recoveryFixedAssetsByYear[i] || 0) +
      (finaData.recoveryWorkingCapitalByYear[i] || 0); // 现金流入------------------
    finaData.investmentCashInflowTotal +=
      finaData.investmentCashInflowByYear[i]; //现金流入合计------------------

    finaData.constructionInvestmentByYear[i] =
      projectData["资金筹措及分年投资计划"]?.["分年投资计划"]?.["总投资"]?.[
        "建设投资"
      ]?.year[i] || 0; // 建设投资-----------------------
    finaData.constructionInvestmentTotal +=
      finaData.constructionInvestmentByYear[i]; // 建设投资合计

    finaData.operationMaintenanceInvestmentByYear[i] = 0; // 维持运营投资
    finaData.operationMaintenanceInvestmentTotal = 0;

    finaData.workingCapitalByYear[i] =
      projectData["流动资金估算"]?.["计算结果"]?.["equityIncreaseThisYear"]
        ?.year[i] || 0; // 流动资金
    finaData.workingCapitalTotal += finaData.workingCapitalByYear[i]; // 流动资金合计

    finaData.investmentOtherCashOutflowByYear[i] = 0; // 其他流出
    finaData.investmentOtherCashOutflowTotal = 0;

    finaData.investmentCashOutflowByYear[i] =
      (finaData.constructionInvestmentByYear[i] || 0) +
      (finaData.operationMaintenanceInvestmentByYear[i] || 0) +
      (finaData.workingCapitalByYear[i] || 0) +
      (finaData.investmentOtherCashOutflowByYear[i] || 0); // 现金流出--------------
    finaData.investmentCashOutflowTotal +=
      finaData.investmentCashOutflowByYear[i]; //----------------------

    finaData.investmentNetCashFlowByYear[i] =
      (finaData.investmentCashInflowByYear[i] || 0) -
      (finaData.investmentCashOutflowByYear[i] || 0); // 投资活动净现金流量
    finaData.investmentNetCashFlowTotal +=
      finaData.investmentNetCashFlowByYear[i];

    // 筹资活动现金流量

    finaData.equityInvestmentByYear[i] =
      projectData["资金筹措及分年投资计划"]?.["分年投资计划"]?.["资金筹措"]?.[
        "资本金"
      ]?.year[i] || 0; // 项目资本金投入
    finaData.equityInvestmentTotal += finaData.equityInvestmentByYear[i];

    finaData.constructionLoanByYear[i] =
      (projectData["资金筹措及分年投资计划"]?.["资金筹措"]?.["债务资金"]?.[
        "银行借款"
      ]?.loan[i] || 0) +
      (projectData["资金筹措及分年投资计划"]?.["资金筹措"]?.["债务资金"]?.[
        "融资租赁"
      ]?.loan[i] || 0) +
      (projectData["资金筹措及分年投资计划"]?.["资金筹措"]?.["债务资金"]?.[
        "其他借款"
      ]?.loan[i] || 0);
    // 建设投资借款

    finaData.constructionLoanTotal += finaData.constructionLoanByYear[i] || 0;

    finaData.workingCapitalLoanByYear[i] =
      projectData["流动资金估算"]?.["计算结果"]?.["workingCapitalLoan"]?.year[
        i
      ] || 0; // 流动资金借款
    finaData.workingCapitalLoanTotal +=
      finaData.workingCapitalLoanByYear[i] || 0;

    finaData.bondByYear[i] =
      projectData["资金筹措及分年投资计划"]?.["资金筹措"]?.["债务资金"]?.[
        "债券"
      ]?.loan[i] || 0; // 债券
    finaData.bondTotal += finaData.bondByYear[i] || 0;

    finaData.shortTermLoanByYear[i] =
      projectData["流动资金估算"]?.["计算结果"]?.["workingCapitalLoan"]?.year[
        i
      ] || 0; // 短期借款
    finaData.shortTermLoanTotal += finaData.shortTermLoanByYear[i] || 0;

    finaData.financingOtherCashInflowByYear[i] = 0; // 其他流入
    finaData.financingOtherCashInflowTotal = 0;

    finaData.financingCashInflowByYear[i] =
      (finaData.equityInvestmentByYear[i] || 0) +
      (finaData.constructionLoanByYear[i] || 0) +
      (finaData.workingCapitalLoanByYear[i] || 0) +
      (finaData.bondByYear[i] || 0) +
      (finaData.shortTermLoanByYear[i] || 0) +
      (finaData.financingOtherCashInflowByYear[i] || 0); // 现金流入
    finaData.financingCashInflowTotal += finaData.financingCashInflowByYear[i];

    finaData.利息支出ByYear[i] =
      projectData["成本费用"]?.["利息"]?.year[i] || 0; // 各种利息支出
    finaData.利息支出Total += finaData.利息支出ByYear[i]; //  various interest expenses

    finaData.debtPrincipalRepaymentByYear[i] =
      (projectData["资金筹措及分年投资计划"]?.["资金筹措"]?.["债务资金"]
        ?.principal[i] || 0) +
      (projectData["流动资金估算"]?.["计算结果"]?.["workingCapitalLoan"]?.year[
        i
      ] || 0); // 偿还债务本金
    finaData.debtPrincipalRepaymentTotal +=
      finaData.debtPrincipalRepaymentByYear[i] || 0;

    finaData.dividendsByYear[i] = 0; // 应付利润(股利分配)
    finaData.dividendsTotal = 0;

    finaData.financingOtherCashOutflowByYear[i] = 0; // 其他流出
    finaData.financingOtherCashOutflowTotal = 0;

    finaData.financingCashOutflowByYear[i] =
      (finaData.利息支出ByYear[i] || 0) +
      (finaData.debtPrincipalRepaymentByYear[i] || 0) +
      (finaData.dividendsByYear[i] || 0) +
      (finaData.financingOtherCashOutflowByYear[i] || 0); // 现金流出
    finaData.financingCashOutflowTotal +=
      finaData.financingCashOutflowByYear[i];

    finaData.financingNetCashFlowByYear[i] =
      (finaData.financingCashInflowByYear[i] || 0) -
      (finaData.financingCashOutflowByYear[i] || 0); // 筹资活动净现金流量
    finaData.financingNetCashFlowTotal +=
      finaData.financingNetCashFlowByYear[i];

    finaData.netCashFlowByYear[i] =
      (finaData.financingNetCashFlowByYear[i] || 0) +
      (finaData.investmentNetCashFlowByYear[i] || 0) +
      (finaData.operatingNetCashFlowByYear[i] || 0); // 净现金流量
    finaData.netCashFlowTotal += finaData.netCashFlowByYear[i];

    // 盈余资金
    if (i == 0) {
      finaData.surplusFundByYear[i] = finaData.netCashFlowByYear[i];
    } else {
      finaData.surplusFundByYear[i] =
        finaData.surplusFundByYear[i - 1] + finaData.netCashFlowByYear[i];
    }

    finaData.surplusFundTotal =
      finaData.surplusFundByYear[calculationPeriod - 1]; // 累计盈余资金
  }
  let cashFlow = finaData;
  projectData["盈利能力分析"]["财务计划现金流量表"] = finaData;
  store.commit("SET_PROJECT_DATA", projectData);

  return {
    cashFlow,
    calculationPeriod, // 计算Period
    constructionPeriod, // 建设Period
    operationPeriod, // 经营Period
  };
}
// 计算分年投资计划数据

// 计算分年投资计划数据
export function calculateAnnualInvestment(a = "") {
  console.log("这里有没有a呀：" + a);

  let projectData = store.state.projectData;

  const zwzj =
    projectData.资金筹措及分年投资计划?.资金筹措?.债务资金?.loan || [];
  let min = 0;
  //债务最早到位时间
  for (let index = 0; index < zwzj.length; index++) {
    if (zwzj[index] > 0) {
      min = index;
      break;
    }
  }
  let 建设期 = projectData.基础数据.constructionPeriod || 1;
  //2个参数
  let 总计算期 = projectData.基础数据.calculationPeriod || 15;
  // 找到第一个达到满负荷的年份
  let 计算期 = 总计算期; // 默认值为计算期最后一年
  for (let i = 1; i <= 总计算期; i++) {
    if (i > 建设期) {
      if (projectData.基础数据.loadData?.[`${i}`] == 100) {
        计算期 = i;
        break;
      }
    }
  }

  let planData = {
    参数: {
      constructionPeriod: 建设期,
      fullLoadYear: 计算期,
    },
    总投资: {
      year: [],
      amount: projectData.总投资估算?.总表.总投资.合计,
      建设投资: {
        year: [],
        amount: projectData.总投资估算?.总表.建设投资.合计 || 0,
      },
      建设期利息: {
        year:
          projectData.资金筹措及分年投资计划?.资金筹措?.债务资金
            ?.interestlist || [],
        amount:
          projectData.资金筹措及分年投资计划?.资金筹措?.债务资金?.interest || 0,
      },
      流动资金: {
        year:
          projectData.流动资金估算?.计算结果.equityIncreaseThisYear.year || [],
        amount:
          projectData.流动资金估算?.计算结果.equityIncreaseThisYear.total || 0,
      },
    },
    资金筹措: {
      year: [],
      amount: projectData.总投资估算?.总表.总投资.合计 || 0,
      资本金: {
        year: [],
        amount:
          projectData.资金筹措及分年投资计划?.资金筹措?.项目资本金?.amount || 0,
        建设投资: {
          year:
            projectData.资金筹措及分年投资计划?.分年投资计划?.资金筹措?.资本金
              ?.建设投资.year || [],
          amount: 0,
        },
        建设期利息: {
          year:
            projectData.资金筹措及分年投资计划?.资金筹措?.债务资金
              ?.interestlist || [],
          amount:
            projectData.资金筹措及分年投资计划?.资金筹措?.债务资金?.interest ||
            0,
        },
        流动资金: {
          year: [],
          amount: 0,
        },
      },
      债务资金: {
        year: [],
        amount:
          projectData.资金筹措及分年投资计划?.资金筹措?.债务资金?.amount || 0,
        loan: zwzj,
        建设投资: {
          year: [],
          amount: 0,
        },
        流动资金: {
          year: [],
          amount: 0,
        },
      },
    },
  };
  console.log("总结果：", planData);

  //--------------------自动计算---------------------
  if (a == "") {
    //-----------------自动无债务计算-----------------
    if (planData.资金筹措.债务资金.amount === 0) {
      for (let i = 0; i < 计算期; i++) {
        planData.资金筹措.资本金.建设投资.year[i] = 0;
        if (i < 建设期) {
          planData.资金筹措.资本金.建设投资.year[i] =
            planData.总投资.建设投资.amount / 建设期;
        }
      }
      planData.资金筹措.资本金.流动资金.year = planData.总投资.流动资金.year;

      let sm = count(planData);
      return { planData: sm };
    } else {
      //有债务资金时，资本金调整
      //1.资本金不足以支付建设期利息和流动资金时，调整资本金分年
      if (
        planData.资金筹措.资本金.amount <=
        planData.资金筹措.资本金.建设期利息.amount +
          planData.总投资.流动资金.amount
      ) {
        let 资本流动 = 0;
        for (let i = 0; i < 计算期; i++) {
          planData.资金筹措.资本金.建设投资.year[i] = 0;
          planData.资金筹措.资本金.流动资金.year[i] =
            planData.总投资.流动资金.year[i] || 0;

          资本流动 += planData.资金筹措.资本金.流动资金.year[i] || 0;
          planData.资金筹措.债务资金.流动资金.year[i] = 0;
          planData.资金筹措.债务资金.建设投资.year[i] = 0;
          if (
            planData.资金筹措.资本金.amount -
              planData.资金筹措.资本金.建设期利息.amount <
            资本流动
          ) {
            planData.资金筹措.债务资金.流动资金.year[i] =
              资本流动 -
              ((planData.资金筹措.资本金.amount || 0) -
                planData.资金筹措.资本金.建设期利息.amount);

            planData.资金筹措.资本金.流动资金.year[i] =
              (planData.总投资.流动资金.year[i] || 0) -
              planData.资金筹措.债务资金.流动资金.year[i];

            资本流动 =
              planData.资金筹措.资本金.amount -
              planData.资金筹措.资本金.建设期利息.amount;
          }

          if ((i < 1, 建设期 && i >= min)) {
            planData.资金筹措.债务资金.建设投资.year[i] =
              planData.总投资.建设投资.amount / (建设期 - min);
          }
        }

        let sm = count(planData);
        return { planData: sm };
      } else {
        planData.资金筹措.资本金.流动资金.year = [
          ...planData.总投资.流动资金.year,
        ];
        for (let i = 0; i < 计算期; i++) {
          planData.资金筹措.资本金.建设投资.year[i] = 0;
          if (i < 建设期) {
            planData.资金筹措.资本金.建设投资.year[i] =
              (planData.资金筹措.资本金.amount -
                (planData.总投资.建设期利息.amount || 0) -
                (planData.总投资.流动资金.amount || 0)) /
              建设期;
          }
          planData.资金筹措.债务资金.流动资金.year[i] = 0;
          planData.资金筹措.债务资金.建设投资.year[i] = 0;

          if (i >= min && i < 建设期) {
            planData.资金筹措.债务资金.建设投资.year[i] =
              ((planData.总投资.amount || 0) -
                (planData.资金筹措.资本金?.amount || 0)) /
              (建设期 - min);
          }
        }

        let sm = count(planData);
        return { planData: sm };
      }
    }
  }
  if (a !== "ok" && a !== "") {
    console.log("前端输入：", a);

    let index = Number(a);

    let numindex = planData.资金筹措.资本金.建设投资.year[index];
    //-----------------------------------------------------前端输入和小于10%-------------------------------------------------------
    if (
      planData.资金筹措.资本金.建设投资.year[index] >
      planData.资金筹措.资本金.amount -
        planData.资金筹措.资本金.建设期利息.amount
    ) {
      return { code: 400, msg: "资本金不足" };
    }

    if (planData.资金筹措.债务资金.amount === 0) {
      planData.资金筹措.资本金.流动资金.year = [
        ...planData.总投资.流动资金.year,
      ];
      planData.资金筹措.资本金.流动资金.amount = 0;

      for (let i = 0; i < 计算期; i++) {
        planData.资金筹措.资本金.流动资金.amount +=
          planData.资金筹措.资本金.流动资金.year[i] || 0;
      }

      let s =
        (planData.资金筹措.资本金.amount || 0) -
        (planData.资金筹措.资本金.流动资金.amount || 0) -
        planData.资金筹措.资本金.建设投资.year[index]; //计算剩余资金

      if (s < 0) {
        return { code: 400, msg: "资本金不足" };
      }

      // 计算除index外其他元素（不包括建设期最后一年）的总和
      let othersSum = 0;
      for (let i = 0; i < 建设期 - 1; i++) {
        if (i !== index) {
          othersSum += planData.资金筹措.资本金.建设投资.year[i] || 0;
        }
      }

      // 如果建设期最后一年不是index，则也要加入到其他元素总和中
      // if (建设期 - 1 !== index) {
      //   othersSum += planData.资金筹措.资本金.建设投资.year[建设期 - 1] || 0;
      // }

      if (s >= othersSum) {
        // 剩余资金足够覆盖其他元素，将剩余部分分配给建设期最后一年
        const remainingForLastYear = s - othersSum;
        planData.资金筹措.资本金.建设投资.year[建设期 - 1] =
          remainingForLastYear;
      } else {
        // 剩余资金不够，除index元素外，其他元素平均分配
        const otherElementCount = 建设期 - 1; // 总共建设期个元素，排除index元素
        let availableAmount = s;

        // 计算除index外的元素平均分配金额
        const averageAllocation = availableAmount / otherElementCount;

        // 清零除index外的所有元素
        for (let i = 0; i < 建设期; i++) {
          if (i !== index) {
            planData.资金筹措.资本金.建设投资.year[i] = 0;
          }
        }

        // 平均分配剩余资金给除index外的元素
        let remainingToAllocate = availableAmount;
        for (let i = 0; i < 建设期 && remainingToAllocate > 0; i++) {
          if (i !== index) {
            const allocation = Math.min(averageAllocation, remainingToAllocate);
            planData.资金筹措.资本金.建设投资.year[i] += allocation;
            remainingToAllocate -= allocation;
          }
        }
      }

      let sm = count(planData);
      return { planData: sm };
    } else {
      let 借款前流动资金和 = 0;
      for (let i = 0; i < min; i++) {
        借款前流动资金和 += planData.总投资.流动资金.year[i] || 0;
      } //债务到位之前的流动资金之和

      let s =
        (planData.资金筹措.资本金.amount || 0) -
        planData.资金筹措.资本金.建设投资.year[index] -
        planData.资金筹措.资本金.建设期利息.amount -
        借款前流动资金和; //计算剩余资金

      if (s < 0) {
        return { code: 400, msg: "资本金不足" };
      }

      // 初始化建设投资数组
      for (let i = 0; i < 建设期; i++) {
        if (!planData.资金筹措.资本金.建设投资.year[i]) {
          planData.资金筹措.资本金.建设投资.year[i] = 0;
        }
      }

      // 先保存除index元素和建设期最后一年外的建设投资数据，用于后续比较
      let originalOthersSum = 0; //-------------------------------------特用数据建设投资数据
      for (let i = 0; i < 建设期 - 1; i++) {
        // 只检查到建设期-1，不包括最后一年
        if (i !== index) {
          originalOthersSum += planData.资金筹措.资本金.建设投资.year[i] || 0;
        }
      }

      planData.资金筹措.资本金.建设投资.year[建设期 - 1] = 0; // 先清零建设期最后一年，后续根据剩余资金进行分配

      // 计算债务到位前的资本金流动资金需求
      for (let i = 0; i < min; i++) {
        planData.资金筹措.资本金.流动资金.year[i] =
          planData.总投资.流动资金.year[i] || 0;
      }

      // 计算剩余可用资本金
      let remainingCapital = s;

      // 从债务到位年开始分配流动资金
      for (let i = min; i < 计算期; i++) {
        // 建设期内的流动资金需求
        planData.资金筹措.资本金.流动资金.year[i] = 0;

        const requiredWorkingCapital = planData.总投资.流动资金.year[i] || 0;
        const availableForWorkingCapital = Math.min(
          requiredWorkingCapital,
          remainingCapital,
        );

        planData.资金筹措.资本金.流动资金.year[i] = availableForWorkingCapital;
        remainingCapital -= availableForWorkingCapital;

        // 计算债务资金中的流动资金
        planData.资金筹措.债务资金.流动资金.year[i] =
          planData.总投资.流动资金.year[i] - availableForWorkingCapital;
      }
      if (remainingCapital <= 0) {
        for (let i = 0; i < 建设期; i++) {
          if (i !== index) {
            planData.资金筹措.资本金.建设投资.year[i] = 0;
          }
        }
      } else {
        if (remainingCapital >= originalOthersSum) {
          // 剩余资金足够覆盖其他元素，将剩余部分分配给建设期最后一年
          planData.资金筹措.资本金.建设投资.year[建设期 - 1] =
            remainingCapital - originalOthersSum;
        } else {
          // 剩余资金不够，除index元素外，其他元素平均分配
          const otherElementCount = 建设期 - 1; // 总共建设期个元素，排除index元素
          let availableAmount = remainingCapital;

          // 计算除index外的元素平均分配金额
          const averageAllocation = availableAmount / otherElementCount;

          // 清零除index外的所有元素
          for (let i = 0; i < 建设期; i++) {
            if (i !== index) {
              planData.资金筹措.资本金.建设投资.year[i] = 0;
            }
          }

          // 平均分配剩余资金给除index外的元素

          for (let i = 0; i < 建设期; i++) {
            planData.资金筹措.资本金.建设投资.year[i] = 0;
            if (i !== index) {
              planData.资金筹措.资本金.建设投资.year[i] = averageAllocation;
            }
          }
        }
      }
      planData.资金筹措.资本金.建设投资.year[index] = numindex;
      let sum = 0;
      for (let i = 0; i < 建设期; i++) {
        sum += planData.资金筹措.资本金.建设投资.year[i];
      }

      for (let i = min; i < 建设期; i++) {
        planData.资金筹措.债务资金.建设投资.year[i] =
          (planData.总投资.建设投资.amount - sum) / (建设期 - min);
      }

      let sm = count(planData);
      return { planData: sm };
    }
  }
  if (a === "ok") {
    // 1. 计算可用于流动资金和建设投资的资本金
    const 总资本金 = planData.资金筹措.资本金.amount;
    const 建设期利息 = planData.资金筹措.资本金.建设期利息.amount;
    const 可用于流动资金和建设投资的资本金 = 总资本金 - 建设期利息;

    // 2. 计算流动资金需求
    let 流动资金需求 = 0;
    for (let i = 0; i < 计算期; i++) {
      流动资金需求 += planData.总投资.流动资金.year[i] || 0;
    }

    // 4. 安排流动资金
    let 剩余资本金 = 可用于流动资金和建设投资的资本金;
    for (let i = 0; i < 计算期; i++) {
      const 需要的流动资金 = planData.总投资.流动资金.year[i] || 0;
      const 资本金可承担的流动资金 = Math.min(需要的流动资金, 剩余资本金);

      planData.资金筹措.资本金.流动资金.year[i] = 资本金可承担的流动资金;
      planData.资金筹措.债务资金.流动资金.year[i] =
        需要的流动资金 - 资本金可承担的流动资金;

      剩余资本金 -= 资本金可承担的流动资金;
    }
    const 建设投资可使用资金 = 剩余资本金;

    // 5. 根据建设投资可使用资金进行建设投资分配
    let 现有资本金建设投资除最后一年总和 = 0;
    for (let i = 0; i < 建设期 - 1; i++) {
      现有资本金建设投资除最后一年总和 +=
        planData.资金筹措.资本金.建设投资.year[i] || 0;
    }

    if (建设投资可使用资金 <= 0) {
      // 如果建设投资可使用资金 <= 0，则资本金组的建设投资将不进行资本金分配，全部清0
      for (let i = 0; i < 建设期; i++) {
        planData.资金筹措.资本金.建设投资.year[i] = 0;
      }
    } else {
      // 获取现有资本金中建设投资（除最后一年）的和
      let 现有资本金建设投资除最后一年总和 = 0;
      for (let i = 0; i < 建设期 - 1; i++) {
        // 使用当前已有的建设投资数据作为参考
        现有资本金建设投资除最后一年总和 +=
          planData.资金筹措.资本金.建设投资.year[i] || 0;
      }

      // 如果没有现有数据，使用平均分配方式作为默认值
      if (现有资本金建设投资除最后一年总和 === 0) {
        planData.资金筹措.资本金.建设投资.year[建设期 - 1] = 建设投资可使用资金;
      } else {
        // 对比分配
        if (建设投资可使用资金 >= 现有资本金建设投资除最后一年总和) {
          planData.资金筹措.资本金.建设投资.year[建设期 - 1] =
            建设投资可使用资金 - 现有资本金建设投资除最后一年总和;
        } else {
          const 平均分摊金额 = 建设投资可使用资金 / 建设期;
          for (let i = 0; i < 建设期; i++) {
            planData.资金筹措.资本金.建设投资.year[i] = 平均分摊金额;
          }
        }
      }
    }

    // 6. 债务资金补充：债务资金的建设投资由总投资项下的总建设投资-资本金项下建设投资的和，
    // 分摊到债务资金到位后至建设期最后一年的各年
    const 总建设投资 = planData.总投资.建设投资.amount;

    for (let i = 0; i < 建设期; i++) {
      planData.资金筹措.债务资金.建设投资.year[i] = 0;
      if (i >= min) {
        planData.资金筹措.债务资金.建设投资.year[i] =
          (总建设投资 - 建设投资可使用资金) / (建设期 - min);
      }
    }

    // 重新计算以确保平衡
    const result = count(planData);
    return { planData: result };
  }
}

function count(e) {
  //下面的全部用for循环计算
  // 计算总投资

  e.资金筹措.资本金.建设投资.amount = 0;
  for (let i = 0; i < e.参数.fullLoadYear; i++) {
    e.资金筹措.资本金.建设投资.amount +=
      e.资金筹措.资本金.建设投资.year[i] || 0;
  }
  e.资金筹措.资本金.流动资金.amount = 0;
  for (let i = 0; i < e.参数.fullLoadYear; i++) {
    e.资金筹措.资本金.流动资金.amount +=
      e.资金筹措.资本金.流动资金.year[i] || 0;
  }
  e.资金筹措.债务资金.建设投资.amount = 0;
  for (let i = 0; i < e.参数.fullLoadYear; i++) {
    e.资金筹措.债务资金.建设投资.amount +=
      e.资金筹措.债务资金.建设投资.year[i] || 0;
  }
  e.资金筹措.债务资金.流动资金.amount = 0;
  for (let i = 0; i < e.参数.fullLoadYear; i++) {
    e.资金筹措.债务资金.流动资金.amount +=
      e.资金筹措.债务资金.流动资金.year[i] || 0;
  }

  for (let i = 0; i < e.参数.fullLoadYear; i++) {
    e.资金筹措.资本金.year[i] =
      (e.资金筹措.资本金.建设投资.year[i] || 0) +
      (e.资金筹措.资本金.流动资金.year[i] || 0) +
      (e.资金筹措.资本金.建设期利息.year[i] || 0);

    e.资金筹措.债务资金.year[i] =
      (e.资金筹措.债务资金.建设投资.year[i] || 0) +
      (e.资金筹措.债务资金.流动资金.year[i] || 0);
    e.资金筹措.year[i] =
      (e.资金筹措.资本金.year[i] || 0) + (e.资金筹措.债务资金.year[i] || 0);
    e.总投资.建设投资.year[i] =
      (e.资金筹措.资本金.建设投资.year[i] || 0) +
      (e.资金筹措.债务资金.建设投资.year[i] || 0);
    e.总投资.year[i] = e.资金筹措.year[i];
  }
  // e.资金筹措.资本金.amount = e.资金筹措.资本金.year.reduce((a, b) => a + b, 0);
  // e.资金筹措.债务资金.amount = e.资金筹措.债务资金.year.reduce(
  //   (a, b) => a + b,
  //   0,
  // );
  // e.总投资.amount = e.资金筹措.amount =
  //   e.资金筹措.资本金.amount + e.资金筹措.债务资金.amount;
  // e.总投资.建设投资.amount = e.总投资.建设投资.year.reduce((a, b) => a + b, 0);
  // e.总投资.流动资金.amount = e.总投资.流动资金.year.reduce((a, b) => a + b, 0);
  // e.总投资.建设期利息.amount = e.总投资.建设期利息.year.reduce(
  //   (a, b) => a + b,
  //   0,
  // );

  let projectData = store.state.projectData;
  projectData.资金筹措及分年投资计划.分年投资计划 = e;

  store.commit("SET_PROJECT_DATA", projectData);

  return e;
}

// 还本付息计算函数
export function calculateRepaymentPlan(repaymentSource = "") {
  let projectData = store.state.projectData;
  if (
    !projectData ||
    !projectData["基础数据"] ||
    !projectData["资金筹措及分年投资计划"]
  ) {
    console.warn("数据结构不完整，无法执行还本付息计算");
    // console.log(
    //   "Missing data:",
    //   !projectData
    //     ? "projectData"
    //     : !projectData["基础数据"]
    //     ? "基础数据"
    //     : "资金筹措及分年投资计划"
    // );
    // 返回空数组而不是空对象
    return [];
  }
  //默认还本付息方式为净利润
  if (!repaymentSource) {
    repaymentSource =
      projectData.资金筹措及分年投资计划.还本付息.repaymentSource ||
      "netProfit";
  }

  // 在计算还本付息前，先调用利润计算函数，确保利润数据已经减去了流动资金利息
  profitCalculation();
  let repaymentData = [];

  const loanTypes = [
    { key: "银行借款", name: "银行借款" },
    { key: "债券", name: "债券" },
    { key: "融资租赁", name: "融资租赁" },
    { key: "其他借款", name: "其他借款" },
  ];
  const debtData = projectData.资金筹措及分年投资计划.资金筹措.债务资金 || {};
  const constructionPeriod = projectData.基础数据.constructionPeriod || 1;
  const calculationPeriod = projectData.基础数据.calculationPeriod || 15; //财务计算期间
  // const debtData = projectData.资金筹措及分年投资计划.资金筹措.债务资金 || {};
  const financeData = projectData.营业收入税金及利润 || {};
  let addedFunds = {
    期初可用还款资金: [],
    本年新增还款资金: [],
    当期本金还款: [],
    当期利息还款: [],
    期末可用资金: [],
    期初可用还款资金toal: 0,
    本年新增还款资金total: 0,
    当期本金还款total: 0,
    当期利息还款total: 0,
    期末可用资金total: 0,
    当期本金还款合计: [],
    当期利息还款合计: [],
    期末可用资金合计: [],
    当期本金还款合计total: 0,
    当期利息还款合计total: 0,
    期末可用资金合计total: 0,
    利息备付率: [],
    本金备付率: [],
    本息备付率: [],
    利息备付金合计: 0,
    本金备付金合计: 0,
    本息备付金合计: 0,
  };
  for (let index = 0; index < calculationPeriod; index++) {
    addedFunds.期初可用还款资金[index] = 0;
    addedFunds.本年新增还款资金[index] = 0;
    addedFunds.当期本金还款[index] = 0;
    addedFunds.当期利息还款[index] = 0;
    addedFunds.期末可用资金[index] = 0;
    addedFunds.当期本金还款合计[index] = 0;
    addedFunds.当期利息还款合计[index] = 0;
    addedFunds.期末可用资金合计[index] = 0;
    addedFunds.利息备付率[index] = 0;
    addedFunds.本金备付率[index] = 0;
    addedFunds.本息备付率[index] = 0;
  }
  loanTypes.forEach((loanType) => {
    let load = {
      名称: loanType.key,
      期初本金: [], // 初始化数组
      借款本金: [], // 初始化数组
      当期还本: [],
      当期还息: [],
      期末本金: [],
      借款本金total: 0,
      期末本金total: 0,
      当期还本total: 0,
      当期还息total: 0,
    };
    if (debtData && (debtData[loanType.key]?.amount || 0) !== 0) {
      for (let index = 0; index < calculationPeriod; index++) {
        load.借款本金[index] = debtData[loanType.key]?.loan[index] || 0;
        load.当期还本[index] = debtData[loanType.key]?.principal[index] || 0;
        load.当期还息[index] = debtData[loanType.key]?.operating[index] || 0;
        if (index == constructionPeriod) {
          load.期初本金[index] = debtData[loanType.key].amount || 0;
        } else if (index > constructionPeriod) {
          load.期初本金[index] = load.期末本金[index - 1];
        } else {
          load.期初本金[index] = 0;
        }
        load.期末本金[index] =
          (load.期初本金[index] || 0) - (load.当期还本[index] || 0);
        addedFunds.当期利息还款[index] += load.当期还息[index] || 0;
        addedFunds.当期本金还款[index] += load.当期还本[index] || 0;
        load.借款本金total += load.借款本金[index] || 0;
        load.期末本金total += load.期末本金[index] || 0;
        load.当期还本total += load.当期还本[index] || 0;
        load.当期还息total += load.当期还息[index] || 0;
        addedFunds.当期本金还款total += load.当期还本[index] || 0;
        addedFunds.当期利息还款total += load.当期还息[index] || 0;
      }

      repaymentData.push(load);
    }
  });

  if (repaymentSource === "netProfit") {
    for (let index = 0; index < calculationPeriod; index++) {
      if (index >= constructionPeriod) {
        addedFunds.本年新增还款资金[index] =
          financeData.利润?.netProfitYear[index] || 0;
        addedFunds.期初可用还款资金[index] =
          index > 0 ? addedFunds.期末可用资金[index - 1] : 0;
      }

      addedFunds.期末可用资金[index] =
        addedFunds.期初可用还款资金[index] +
        addedFunds.本年新增还款资金[index] -
        addedFunds.当期本金还款[index] -
        addedFunds.当期利息还款[index];

      // 设置新增字段的值
      addedFunds.当期本金还款合计[index] = addedFunds.当期本金还款[index];
      addedFunds.当期利息还款合计[index] = addedFunds.当期利息还款[index];
      addedFunds.期末可用资金合计[index] =
        index === calculationPeriod - 1 ? addedFunds.期末可用资金[index] : 0;

      addedFunds.本年新增还款资金total +=
        addedFunds.本年新增还款资金[index] || 0;
      addedFunds.当期本金还款合计total +=
        addedFunds.当期本金还款合计[index] || 0;
      addedFunds.当期利息还款合计total +=
        addedFunds.当期利息还款合计[index] || 0;
      addedFunds.期末可用资金合计total +=
        addedFunds.期末可用资金合计[index] || 0;
    }
  }
  if (repaymentSource === "ebitda") {
    for (let index = 0; index < calculationPeriod; index++) {
      if (index >= constructionPeriod) {
        addedFunds.本年新增还款资金[index] =
          (financeData.利润?.ebitdaByYear[index] || 0) -
          (projectData.流动资金估算.计算结果?.workingCapitalLoanInterest?.year[
            index
          ] || 0);
        addedFunds.期初可用还款资金[index] =
          index > 0 ? addedFunds.期末可用资金[index - 1] : 0;
      }

      addedFunds.期末可用资金[index] =
        addedFunds.期初可用还款资金[index] +
        addedFunds.本年新增还款资金[index] -
        addedFunds.当期本金还款[index] -
        addedFunds.当期利息还款[index];

      // 设置新增字段的值
      addedFunds.当期本金还款合计[index] = addedFunds.当期本金还款[index];
      addedFunds.当期利息还款合计[index] = addedFunds.当期利息还款[index];
      addedFunds.期末可用资金合计[index] =
        index === calculationPeriod - 1 ? addedFunds.期末可用资金[index] : 0;

      addedFunds.本年新增还款资金total +=
        addedFunds.本年新增还款资金[index] || 0;
      addedFunds.当期本金还款合计total +=
        addedFunds.当期本金还款合计[index] || 0;
      addedFunds.当期利息还款合计total +=
        addedFunds.当期利息还款合计[index] || 0;
      addedFunds.期末可用资金合计total +=
        addedFunds.期末可用资金合计[index] || 0;
    }
  }

  if (repaymentSource === "profitBeforeTax") {
    for (let index = 0; index < calculationPeriod; index++) {
      if (index >= constructionPeriod) {
        addedFunds.本年新增还款资金[index] =
          (financeData.利润?.ebitByYear[index] || 0) -
          (projectData.流动资金估算.计算结果?.workingCapitalLoanInterest?.year[
            index
          ] || 0);
        addedFunds.期初可用还款资金[index] =
          index > 0 ? addedFunds.期末可用资金[index - 1] : 0;
      }

      addedFunds.期末可用资金[index] =
        addedFunds.期初可用还款资金[index] +
        addedFunds.本年新增还款资金[index] -
        addedFunds.当期本金还款[index] -
        addedFunds.当期利息还款[index];

      // 设置新增字段的值
      addedFunds.当期本金还款合计[index] = addedFunds.当期本金还款[index];
      addedFunds.当期利息还款合计[index] = addedFunds.当期利息还款[index];
      addedFunds.期末可用资金合计[index] =
        index === calculationPeriod - 1 ? addedFunds.期末可用资金[index] : 0;

      addedFunds.本年新增还款资金total +=
        addedFunds.本年新增还款资金[index] || 0;
      addedFunds.当期本金还款合计total +=
        addedFunds.当期本金还款合计[index] || 0;
      addedFunds.当期利息还款合计total +=
        addedFunds.当期利息还款合计[index] || 0;
      addedFunds.期末可用资金合计total +=
        addedFunds.期末可用资金合计[index] || 0;
    }
  }

  for (let index = 0; index < calculationPeriod; index++) {
    if (addedFunds.当期利息还款[index] > 0) {
      addedFunds.利息备付率[index] =
        (addedFunds.期初可用还款资金[index] +
          addedFunds.本年新增还款资金[index]) /
          addedFunds.当期利息还款[index] || 0;
    } else {
      addedFunds.利息备付率[index] = 0;
    }
    if (addedFunds.当期本金还款[index] > 0) {
      addedFunds.本金备付率[index] =
        (addedFunds.期初可用还款资金[index] +
          addedFunds.本年新增还款资金[index]) /
          addedFunds.当期本金还款[index] || 0;
    } else {
      addedFunds.本金备付率[index] = 0;
    }
    if (addedFunds.当期本金还款[index] + addedFunds.当期利息还款[index] > 0) {
      addedFunds.本息备付率[index] =
        (addedFunds.期初可用还款资金[index] +
          addedFunds.本年新增还款资金[index]) /
          (addedFunds.当期本金还款[index] + addedFunds.当期利息还款[index]) ||
        0;
    } else {
      addedFunds.本息备付率[index] = 0;
    }
  }
  if (addedFunds.当期利息还款合计total > 0) {
    addedFunds.利息备付率total =
      addedFunds.本年新增还款资金total / addedFunds.当期利息还款合计total || 0;
  } else {
    addedFunds.利息备付率total = 0;
  }
  if (addedFunds.当期本金还款合计total > 0) {
    addedFunds.本金备付率total =
      addedFunds.本年新增还款资金total / addedFunds.当期本金还款合计total || 0;
  } else {
    addedFunds.本金备付率total = 0;
  }
  if (addedFunds.当期本金还款合计total + addedFunds.当期利息还款合计total > 0) {
    addedFunds.本息备付率total =
      addedFunds.本年新增还款资金total /
        (addedFunds.当期本金还款合计total + addedFunds.当期利息还款合计total) ||
      0;
  } else {
    addedFunds.本息备付率total = 0;
  }

  // console.log("借款：", repaymentData);
  // console.log("还款：", addedFunds);

  // 更新项目数据中的还本付息计划
  projectData.资金筹措及分年投资计划.还本付息 = {
    repaymentSource,
    repaymentData,
    addedFunds,
  };

  // 保存到Vuex
  store.commit("SET_PROJECT_DATA", projectData);

  return {
    repaymentSource,
    repaymentData,
    addedFunds,
    constructionPeriod,
    calculationPeriod,
  };
}

// 敏感性分析计算函数
export function sensitivityAnalysisCalculation(zb, fd) {
  let projectData = store.state.projectData;
  // 检查数据结构是否完整
  if (!projectData || !projectData["基础数据"]) {
    console.warn("数据结构不完整，无法执行敏感性分析");
    return {};
  }

  let zcn = projectData.基础数据.normalYear; //正常年
  let baseIRR = JSON.parse(
    projectData.盈利能力分析?.全部投资现金流量?.irr || 0,
  ); //获得基础irr
  let fdarr = [];
  if (fd === "0") {
    fdarr = [-0.03, -0.02, -0.01, 0, 0.01, 0.02, 0.03];
  }
  if (fd === "1") {
    fdarr = [-0.15, -0.1, -0.05, 0, 0.05, 0.1, 0.15];
  }
  if (fd === "2") {
    fdarr = [-0.3, -0.2, -0.1, 0, 0.1, 0.2, 0.3]; // 修复了负数序列中的错误
  }

  // 存储各个指标的敏感性分析结果
  let sensitivityResults = {};

  zb.forEach((item) => {
    if (zbfun[item + "f"]) {
      // 调用指标处理函数，获取该指标的敏感性分析结果
      const result = zbfun[item + "f"](projectData, fdarr);
      if (result) {
        sensitivityResults[item] = result;
      }
    } else {
      console.warn(`未找到处理函数: ${item + "f"}`);
    }
  });

  // 统计临界值数量
  let 临界值数量 = 0;
  for (const item in sensitivityResults) {
    if (sensitivityResults[item].临界点 !== 0) {
      临界值数量++;
    }
  }

  // 准备敏感性分析数据
  const sensitivityAnalysisData = {
    baseIRR: baseIRR,
    fdarr: fdarr,
    results: sensitivityResults,
    临界值数量: 临界值数量,
  };
  // console.log(sensitivityAnalysisData);

  // 更新项目数据
  if (!projectData.不确定性分析) {
    projectData.不确定性分析 = {};
  }
  projectData.不确定性分析.sensitivityAnalysis = sensitivityAnalysisData;
  store.commit("SET_PROJECT_DATA", projectData);

  return sensitivityAnalysisData;
}
const zbfun = {
  产品f(projectData, fdarr) {
    let a = { 产品: 0, 原料: 0, 原料率: 1, 建投: 0 };
    let 产品名称 =
      projectData.营业收入税金及利润.营业收入及营业税金.revenue.revenuelist[
        projectData.营业收入税金及利润.营业收入及营业税金.revenue.revenuelist
          .length - 1
      ].name || "";
    let 收益率 = [];
    fdarr.forEach((res) => {
      a.产品 = res;
      let v = allInvestmentCashFlowCalculation(a);
      收益率.push(v);
    });

    //   fdarr.forEach((res) => {
    //   a.产品 = res;

    //   let v = calculateOperatingRevenue(taxParams = {});
    //   收益率.push(v);
    // });

    // 改进的临界点查找逻辑
    let 临界点 = 0;
    let ljd = 10000;

    // 先找到收益率最接近0的点作为起点
    let 起点 = 0;
    let 最小差值 = 10000;
    for (let i = 0; i < fdarr.length; i++) {
      a.产品 = fdarr[i];
      let s = allInvestmentCashFlowCalculation(a);
      let 差值 = Math.abs(s);
      if (差值 < 最小差值) {
        最小差值 = 差值;
        起点 = fdarr[i];
      }
    }

    // 在起点附近进行精细搜索
    const 搜索范围 = Math.min(Math.abs(起点) * 0.2, 0.1); // 动态调整搜索范围
    const 搜索步长 = 0.0001; // 更精细的步长

    // 向负方向搜索
    for (let index = 起点; index >= 起点 - 搜索范围; index -= 搜索步长) {
      a.产品 = index;
      let s = allInvestmentCashFlowCalculation(a);
      if (Math.abs(s) < ljd) {
        ljd = Math.abs(s);
        临界点 = Number(index.toFixed(4));
      }
    }

    // 向正方向搜索
    for (let index = 起点; index <= 起点 + 搜索范围; index += 搜索步长) {
      a.产品 = index;
      let s = allInvestmentCashFlowCalculation(a);
      if (Math.abs(s) < ljd) {
        ljd = Math.abs(s);
        临界点 = Number(index.toFixed(4));
      }
    }

    // console.log("来没", 产品名称, 收益率, "临界点", 临界点);
    let 临界值 = `${
      projectData.营业收入税金及利润.营业收入及营业税金.revenue.revenuelist[
        projectData.营业收入税金及利润.营业收入及营业税金.revenue.revenuelist
          .length - 1
      ].unitprice *
      (1 + 临界点)
    }/${
      projectData.营业收入税金及利润.营业收入及营业税金.revenue.revenuelist[
        projectData.营业收入税金及利润.营业收入及营业税金.revenue.revenuelist
          .length - 1
      ].unit
    }`;
    // 返回计算结果
    return {
      指标名称: "产品价格（产量）",
      收益率: 收益率,
      临界点: 临界点,
      // 临界值名称：用于在表格中显示具体产品/材料名称
      临界值名称: 产品名称,
      // 临界值：用于显示临界数量，后续会添加具体数值
      临界值,
    };
  },

  原料f(projectData, fdarr) {
    let a = { 产品: 0, 原料: 0, 原料率: 1, 建投: 0 };
    let 产品名称 =
      projectData.成本费用.原辅材料.materials.materialslist[
        projectData.成本费用.原辅材料.materials.materialslist.length - 1
      ].name || "";
    let 经营成本 = projectData.成本费用.经营成本.total;
    let 原辅材料 = projectData.成本费用.原辅材料.total.total;
    let 原料率 = 原辅材料 / 经营成本;
    a.原料率 = 原料率;
    let ljd = 10000;

    let 收益率 = [];
    fdarr.forEach((res) => {
      a.原料 = res;
      let v = allInvestmentCashFlowCalculation(a);
      收益率.push(v);
    });

    // 改进的临界点查找逻辑
    let 临界点 = 0;

    // 先找到收益率最接近0的点作为起点
    let 起点 = 0;
    let 最小差值 = 10000;
    for (let i = 0; i < fdarr.length; i++) {
      a.原料 = fdarr[i];
      let s = allInvestmentCashFlowCalculation(a);
      let 差值 = Math.abs(s);
      if (差值 < 最小差值) {
        最小差值 = 差值;
        起点 = fdarr[i];
      }
    }

    // 在起点附近进行精细搜索
    const 搜索范围 = 10; // 固定搜索范围
    const 搜索步长 = 0.001; // 更精细的步长

    // 双向搜索
    for (
      let index = Math.max(0, 起点 - 搜索范围);
      index <= Math.min(100, 起点 + 搜索范围);
      index += 搜索步长
    ) {
      a.原料 = index;
      let s = allInvestmentCashFlowCalculation(a);
      if (Math.abs(s) < ljd) {
        ljd = Math.abs(s);
        临界点 = Number(index.toFixed(4));
      }
    }
    //保留2位小数
    临界点 = Number(临界点.toFixed(2));
    let 临界值 = `${(
      (projectData.成本费用.原辅材料.materials.materialslist[
        projectData.成本费用.原辅材料.materials.materialslist.length - 1
      ].unitPrice || 0) *
      (1 + 临界点)
    ).toFixed(2)}/${
      projectData.成本费用.原辅材料.materials.materialslist[
        projectData.成本费用.原辅材料.materials.materialslist.length - 1
      ].unit
    }`;
    // 返回计算结果
    return {
      指标名称: "原辅材料",
      收益率: 收益率,
      临界点: 临界点,
      // 临界值名称：用于在表格中显示具体产品/材料名称
      临界值名称: 产品名称,
      // 临界值：用于显示临界数量，后续会添加具体数值
      临界值,
    };
  },

  成本f(projectData, fdarr) {
    let a = { 产品: 0, 原料: 0, 原料率: 1, 建投: 0 };
    let 产品名称 = "经营成本";

    a.原料率 = 1;

    let 收益率 = [];
    fdarr.forEach((res) => {
      a.原料 = res;
      let v = allInvestmentCashFlowCalculation(a);
      收益率.push(v);
    });

    // 改进的临界点查找逻辑
    let 临界点 = 0;
    let ljd = 10000;

    // 先找到收益率最接近0的点作为起点
    let 起点 = 0;
    let 最小差值 = 10000;
    for (let i = 0; i < fdarr.length; i++) {
      a.原料 = fdarr[i];
      let s = allInvestmentCashFlowCalculation(a);
      let 差值 = Math.abs(s);
      if (差值 < 最小差值) {
        最小差值 = 差值;
        起点 = fdarr[i];
      }
    }

    // 在起点附近进行精细搜索
    const 搜索范围 = 10;
    const 搜索步长 = 0.001;

    for (
      let index = Math.max(0, 起点 - 搜索范围);
      index <= Math.min(100, 起点 + 搜索范围);
      index += 搜索步长
    ) {
      a.原料 = index;
      let s = allInvestmentCashFlowCalculation(a);
      if (Math.abs(s) < ljd) {
        ljd = Math.abs(s);
        临界点 = Number(index.toFixed(4));
      }
    }
    let 正常年 = projectData.基础数据.normalYear;
    let 临界值 = `${(
      projectData.成本费用.经营成本.year[正常年 - 1] *
      (1 + 临界点)
    ).toFixed(2)}万元 `;

    // 返回计算结果
    return {
      指标名称: "经营成本",
      收益率: 收益率,
      临界点: 临界点,
      // 临界值名称：用于在表格中显示具体产品/材料名称
      临界值名称: 产品名称,
      // 临界值：用于显示临界数量，后续会添加具体数值
      临界值,
    };
  },

  建投f(projectData, fdarr) {
    let a = { 产品: 0, 原料: 0, 原料率: 1, 建投: 0 };
    let 产品名称 = "建设投资";

    let 收益率 = [];
    fdarr.forEach((res) => {
      a.建投 = res;
      let v = allInvestmentCashFlowCalculation(a);
      收益率.push(v);
    });

    // 改进的临界点查找逻辑
    let 临界点 = 0;
    let ljd = 10000;

    // 先找到收益率最接近0的点作为起点
    let 起点 = 0;
    let 最小差值 = 10000;
    for (let i = 0; i < fdarr.length; i++) {
      a.建投 = fdarr[i];
      let s = allInvestmentCashFlowCalculation(a);
      let 差值 = Math.abs(s);
      if (差值 < 最小差值) {
        最小差值 = 差值;
        起点 = fdarr[i];
      }
    }

    // 在起点附近进行精细搜索
    const 搜索范围 = 10;
    const 搜索步长 = 0.001;

    for (
      let index = Math.max(0, 起点 - 搜索范围);
      index <= Math.min(100, 起点 + 搜索范围);
      index += 搜索步长
    ) {
      a.建投 = index;
      let s = allInvestmentCashFlowCalculation(a);
      if (Math.abs(s) < ljd) {
        ljd = Math.abs(s);
        临界点 = Number(index.toFixed(4));
      }
    }
    let 临界值 = `${(
      projectData.总投资估算.总表.建设投资.合计 *
      (1 + 临界点)
    ).toFixed(2)}/万元 `;

    // 返回计算结果
    return {
      指标名称: "建设投资",
      收益率: 收益率,
      临界点: 临界点,
      // 临界值名称：用于在表格中显示具体产品/材料名称
      临界值名称: 产品名称,
      // 临界值：用于显示临界数量，后续会添加具体数值
      临界值,
    };
  },
  动力f(projectData, fdarr) {
    let a = { 产品: 0, 原料: 0, 原料率: 1, 建投: 0 };
    let 产品名称 = "燃料动力";

    let 经营成本 = projectData.成本费用.经营成本.total;
    let 燃料动力 = projectData.成本费用.燃料动力.total.total;
    let 原料率 = 燃料动力 / 经营成本;
    // console.log("原料率:", 原料率);

    a.原料率 = 原料率;

    let 收益率 = [];
    fdarr.forEach((res) => {
      a.原料 = res;
      let v = allInvestmentCashFlowCalculation(a);
      收益率.push(v);
    });

    // 改进的临界点查找逻辑
    let 临界点 = 0;
    let ljd = 10000;

    // 先找到收益率最接近0的点作为起点
    let 起点 = 0;
    let 最小差值 = 10000;
    for (let i = 0; i < fdarr.length; i++) {
      a.原料 = fdarr[i];
      let s = allInvestmentCashFlowCalculation(a);
      let 差值 = Math.abs(s);
      if (差值 < 最小差值) {
        最小差值 = 差值;
        起点 = fdarr[i];
      }
    }

    // 在起点附近进行精细搜索
    const 搜索范围 = 10;
    const 搜索步长 = 0.001;

    for (
      let index = Math.max(0, 起点 - 搜索范围);
      index <= Math.min(100, 起点 + 搜索范围);
      index += 搜索步长
    ) {
      a.原料 = index;
      let s = allInvestmentCashFlowCalculation(a);
      if (Math.abs(s) < ljd) {
        ljd = Math.abs(s);
        临界点 = Number(index.toFixed(4));
      }
    }

    let 临界值 = `${(
      projectData.成本费用.燃料动力.fuelpower[
        projectData.成本费用.燃料动力.fuelpower.length - 1
      ].unitPrice *
      (1 + 临界点)
    ).toFixed(2)}/${
      projectData.成本费用.燃料动力.fuelpower[
        projectData.成本费用.燃料动力.fuelpower.length - 1
      ].unit
    }`;
    // 返回计算结果
    return {
      指标名称: "燃料动力",
      收益率: 收益率,
      临界点: 临界点,
      // 临界值名称：用于在表格中显示具体产品/材料名称
      临界值名称: 产品名称,
      // 临界值：用于显示临界数量，后续会添加具体数值
      临界值,
    };
  },
};
